/* =========================================================
   LASTU-KONFIGURAATTORI – JS (v0.1, 17.9.2026)

   Rakenne:
     1. alustus, tekstit, lomakekytkös
     2. tila + valintojen logiikka (merkki → malli, materiaali, personointi,
        MagSafe + lisäosat, LEKA), hinta
     3. esikatselu: canvas-kerrokset (materiaali → design → MagSafe → kuori
        → lisäosat), ikkuna-alue luetaan kuorikuvan alfasta
     4. kaiverrusmuunnin: taustanpoisto + kynnys / rasteri / ääriviiva
     5. eleet (siirto, skaalaus, pyöritys) + työkalunapit
     6. mobiili mini/expand, desktop galleriaan
     7. koriin lisäys: YKSI /cart/add.js items[]-pyyntö, Customilyn
        property-nimet, esikatselu-snapshot koridraweriin

   Ei riippuvuuksia. Vika JS:ssä ei estä ostoa: teeman lomake lähettää
   päätuotteen propertyineen ilman tätä tiedostoa.
   ========================================================= */
(function () {
  'use strict';
  var root = document.getElementById('lastu-k');
  if (!root || root.__lastuK) return;
  root.__lastuK = true;

  var S, D;
  try {
    S = JSON.parse(document.getElementById('lastu-k-strings').textContent);
    D = JSON.parse(document.getElementById('lastu-k-data').textContent);
  } catch (e) { console.error('[lastu-k] data', e); return; }

  var DEBUG = /lastudebug=1/.test(location.search);
  var log = function () { if (DEBUG) console.log.apply(console, ['[lastu-k]'].concat([].slice.call(arguments))); };
  var lang = root.getAttribute('data-lang') || 'fi';
  var MODE = root.getAttribute('data-mode') || 'puu', KUWA = MODE === 'kuwa', CAMO = MODE === 'camo';
  /* VELCRO-tuote: camo-runko, Velcro aina päällä hintaan sisältyen (ei riviä, ei lisäosaa, ei pakettietua). */
  var VELCRO = root.hasAttribute('data-velcro');
  /* KARB-LOMPAKKO (29.9.2026): erillinen korttilompakko KARB-tilassa (musta polttomerkkaus), ei puhelinmallia.
     Esikatselu = materiaalin tekstuuri (lompakon kuva 397×593, läpinäkyvä tausta); kaiverrusalue = etutasku. */
  var LOMPAKKO = root.hasAttribute('data-lompakko');
  var LOMPAKKO_MODEL = { name: 'KARB-lompakko', orderName: '', img: '', variantId: null, available: true };
  function lompakkoGeom() {
    var ih = 880, iw = 397 * ih / 593, ix = (1200 - iw) / 2, iy = (960 - ih) / 2;
    return {
      img: { x: ix, y: iy, w: iw, h: ih },
      pocket: { x: ix + iw * 0.075, y: iy + ih * 0.128, w: iw * 0.845, h: ih * 0.78, r: iw * 0.09 },   /* leikkaus: merkki ei valu taskun reunan yli */
      box: { x: ix + iw * 0.12, y: iy + ih * 0.18, w: iw * 0.76, h: ih * 0.68 }                     /* kaiverrusalue + tuotanto-PNG:n koordinaatisto */
    };
  }
  var SANAT = MODE === 'sanat';
  var KARTTA_MODE = MODE === 'kartta';
  /* Kartta on joko oma tuote (MODE) tai puukuoren personointi (+7 €) → KARTTA() kertoo onko kartta juuri nyt käytössä. */
  var KARTTA_ADDON = !!(D.consts && D.consts.karttaAddon);
  function KARTTA() { return KARTTA_MODE || (KARTTA_ADDON && st.persona === 'kartta'); }
  /* Camo-merkki ja puurinkula: MagSafe-renkaan sisäreuna on 479–719 × 373–613
     (halkaisija 241, keskipiste 599,493). Merkki piirretään 262 px:nä hieman
     renkaan alle, jotta kangasta ei näy merkin ja renkaan välistä. */
  var RING_D = 262, BADGE = { x: 599, y: 493 };
  var currency = root.getAttribute('data-currency') || 'EUR';
  var basePrice = parseInt(root.getAttribute('data-base-price'), 10) || 0;
  var $ = function (sel, ctx) { return (ctx || root).querySelector(sel); };
  var $$ = function (sel, ctx) { return [].slice.call((ctx || root).querySelectorAll(sel)); };

  /* Tilakohtaiset tekstit: KARB = polttomerkkaus (mustana) */
  if (CAMO) { S.engraving_row = S.camo_engraving_row; S.engraving_browse = S.camo_engraving_browse; S.engraving_note = S.camo_engraving_note; S.print_row = S.camo_print_row; S.upload_note = S.camo_print_note; S.removebg = S.camo_removebg; S.ins_s3 = S.ins_s3_camo || S.ins_s3; S.band_personalize = S.camo_band; }
  if (CAMO) { S.sum_engraving = S.camo_sum_engraving || S.sum_engraving; S.sum_upload = S.camo_sum_upload || S.sum_upload; }
  if (MODE === 'kuksa') { S.sum_upload = S.kuksa_sum_upload || S.sum_upload; S.upload_row = S.kuksa_upload_row || S.upload_row; S.upload_note = S.kuksa_upload_note || S.upload_note; S.text_hint = S.kuksa_text_hint || S.text_hint; S.conv_note = S.kuksa_conv_note || S.conv_note; }
  if (MODE === 'karb') { S.sum_upload = S.karb_sum_upload || S.sum_upload; S.sum_text = S.karb_sum_text || S.sum_text; S.upload_row = S.karb_upload_row || S.upload_row; S.text_row = S.karb_text_row || S.text_row; S.conv_note = S.karb_conv_note || S.conv_note; S.text_hint = S.karb_text_hint || S.text_hint; S.upload_note = S.karb_upload_note || S.upload_note; }
  /* ───────── 1. Tekstit ───────── */
  $$('[data-s]').forEach(function (el) {
    var k = el.getAttribute('data-s');
    if (k === 'model') return;
    if (S[k] !== undefined && !el.textContent.trim()) el.textContent = S[k];
  });
  function money(cents) {
    try { return new Intl.NumberFormat(lang === 'en' ? 'en-FI' : 'fi-FI', { style: 'currency', currency: currency }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2) + ' ' + currency; }
  }

  var ta0 = $('[data-text-value]'); if (ta0) ta0.placeholder = S.text_placeholder || '';
  /* ───────── Lomakekytkös ───────── */
  var form = document.getElementById(root.getAttribute('data-form-id')) ||
             document.querySelector('form[is="product-form"][action*="/cart/add"], form.product-form[action*="/cart/add"]');
  if (form) {
    $$('[form]').forEach(function (el) { el.setAttribute('form', form.id); });
  }
  function submitButton() {
    if (!form) return null;
    return document.querySelector('button[type="submit"][name="add"][form="' + form.id + '"]') || form.querySelector('button[type="submit"][name="add"]');
  }

  { var cardsEl = $('#lastu-k-engravings'); if (cardsEl) { var sh = document.createElement('p'); sh.className = 'lastu-k__scroll-hint'; sh.textContent = lang === 'en' ? 'scroll sideways' : 'vieritä sivuttain'; cardsEl.parentNode.insertBefore(sh, cardsEl); } }
  /* 2.10.2026: swipe-vihje kaiverrus-/merkkikarusellin päälle – kerran per sivulataus, kun karuselli tulee näkyviin
     ja siinä on vieritettävää. Sormi liukuu oikealta vasemmalle + karuselli nytkähtää ~1 kortin verran ja palaa.
     Asiakkaan kosketus/rulla keskeyttää heti. Ei prefers-reduced-motionilla. */
  (function () {
    var el = $('#lastu-k-engravings'); if (!el || !window.IntersectionObserver) return;
    var done = false, tms = [], hint = null;
    function stop() { tms.forEach(clearTimeout); tms = []; if (hint) { hint.remove(); hint = null; } }
    function play() {
      if (done) return;
      if (el.scrollWidth - el.clientWidth < 24 || !el.offsetParent || el.scrollLeft > 4) return;
      done = true; io.disconnect();
      try { if (matchMedia('(prefers-reduced-motion: reduce)').matches) return; } catch (e) {}
      var host = el.parentNode; host.classList.add('lastu-k__swipe-host');
      hint = document.createElement('span'); hint.className = 'lastu-k__swipe'; hint.setAttribute('aria-hidden', 'true');
      hint.style.top = (el.offsetTop + el.offsetHeight * 0.38) + 'px';
      host.appendChild(hint);
      var nudge = Math.min(90, el.scrollWidth - el.clientWidth);
      tms.push(setTimeout(function () { el.scrollTo({ left: nudge, behavior: 'smooth' }); }, 350));
      tms.push(setTimeout(function () { el.scrollTo({ left: 0, behavior: 'smooth' }); }, 1150));
      tms.push(setTimeout(stop, 1900));
    }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting && e.intersectionRatio > 0.6) setTimeout(play, 300); }); }, { threshold: [0.6] });
    io.observe(el);
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (t) { el.addEventListener(t, function () { if (!done) { done = true; io.disconnect(); } stop(); }, { passive: true }); });
  })();
  /* ───────── 2. Tila ───────── */
  var st = {
    brand: -1, model: -1, material: -1, persona: null, engraving: -1,
    upload: null,   // MUOKATTAVA kaiverruskuva (yksi st.uploadsista): { img, mask:{w,h,data}, name, tf:{x,y,s,r}, mode, detail, dark, invert, hasAlpha, bgMask }
    uploads: [],    // kaikki kaiverruskuvat, 1–3 kpl (23.9.2026), jokainen oma kerros omilla asetuksillaan
    print: null,    // { img, name, tf, removeBg, cut(canvas) }
    magsafe: false, addons: {}, leka: false, lekaCount: 0,
    text: { on: false, font: (MODE === 'puu' || MODE === 'kuksa') ? 'brush' : 'hand', align: 'center', items: [{ value: '', tf: null, maskCanvas: null, isText: true }] },   /* 29.9.2026: 1–8 tekstiä, yhteinen fontti + tasaus */
    kartta: { q: '', place: '', center: null, zoom: 14.5, style: 'city', text: '', mode: 'none', font: 'poster', size: 'm', pin: false, map: null, ready: false, tf: null, textCanvas: null },   /* KARTTA() */
    words: { list: [], font: 'brush', seed: 1, density: 50, maskCanvas: null, tf: { x: 0.5, y: 0.5, s: 1, r: 0 }, key: '' },   /* SANAT */
    images: []   /* KUWA: [{ file, img, imageData, bg, hasAlpha, canvas, tf, round, removeBg, cutCanvas, row }] */
  };
  var upsellId = '_lastu-id-' + (window.crypto && crypto.randomUUID ? crypto.randomUUID() : (Date.now().toString(36) + Math.random().toString(36).slice(2)));
  var hiddenUpsell = $('[data-hidden="upsell"]');
  if (hiddenUpsell) { hiddenUpsell.value = upsellId; hiddenUpsell.disabled = false; }

  var statusEls = {};
  $$('[data-status]').forEach(function (el) { statusEls[el.getAttribute('data-status')] = el; });
  function setStatus(key, val) {
    var el = statusEls[key]; if (!el) return;
    if (val) { el.textContent = val; el.classList.add('is-set'); }
    else { el.textContent = S.choose; el.classList.remove('is-set'); }
  }
  var errorEl = $('#lastu-k-error'), errorHome = errorEl && errorEl.parentNode, errorNext = errorEl && errorEl.nextSibling;
  /* 9.10.2026 UX: virhe näytetään PUUTTUVAN vaiheen kohdalla (ennen se oli konfiguraattorin alalaidassa, mutta sivu
     vieritti ylös vaiheeseen → asiakas ei nähnyt viestiä). Vaihe korostetaan; viesti poistuu kun asia korjataan. */
  function showError(msg, focusEl) {
    if (!errorEl) return;
    $$('.lastu-k-invalid').forEach(function (x) { x.classList.remove('lastu-k-invalid'); });
    if (!msg) { errorEl.hidden = true; errorEl.textContent = ''; return; }
    errorEl.textContent = msg; errorEl.hidden = false;
    var host = focusEl && (focusEl.closest('fieldset, .lastu-k__row') || focusEl);
    if (host && host.offsetParent !== null) { host.classList.add('lastu-k-invalid'); host.appendChild(errorEl); }
    else if (errorHome && errorEl.parentNode !== errorHome) errorHome.insertBefore(errorEl, errorNext && errorNext.parentNode === errorHome ? errorNext : null);
    if (focusEl && focusEl.scrollIntoView) (host && host.offsetParent !== null ? host : focusEl).scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  /* Merkki → malli */
  var modelTitle = $('#lastu-k-model-title');
  var modelWraps = $$('.lastu-k__select-wrap');
  /* 26.9.2026 Hengittävä hehku: ohjaa katseen seuraavaan kohtaan (malli / esikatselu). Kerran per sivu. */
  var breathed = {};
  function breathe(el, key) {
    if (!el || breathed[key]) return; breathed[key] = true;
    el.classList.remove('is-breathe'); void el.offsetWidth; el.classList.add('is-breathe');
    var stop = function () { el.classList.remove('is-breathe'); };
    el.addEventListener('animationend', stop, { once: true });
    ['pointerdown', 'focusin', 'change'].forEach(function (ev) { el.addEventListener(ev, stop, { once: true }); });
  }
  var modelSelects = $$('.lastu-k__select');
  function setModelTitle() {
    var b = D.brands[st.brand];
    modelTitle.textContent = b ? S.model.replace('{brand}', b.key) : (S.model_placeholder + ':');
  }
  setModelTitle();
  /* Merkkilogokaiverrukset: näytetään vain valitun puhelinmerkin oma logo (järjestys ennallaan,
     logot listan lopussa). Ilman merkkiä logoja ei näytetä lainkaan. */
  var LOGO_BRAND = [[/apple/i, /iphone|apple/i], [/samsung/i, /samsung|galaxy/i], [/google|pixel/i, /pixel|google/i], [/oneplus/i, /oneplus/i], [/realme/i, /realme/i], [/nothing/i, /nothing/i]];
  function syncBrandLogos() {
    var b = D.brands && st.brand >= 0 ? D.brands[st.brand] : null, bn = b ? (b.name + ' ' + (b.key || '')) : '';
    $$('input[data-engraving-index]').forEach(function (inp) {
      var e = D.engravings[+inp.getAttribute('data-engraving-index')]; if (!e || !/logo/i.test(e.name)) return;
      var rule = LOGO_BRAND.filter(function (r) { return r[0].test(e.name); })[0];
      var show = !!(rule && bn && rule[1].test(bn));
      var card = inp.closest('.lastu-k__card'); if (card) card.hidden = !show;
      if (!show && inp.checked) { inp.checked = false; if (st.engraving === +inp.getAttribute('data-engraving-index')) { st.engraving = -1; setStatus('engraving', null); render(); } }
    });
  }
  syncBrandLogos();
  $$('input[data-brand-index]').forEach(function (r) {
    r.addEventListener('change', function () {
      setTimeout(function () { var w = modelWraps.filter(function (x) { return !x.hidden; })[0], sl = w && w.querySelector('select'); if (w && sl && !sl.value) breathe(w, 'model'); }, 120);
      if (!r.checked) return;
      st.brand = +r.getAttribute('data-brand-index'); st.model = -1; syncLekaCurved();
      modelWraps.forEach(function (w) { w.hidden = +w.getAttribute('data-brand-index') !== st.brand; });
      modelSelects.forEach(function (s) {
        var mine = +s.getAttribute('data-brand-index') === st.brand;
        s.disabled = !mine; if (!mine) s.value = '';
      });
      setModelTitle(); setStatus('brand', D.brands[st.brand].name); setStatus('model', null); syncBrandLogos();
      if (!document.documentElement.classList.contains('lastu-k-started')) {
        document.documentElement.classList.add('lastu-k-started'); placeStage(); syncDock(); kCascade();
        dropLeaves();   /* minikortti ilmestyy ensimmäisen kerran */
      }
      showError(null); render();
      var sel = modelSelects[st.brand]; if (sel && !isMobile()) { try { sel.focus({ preventScroll: true }); } catch (e) {} }
    });
  });
  modelSelects.forEach(function (s) {
    s.addEventListener('change', function () {
      var opt = s.options[s.selectedIndex];
      st.model = opt && opt.value ? +opt.getAttribute('data-index') : -1;
      var m = currentModel();
      setStatus('model', m ? m.name : null); syncLekaCurved(); showError(null); render();
    });
  });
  function currentBrand() { return D.brands[st.brand] || null; }
  function currentModel() { if (LOMPAKKO) return LOMPAKKO_MODEL; var b = currentBrand(); return b && st.model >= 0 ? b.models[st.model] : null; }
  function currentMaterial() { return D.materials[st.material] || null; }

  /* Materiaali */
  $$('input[data-material-index]').forEach(function (r) {
    r.addEventListener('change', function () {
      if (!r.checked) return;
      st.material = +r.getAttribute('data-material-index');
      onMaterialChange();
    });
    if (r.checked) st.material = +r.getAttribute('data-material-index');
  });
  var printToggle = $('input[data-persona="print"]');
  var printUnavailable = $('[data-print-unavailable]');
  if (D.consts.printPaused && printToggle) { printToggle.disabled = true; printToggle.checked = false; if (printUnavailable) { printUnavailable.hidden = false; printUnavailable.textContent = S.print_paused || ''; } }
  function onMaterialChange() {
    var m = currentMaterial();
    setStatus('material', m ? m.name : null);
    if (m) {
      root.style.setProperty('--k-mat-bg', 'url("' + m.texture + '")');
      root.style.setProperty('--k-mat-color', m.color);
      var ok = m.colorPrint !== false && !D.consts.printPaused;   /* printPaused: väritulostin huollossa → pois kaikilta */
      if (printToggle) {
        printToggle.disabled = !ok; if (printUnavailable) { printUnavailable.hidden = ok; printUnavailable.textContent = D.consts.printPaused ? (S.print_paused || S.print_unavailable) : S.print_unavailable; }
        if (!ok && printToggle.checked) { printToggle.checked = false; setPersona(null); }
      }
    }
    if (KARTTA()) karttaRestyle();
    render();
    /* Materiaalin vaihto voi vaihtaa piirroksen tyylin (pos/neg) → haetaan puuttuva versio. */
    st.uploads.forEach(function (u) { if (u.mode === 'ai' && !hasAi(u)) { convert(u); render(); aiSketch(u, 'edge'); } });
  }

  /* Personointi: kolme toisensa poissulkevaa riviä */
  var personaInputs = $$('input[data-persona]');
  function rowOf(input) { return input.closest('.lastu-k__row'); }
  /* ───────── Avautuvat lohkot (1.10.2026) ─────────
     Applen tyyliin hillitty liuku: lohko avautuu valintarivin ALTA (korkeus 0 → oma, sisältö liukuu 10 px alhaalta
     ja häivyttyy esiin), sulkeutuu takaisin rivin alle ja vasta sitten piiloon. Ilman animaatiota: muistista
     palautus, käynnistys, "vähennä liikettä" ja vanhat selaimet (ei Element.animate). */
  var K_EASE_OUT = 'cubic-bezier(.32,.72,0,1)', K_EASE_IN = 'cubic-bezier(.4,0,.6,1)', kAnimReady = false;
  function kMotionOk() { try { return kAnimReady && !memRestoring && !!document.body.animate && !(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches); } catch (e) { return false; } }
  /* FLIP (1.10.2026): asettelu muutetaan KERRAN lopulliseksi, sitten alla olevat osat liukuvat vanhasta paikasta
     uuteen pelkällä transformilla ja avautuva lohko paljastetaan clip-pathilla samassa tahdissa. Ei asettelun
     uudelleenlaskentaa joka ruudussa → sulava myös hitailla puhelimilla. Sulkeutuva lohko irrotetaan virrasta
     (position:absolute) animaation ajaksi. Saman tickin muutokset (esim. persona: yksi auki, muut kiinni) yhtenä FLIPinä. */
  var K_OPEN_MS = 700, K_CLOSE_MS = 480, kPend = [], kPendQ = false, kFolAnims = [];
  /* Keskeytys (esim. nopea uusi klikkaus): lopputila HETI synkronisesti – WAAPI:n onfinish tulisi vasta myöhemmin. */
  function kFinishEl(el) { if (!el) return; var a = el.__kAnims, d = el.__kDone; el.__kAnims = null; el.__kDone = null; if (a) a.forEach(function (x) { try { x.cancel(); } catch (e) {} }); if (d) d(); }
  function kReveal(el, on, opts) {
    if (!el) return;
    opts = opts || {};
    if (!kMotionOk() || opts.instant) { kFinishEl(el); el.hidden = !on; return; }
    kPend.push({ el: el, on: !!on, opts: opts });
    if (!kPendQ) { kPendQ = true; Promise.resolve().then(kFlush); }
  }
  function kFlush() {
    kPendQ = false;
    var raw = kPend.splice(0), changes = [];
    raw.forEach(function (c) { changes = changes.filter(function (x) { return x.el !== c.el; }); changes.push(c); });
    changes.forEach(function (c) { kFinishEl(c.el); });
    kFolAnims.forEach(function (a) { try { a.finish(); } catch (e) {} }); kFolAnims = [];
    changes = changes.filter(function (c) { return c.on ? c.el.hidden : !c.el.hidden; });
    if (!changes.length) return;
    var host = document.getElementById('lastu-k'), root = (host && host.closest('.shopify-section')) || document.body;
    var changing = changes.map(function (c) { return c.el; }), fol = [];
    changes.forEach(function (c) {
      var n = c.el;
      while (n && n !== root && n !== document.body) {
        for (var s = n.nextElementSibling; s; s = s.nextElementSibling) if (fol.indexOf(s) < 0 && changing.indexOf(s) < 0) fol.push(s);
        n = n.parentElement;
      }
    });
    fol = fol.filter(function (f) { return !fol.some(function (g) { return g !== f && g.contains(f); }) && !changing.some(function (c) { return c.contains(f); }); });
    var vh = window.innerHeight, first = [];
    fol.forEach(function (f) {
      if (f.hidden) return;
      var cs = getComputedStyle(f); if (cs.display === 'none' || cs.position === 'fixed' || cs.position === 'sticky') return;
      var r = f.getBoundingClientRect(); first.push([f, r.top, r.bottom]);
    });
    changes.forEach(function (c) { if (!c.on) { c.t = c.el.offsetTop; c.l = c.el.offsetLeft; c.w = c.el.offsetWidth; } });
    /* APPLY: lopullinen asettelu kerralla */
    changes.forEach(function (c) {
      if (c.on) { c.el.hidden = false; return; }
      var st2 = c.el.style; st2.position = 'absolute'; st2.top = c.t + 'px'; st2.left = c.l + 'px'; st2.width = c.w + 'px'; st2.margin = '0'; st2.zIndex = '0'; c.el.__kClosing = true;
    });
    var opening = changes.some(function (c) { return c.on; }), dur = opening ? K_OPEN_MS : K_CLOSE_MS, ease = K_EASE_OUT;
    /* LAST + INVERT + PLAY: vain näkyvissä olevat siirtyvät (muut napsahtavat näkymättömissä) */
    first.forEach(function (x) {
      var f = x[0], r = f.getBoundingClientRect(), d = x[1] - r.top;
      if (Math.abs(d) < 0.5) return;
      if (Math.min(x[1], r.top) > vh + 40 || Math.max(x[2], r.bottom) < -40) return;
      kFolAnims.push(f.animate([{ transform: 'translateY(' + d.toFixed(1) + 'px)' }, { transform: 'translateY(0)' }], { duration: dur, easing: ease }));
    });
    changes.forEach(function (c) {
      var el = c.el;
      if (c.on) {
        el.__kAnims = [el.animate([
          { clipPath: 'inset(0 0 100% 0)', opacity: 0, transform: 'translateY(-8px)' },
          { clipPath: 'inset(0 0 35% 0)', opacity: 1, transform: 'translateY(-2px)', offset: .55 },
          { clipPath: 'inset(0 0 0% 0)', opacity: 1, transform: 'translateY(0)' }
        ], { duration: dur, easing: ease })];
        el.__kDone = function () { el.__kAnims = null; };
        el.__kAnims[0].onfinish = function () { if (el.__kDone) { el.__kDone(); el.__kDone = null; if (!c.opts.noScroll) kRevealScroll(el); } };
      } else {
        var a = el.animate([{ clipPath: 'inset(0 0 0% 0)', opacity: 1 }, { clipPath: 'inset(0 0 100% 0)', opacity: 0 }], { duration: dur, easing: ease, fill: 'forwards' });
        el.__kAnims = [a];
        el.__kDone = function () {
          el.hidden = true; el.__kClosing = false; el.__kAnims = null;
          var st3 = el.style; st3.position = st3.top = st3.left = st3.width = st3.margin = st3.zIndex = '';
          try { a.cancel(); } catch (e) {}
        };
        a.onfinish = function () { if (el.__kDone) { var d = el.__kDone; el.__kDone = null; d(); } };
      }
    });
  }
  /* Avautunut lohko jää näytön alareunan alle → vieritä pehmeästi niin, että sen alku näkyy (ei hyppyä). */
  function kRevealScroll(el) {
    try {
      var r = el.getBoundingClientRect(), vh = window.innerHeight, pad = isMobile() ? 120 : 40;
      if (r.top > vh - pad - 60) window.scrollBy({ top: Math.min(r.top - vh * 0.45, r.top - 80), behavior: 'smooth' });
    } catch (e) {}
  }
  /* Ensimmäinen merkin valinta: seuraavat askeleet tulevat esiin merkkivalinnan alta porrastetusti ylhäältä alas. */
  function kCascade() {
    if (!kMotionOk()) return;
    var panel = $('.lastu-k__panel'); if (!panel) return;
    var brand = $('#lastu-k-step-brand'), items = [], after = false;
    [].slice.call(panel.children).forEach(function (c) {
      if (c === brand) { after = true; return; }
      if (after && !c.hidden && c.offsetParent !== null) items.push(c);
    });
    items.slice(0, 14).forEach(function (c, i) {
      c.animate([{ opacity: 0, transform: 'translateY(-14px)' }, { opacity: 1, transform: 'translateY(0)' }],
        { duration: 620, delay: 80 + i * 55, easing: K_EASE_OUT, fill: 'backwards' });
    });
  }
  function setPersona(which) {
    st.persona = which;
    personaInputs.forEach(function (inp) {
      var on = inp.getAttribute('data-persona') === which;
      if (inp.checked !== on) inp.checked = on;
      var row = rowOf(inp), reveal = row && row.querySelector('.lastu-k__reveal');
      if (reveal) kReveal(reveal, on);
      /* Yksi personointitapa kerrallaan: muut kaksi riviä piiloon kun yksi on valittu. */
      /* data-row-off = rivi ei kuulu tähän tuotetyyppiin (esim. kaiverrus camossa) → pysyy aina piilossa. */
      if (row) { if (row.hasAttribute('data-row-off')) row.hidden = true; else kReveal(row, !(!!which && !on), { noScroll: true }); }
      $$('input[data-engraving-index]', row).forEach(function (r) { r.disabled = !on || r.hasAttribute('data-soldout'); if (!on) r.checked = false; });
      $$('input[data-removebg],input[data-upload-removebg],input[data-round]', row).forEach(function (r) { r.disabled = !on; if (!on) r.checked = false; });
      $$('[data-round-panel]', row).forEach(function (pn) { if (!on) pn.hidden = true; });
    });
    if (which !== 'engraving') { st.engraving = -1; setStatus('engraving', null); }
    if (which === 'upload' && st.upload) selectUpload(st.upload);
    /* Ensimmäinen kaiverrus esivalittuna (camo: esim. Leijona Vaakuna; 9.10.2026 käyttäjä: myös puukuoret, esim. Muodot).
       Ohitetaan loppuunmyydyt ja tälle merkille piilotetut (merkkilogot) kortit. */
    if (which === 'engraving' && st.engraving < 0) { var first = $$('input[data-engraving-index]:not([data-soldout])').filter(function (i) { var c = i.closest('.lastu-k__card'); return !(c && c.hidden); })[0]; if (first) { first.checked = true; st.engraving = +first.getAttribute('data-engraving-index'); setStatus('engraving', D.engravings[st.engraving].name); } }
    /* Velcro sulkee MagSafen pois: rivi piiloon ja valinta pois. */
    var msRow = magsafeInput && rowOf(magsafeInput);
    if (msRow) { msRow.hidden = which === 'velcro' || msRow.hasAttribute('data-row-off'); if (which === 'velcro' && magsafeInput.checked) { magsafeInput.checked = false; setMagsafe(false); } }
    if (KARTTA_ADDON) karttaPersonaSync(which === 'kartta');
    showError(null); updatePrice(); render();
  }
  /* Personointina valittu kartta: MapLibre ladataan vasta nyt (LCP), stage saa kartta-luokan ja
     kartta piilotetaan kun asiakas vaihtaa toiseen personointiin. */
  var maplibrePromise = null;
  function loadMapLibre() {
    if (window.maplibregl) return Promise.resolve();
    if (maplibrePromise) return maplibrePromise;
    maplibrePromise = new Promise(function (res, rej) {
      var css = document.createElement('link'); css.rel = 'stylesheet'; css.href = D.consts.maplibreCss; document.head.appendChild(css);
      var sc = document.createElement('script'); sc.src = D.consts.maplibreJs; sc.async = true;
      sc.onload = function () { res(); }; sc.onerror = function () { maplibrePromise = null; rej(new Error('maplibre')); };
      document.head.appendChild(sc);
    });
    return maplibrePromise;
  }
  function karttaPersonaSync(on) {
    if (stage) stage.classList.toggle('lastu-k__stage--kartta', !!on);
    /* Kartta täyttää koko takakannen → tekstikaiverrus ei mahdu mukaan: rivi piiloon ja valinta pois. */
    if (typeof textInput !== 'undefined' && textInput) {
      var tRow = rowOf(textInput);
      if (on && textInput.checked) { textInput.checked = false; setText(false); }
      if (tRow) tRow.hidden = !!on || tRow.hasAttribute('data-row-off');
    }
    if (karttaEl) karttaEl.hidden = !on;
    var zb = document.getElementById('lastu-k-map-zoom'); if (zb) zb.hidden = !on || !st.kartta.center;
    if (on) loadMapLibre().then(function () { karttaLastGeom = ''; render(); }, function () { showError(S.kartta_nomap); });
    else karttaLastGeom = '';
  }
  personaInputs.forEach(function (inp) {
    inp.addEventListener('change', function () { setPersona(inp.checked ? inp.getAttribute('data-persona') : null); });
  });
  $$('input[data-engraving-index]').forEach(function (r) {
    r.addEventListener('change', function () {
      if (!r.checked) return;
      st.engraving = +r.getAttribute('data-engraving-index');
      setStatus('engraving', D.engravings[st.engraving].name); showError(null); render();
    });
  });

  /* MagSafe + lisäosat */
  var magsafeInput = $('input[data-magsafe]');
  var addonInputs = $$('input[data-addon-index]');
  function setMagsafe(on) {
    st.magsafe = on;
    if (on && !memRestoring) msGlow(); else if (!on) msStop(true);
    if (on && kMotionOk()) setTimeout(function () {                 /* lisäosarivit erottuvat: 2 keltaista hengitystä, kun lohko on auki */
      if (!st.magsafe) return;
      $$('.lastu-k__row--addon').forEach(function (r, i) {
        if (r.hidden || r.offsetParent === null) return;
        setTimeout(function () {
          r.classList.remove('is-glow'); void r.offsetWidth; r.classList.add('is-glow');
          var face = r.querySelector('.lastu-k__toggle-face'), stop = function () { r.classList.remove('is-glow'); };
          if (face) face.addEventListener('animationend', function (e) { if (e.animationName === 'lastuKBreathe') stop(); });
          r.addEventListener('pointerdown', stop, { once: true });
        }, i * 140);
      });
    }, K_OPEN_MS + 60);
    var reveal = rowOf(magsafeInput).querySelector('.lastu-k__reveal'); if (reveal) kReveal(reveal, on);
    addonInputs.forEach(function (a) {
      a.disabled = !on || a.hasAttribute('data-soldout');
      if (!on) { a.checked = false; }
    });
    if (!on) { st.addons = {}; if (K.on) kripUnselect(); if (KW.on) karbUnselect(); }
    else if (KA && KRIP_I >= 0) kripLoad();
    updatePrice(); render();
  }
  if (magsafeInput) magsafeInput.addEventListener('change', function () { setMagsafe(magsafeInput.checked); });
  addonInputs.forEach(function (a) {
    a.addEventListener('change', function () {
      var i = +a.getAttribute('data-addon-index');
      var type = D.addons[i].type;
      if (a.checked && type) {
        /* Yksi per tyyppi (esim. vain yksi KARB-väri) */
        addonInputs.forEach(function (o) {
          var j = +o.getAttribute('data-addon-index');
          if (o !== a && D.addons[j].type === type && o.checked) { o.checked = false; delete st.addons[j]; }
        });
      }
      if (a.checked) st.addons[i] = true; else delete st.addons[i];
      if (i === KRIP_I) { if (a.checked) kripSelect(!memRestoring); else kripUnselect(); }
      else if (type === 'karb') { if (a.checked) karbSelect(i, !memRestoring); else if (i === KW.idx) karbUnselect(); }
      updatePrice(); render();
    });
  });

  /* ───────── KRIP-animaatio (30.9.2026) ─────────
     Kun asiakas valitsee KRIPin: liukuu vasemmalta irrallaan → napsahtaa magneettiin → kahva avautuu
     (kuvat 1→6) → pyörähtää 360° → jää auki. Painikkeet: Sulje/Avaa KRIP ja Irrota/Kiinnitä KRIP
     (sivuun vain suljettuna). Rengas = yksi kiinteä kuva (kuvan 1 sävy), vain kahva liikkuu.
     Kevyt: 8 × WebP (~85 kB) ladataan vasta kun MagSafe valitaan; oma kerros canvasin päällä, liike
     transformilla ja pienellä kahvakanvaksella – esikatselua ei piirretä uudelleen animaation aikana.
     Jos kuvat eivät lataudu (vanha selain), canvas piirtää KRIPin staattisena kuten ennenkin.
     K.shown = kerros näkyvissä → draw() jättää KRIPin staattisen kuvan pois (snapshot lisää sen). */
  var KRIP_I = -1;
  D.addons.forEach(function (a, i) { if (a.type === 'krip' && KRIP_I < 0) KRIP_I = i; });
  var KA = D.consts.kripAnim || null;
  var K = { imgs: null, ready: false, loadP: null, shown: false, on: false, open: false, parked: false, f: 0, ang: 0, busy: false, raf: 0, staticImg: null, px: 940, token: 0 };
  var K_C = [345.6, 345.4], K_OFF = [470 - 345.6, 470 - 345.4];
  var K_HOME = { x: 0, y: 0, r: 0, s: 1, l: 0 }, K_OUT = { x: -140, y: 4, r: -16, s: 1.14, l: 1 }, K_AIR = { x: 0, y: 0, r: 0, s: 1.14, l: 1 }, K_PARK = { x: -55, y: 0, r: -8, s: 1, l: 0.45 };
  /* KARB vie vasemman reunan → KRIP odottaa silloin oikealla (puhelimen sivukuvan päällä, mahtuu kehykseen) */
  var K_PARK_R = { x: 64.4, y: 14.9, r: 8, s: 1, l: 0.45 };
  function kParkPose() { return KW.on ? K_PARK_R : K_PARK; }
  var kwEl = null, kwNext = null, kBtnKarb = null, kLayer = null, kEl = null, kRing = null, kRingFull = null, kCv = null, kCtx = null, kRipple = null, kBtns = null, kBtnOpen = null, kBtnPark = null, kCapEl = null, kPose = K_OUT;
  function kripReduce() { try { return window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; } }
  function kripEls() {
    if (kLayer) return !!kLayer;
    kLayer = document.getElementById('lastu-k-krip-layer'); if (!kLayer) return false;
    kEl = kLayer.querySelector('.lastu-k__krip'); var rs = kLayer.querySelectorAll('.lastu-k__krip-ring'); kRing = rs[0]; kRingFull = rs[1];
    kCv = kLayer.querySelector('canvas'); kCtx = kCv.getContext('2d'); kRipple = kLayer.querySelector('.lastu-k__krip-ripple');
    kBtns = document.getElementById('lastu-k-krip-btns'); kCapEl = document.getElementById('lastu-k-krip-cap');
    kBtnOpen = kBtns.querySelector('[data-krip="open"]'); kBtnPark = kBtns.querySelector('[data-krip="park"]'); kBtnKarb = kBtns.querySelector('[data-krip="karb"]');
    var kws = kLayer.querySelectorAll('.lastu-k__karb'); kwEl = kws[0]; kwNext = kws[1];
    if (kBtnKarb) kBtnKarb.addEventListener('click', function (e) { e.stopPropagation(); karbToggle(); });
    kBtnOpen.addEventListener('click', function (e) { e.stopPropagation(); kripToggleOpen(); });
    kBtnPark.addEventListener('click', function (e) { e.stopPropagation(); kripTogglePark(); });
    ['pointerdown', 'touchstart', 'mousedown'].forEach(function (ev) { kBtns.addEventListener(ev, function (e) { e.stopPropagation(); }, { passive: true }); });
    /* Esikatselun koko muuttuu (mini ↔ iso, kierto) → kahvakanvaksen tarkkuus perässä */
    if (window.ResizeObserver) new ResizeObserver(function () { if (K.shown && K.imgs) { var o = K.px; kripSize(); if (K.px !== o) kripDraw(0); } }).observe(kLayer);
    return true;
  }
  /* Kuvat ladataan kerran; decode() ennen käyttöä → ei nykäisyä ensimmäisessä ruudussa. */
  function kripLoad() {
    if (K.loadP) return K.loadP;
    if (!KA || KRIP_I < 0 || !kripEls() || !kCtx) return (K.loadP = Promise.reject(new Error('krip-anim off')));
    function one(src) { return new Promise(function (res, rej) { var im = new Image(); im.decoding = 'async'; im.onload = function () { (im.decode ? im.decode() : Promise.resolve()).then(function () { res(im); }, function () { res(im); }); }; im.onerror = rej; im.src = src; }); }
    K.loadP = Promise.all([one(KA.ring), one(KA.ringFull)].concat(KA.h.map(one))).then(function (a) {
      kRing.src = a[0].src; kRingFull.src = a[1].src; K.imgs = a.slice(2); K.ready = true;
      loadImage(D.addons[KRIP_I].img).then(function (im) { K.staticImg = im; });
    });
    K.loadP.catch(function (e) { log('krip-anim ei latautunut', e); });
    return K.loadP;
  }
  /* Kanvaksen tarkkuus laitteen mukaan (max 940 px) – pieni minikortti ei piirrä turhaa. */
  function kripSize() {
    var w = kLayer.getBoundingClientRect().width || 600, dpr = Math.min(window.devicePixelRatio || 1, 2.5);
    var px = Math.max(240, Math.min(940, Math.ceil(w * 0.7833 * dpr)));
    if (px !== K.px || kCv.width !== px) { K.px = px; kCv.width = px; kCv.height = px; }
  }
  function kripDraw(omega) {
    if (!K.imgs) return;
    var k = K.px / 940, c = kCtx;
    c.setTransform(1, 0, 0, 1, 0, 0); c.clearRect(0, 0, K.px, K.px);
    function frame(angDeg) {
      var r = angDeg * Math.PI / 180, cs = Math.cos(r), sn = Math.sin(r);
      c.setTransform(cs * k, sn * k, -sn * k, cs * k, (K_C[0] - cs * K_C[0] + sn * K_C[1] + K_OFF[0]) * k, (K_C[1] - sn * K_C[0] - cs * K_C[1] + K_OFF[1]) * k);
      var i = Math.min(4, Math.floor(K.f)), t = K.f - i; if (K.f >= 5) { i = 4; t = 1; }
      if (t < 0.002) { c.globalAlpha = 1; c.drawImage(K.imgs[i], 0, 0); return; }
      if (t > 0.998) { c.globalAlpha = 1; c.drawImage(K.imgs[i + 1], 0, 0); return; }
      c.globalAlpha = 1; c.drawImage(K.imgs[i], 0, 0);          /* edellinen täysin, seuraava päälle → ei läpikuultavuuskuoppaa */
      c.globalAlpha = t; c.drawImage(K.imgs[i + 1], 0, 0);
    }
    if (omega && Math.abs(omega) > 1.2) {                          /* pyörähdyksen vana nopeimmassa kohdassa */
      var tr = Math.min(12, Math.abs(omega) * 1.4) * (omega > 0 ? 1 : -1);
      frame(K.ang - tr); frame(K.ang - tr / 2);
      c.setTransform(1, 0, 0, 1, 0, 0); c.globalAlpha = 0.45; c.globalCompositeOperation = 'destination-in'; c.fillRect(0, 0, K.px, K.px); c.globalCompositeOperation = 'source-over';
    }
    frame(K.ang);
    c.globalAlpha = 1; c.setTransform(1, 0, 0, 1, 0, 0);
  }
  function kripPlace(p) {
    kPose = p;
    var a = accXf();
    kEl.style.transform = (a.s === 1 && !a.dy ? '' : 'translate(' + (a.dx / 6.9).toFixed(3) + '%,' + (a.dy / 6.9).toFixed(3) + '%) scale(' + a.s + ') ') + 'translate(' + p.x.toFixed(2) + '%,' + p.y.toFixed(2) + '%) rotate(' + p.r.toFixed(2) + 'deg) scale(' + p.s.toFixed(4) + ')';
    kEl.style.filter = p.l > 0.01 ? 'drop-shadow(' + (10 * p.l).toFixed(1) + 'px ' + (18 * p.l).toFixed(1) + 'px ' + (16 * p.l).toFixed(1) + 'px rgba(0,26,26,' + (0.33 * p.l).toFixed(3) + '))' : 'none';
  }
  function kLerp(a, b, t) { return { x: a.x + (b.x - a.x) * t, y: a.y + (b.y - a.y) * t, r: a.r + (b.r - a.r) * t, s: a.s + (b.s - a.s) * t, l: a.l + (b.l - a.l) * t }; }
  function kEaseIO(t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
  function kEaseOut(t) { return 1 - Math.pow(1 - t, 3); }
  function kEaseSine(t) { return -(Math.cos(Math.PI * t) - 1) / 2; }
  /* Aikajana: token katkaisee kesken jääneen ketjun (esim. valinta poistetaan kesken animaation). */
  function kTween(ms, step) {
    var tok = K.token;
    return new Promise(function (res, rej) {
      var t0 = 0;
      function tk(now) {
        if (tok !== K.token) { rej('krip-cancel'); return; }
        if (!t0) t0 = now;
        var t = Math.min(1, (now - t0) / ms); step(t);
        if (t < 1) K.raf = requestAnimationFrame(tk); else res();
      }
      K.raf = requestAnimationFrame(tk);
    });
  }
  function kWait(ms) { var tok = K.token; return new Promise(function (res, rej) { setTimeout(function () { tok === K.token ? res() : rej('krip-cancel'); }, ms); }); }
  function kCancel() { K.token++; cancelAnimationFrame(K.raf); }
  /* Mobiilissa teksti peittää kuorta: lepotilan teksti häviää 5 s:n kuluttua eikä tekstejä näytetä sen jälkeen enää (sivukäynnin aikana). */
  var kCapGone = false, kCapTimer = 0;
  function kCap(key) {
    if (!kCapEl) return;
    clearTimeout(kCapTimer);
    if (!key || (kCapGone && isMobile())) { kCapEl.classList.remove('is-on'); return; }
    kCapEl.textContent = S[key] || ''; kCapEl.setAttribute('data-key', key); kCapEl.classList.add('is-on');
    if (isMobile() && (key === 'krip_c_rest' || key === 'krip_c_parked')) kCapTimer = setTimeout(function () { kCapGone = true; kCapEl.classList.remove('is-on'); }, 5000);
  }
  function kLabels() {
    if (!kBtns) return;
    kBtns.hidden = !(K.shown || KW.shown);
    kBtnPark.hidden = !K.shown;
    if (kBtnKarb) { kBtnKarb.hidden = !KW.shown; kBtnKarb.querySelector('span').textContent = KW.attached ? S.karb_detach : S.karb_attach; kBtnKarb.classList.toggle('is-flip', !KW.attached); }
    kBtnOpen.hidden = !K.shown || K.parked;
    kBtnOpen.querySelector('span').textContent = K.open ? S.krip_close : S.krip_open;
    kBtnPark.querySelector('span').textContent = K.parked ? S.krip_attach : S.krip_detach;
    kBtnPark.classList.toggle('is-flip', K.parked);
  }
  function kLock(on) { K.busy = on; if (kBtns) [kBtnOpen, kBtnPark, kBtnKarb].forEach(function (b) { if (!b) return; if (on) b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled'); }); }
  function kShow(on) {
    if (K.shown === on) return;
    K.shown = on; kLayerSync(); kLabels();
    if (!on) { if (!KW.shown) kCap(''); kEl.style.opacity = 0; }
    render();                                                     /* canvas piirtää / jättää staattisen KRIPin */
  }
  function kUnfold(dir) { return kTween(dir > 0 ? 900 : 800, function (t) { var e = kEaseSine(t); K.f = 5 * (dir > 0 ? e : 1 - e); kripDraw(0); }); }
  function kSpin(deg, ms) {
    kRingFull.style.opacity = 1; kRing.style.opacity = 0; var last = 0;
    function done() { K.ang = 0; kripDraw(0); kRingFull.style.opacity = 0; kRing.style.opacity = 1; }
    return kTween(ms, function (t) { var a = deg * kEaseIO(t); K.ang = a; kripDraw(a - last); last = a; }).then(done, function (e) { done(); throw e; });
  }
  function kSnap(to) {
    var from = kPose;
    try { if (navigator.vibrate) navigator.vibrate(12); } catch (e) {}
    try { if (kRipple.animate) kRipple.animate([{ opacity: .9, transform: 'translate(-50%,-50%) scale(.92)' }, { opacity: 0, transform: 'translate(-50%,-50%) scale(1.45)' }], { duration: 420, easing: 'cubic-bezier(.2,.8,.2,1)' }); } catch (e) {}
    return kTween(200, function (q) {
      var p = kLerp(from, to, Math.min(1, q / .55));
      p.s = q < .55 ? from.s - (from.s - to.s * 0.97) * Math.pow(q / .55, 2) : to.s * (0.97 + 0.03 * kEaseOut((q - .55) / .45));
      p.l = Math.max(0, from.l * (1 - q / .55)); kripPlace(p);
    }).then(function () { kripPlace(to); });
  }
  function kGlide(from, to, ms) { return kTween(ms, function (t) { var p = kLerp(from, to, kEaseIO(t)), b = Math.sin(Math.PI * t); p.l = Math.max(p.l, b * 0.9); p.s *= 1 + b * 0.06; kripPlace(p); }); }
  function kStatic(open) {                                        /* ilman animaatiota: kiinni kuoressa */
    if (KW.attached) { KW.attached = false; wPlace(W_SIDE); }
    K.open = open; K.parked = false; K.f = open ? 5 : 0; K.ang = 0; kShow(true); kripSize(); kripDraw(0); kripPlace(K_HOME); kEl.style.opacity = 1; kLabels(); kCap(open ? 'krip_c_rest' : ''); kLock(false);
  }
  function kripSelect(animate) {
    K.on = true;
    kripLoad().then(function () {
      if (!K.on) return;
      kCancel();
      if (!animate || kripReduce() || K.busy) { kStatic(!!animate && !K.busy); return; }   /* KARB-esittely kesken → KRIP suoraan paikalleen */
      K.open = false; K.parked = false; K.f = 0; K.ang = 0; kripPlace(K_OUT); kShow(true); kripSize(); kripDraw(0);
       kLabels(); kLock(true); kEl.style.opacity = 1; kCap('krip_c_fly');
      (KW.attached ? karbDetachSeq() : Promise.resolve())
        .then(function () { kCap('krip_c_fly'); return kTween(650, function (t) { kripPlace(kLerp(K_OUT, K_AIR, kEaseOut(t))); }); })
        .then(function () { kCap('krip_c_snap'); return kSnap(K_HOME); })
        .then(function () { return kWait(150); })
        .then(function () { kCap('krip_c_unfold'); return kUnfold(1); })
        .then(function () { return kWait(120); })
        .then(function () { kCap('krip_c_spin'); return kSpin(360, 1300); })
        .then(function () { K.open = true; kCap('krip_c_rest'); kLabels(); kLock(false); }, function () {});
    }, function () {});
  }
  function kripUnselect() {
    K.on = false;
    if (!K.shown) return;
    kCancel(); kBtns.hidden = true; kCap('');
    if (kripReduce()) { kShow(false); return; }
    var from = kPose, lifted = { x: from.x, y: from.y, r: from.r, s: from.s * 1.14, l: 1 };
    kTween(480, function (q) {
      var lift = Math.min(1, q / .25), p2 = q < .25 ? 0 : Math.pow((q - .25) / .75, 2);
      kripPlace(kLerp(kLerp(from, lifted, lift), K_OUT, p2)); kEl.style.opacity = 1 - Math.max(0, (q - .8) / .2);
    }).then(function () { if (!K.on) kShow(false); }, function () {});
  }
  function kripToggleOpen() {
    if (K.busy || K.parked || !K.shown) return;
    hintDone(); kripSize();
    if (kripReduce()) { K.open = !K.open; K.f = K.open ? 5 : 0; kripDraw(0); kLabels(); kCap(K.open ? 'krip_c_rest' : ''); return; }
    kLock(true);
    var p = K.open
      ? (kCap('krip_c_spin'), kSpin(-360, 1100)).then(function () { kCap('krip_c_fold'); return kUnfold(-1); })
      : (kCap('krip_c_unfold'), kUnfold(1)).then(function () { kCap('krip_c_spin'); return kSpin(360, 1300); });
    p.then(function () { K.open = !K.open; kCap(K.open ? 'krip_c_rest' : ''); kLabels(); kLock(false); }, function () {});
  }
  /* KRIP sivuun (aina suljettuna). quick = vaihto KARBiin: pelkkä taitto ilman pyörähdystä. */
  function kripParkSeq(quick) {
    var pre = !K.open ? Promise.resolve()
      : quick ? (kCap('krip_c_fold'), kUnfold(-1)).then(function () { K.open = false; kLabels(); })
      : (kCap('krip_c_spin'), kSpin(-360, 1100)).then(function () { kCap('krip_c_fold'); return kUnfold(-1); }).then(function () { K.open = false; kLabels(); return kWait(120); });
    return pre.then(function () { kCap('krip_c_parked'); var from = kPose; return kTween(160, function (t) { kripPlace(kLerp(from, K_AIR, kEaseOut(t))); }); })
      .then(function () { return kGlide(K_AIR, kParkPose(), 620); }).then(function () { K.parked = true; kLabels(); });
  }
  /* KRIP kuoreen; jos KARB on kuoressa, se irrotetaan ensin sivuun */
  function kripAttachSeq() {
    var pre = KW.attached ? karbDetachSeq() : Promise.resolve();
    return pre.then(function () { kCap('krip_c_snap'); return kGlide(kPose, K_AIR, 560); }).then(function () { return kSnap(K_HOME); }).then(function () { K.parked = false; kLabels(); });
  }
  function kripTogglePark() {
    if (K.busy || !K.shown) return;
    hintDone(); kripSize();
    if (kripReduce()) { K.parked = !K.parked; if (K.parked) { K.open = false; K.f = 0; kripDraw(0); } else if (KW.attached) { KW.attached = false; wPlace(W_SIDE); } kripPlace(K.parked ? kParkPose() : K_HOME); kLabels(); kCap(K.parked ? 'krip_c_parked' : ''); return; }
    kLock(true);
    (K.parked ? kripAttachSeq() : kripParkSeq(false))
      .then(function () { kCap(K.parked ? 'krip_c_parked' : (K.open ? 'krip_c_rest' : '')); kLabels(); kLock(false); }, function () {});
  }

  /* ───────── KARB-lompakko (1.10.2026) ─────────
     Lompakko on esikatselussa kuoren VIERESSÄ (ei peitä asiakkaan kuvaa). Valittaessa: liukuu sisään → kuoreen
     MagSafe-renkaan kohdalle (napsahdus) → hetki kiinni → takaisin sivuun. Painike Kiinnitä/Irrota KARB.
     Sama MagSafe-paikka kuin KRIPillä: kiinnitys siirtää toisen ensin sivuun. Kuva = lisäosan oma overlay
     (1200×960, lompakko vasemmassa reunassa oikeassa mittakaavassa) → ei uusia kuvia. Siirrot %:na kuvan koosta,
     kuoressa: magneetti on lompakon YLÄOSASSA → lompakon yläreuna 5 mm renkaan yläreunan yläpuolelle, vaakasuunnassa
     keskelle (mittakaava 5,43 px/mm renkaasta Ø 54 mm; lompakko 98 × 66 mm). */
  var KW = { on: false, shown: false, attached: false, idx: -1, staticImg: null };
  var W_OFF = { x: -40, y: 0, s: 1, l: 0 }, W_SIDE = { x: 0, y: 0, s: 1, l: 0 }, wPose = W_SIDE;
  /* Kuoressa: lompakon yläreuna 5 mm (27 px) magneetin yläreunan yläpuolella, MUTTA ei koskaan kameramoduulin päälle:
     vähintään 2 mm (11 px) mallin kamera-alueen alareunan (windowBox.safeY) alapuolella. Lompakon runko alkaa kuvassa y=374. */
  function wOn(air) {
    var m = currentModel(), u = m && m.img, box = u && winCache[u], a = accXf(), top = (ACC_C.y + a.dy) - (146.7 + 27) * a.s;
    if (!a.low && box && box.safeY) top = Math.max(top, box.safeY + 11);   /* Galaxy-perusmalleissa lompakko saa mennä kameran päälle */
    var y = (top - (ACC_K.y - 275.5 * a.s)) / 9.6, x = 33.64 + a.dx / 12;      /* skaalaus lompakon origosta (198,5; 649,5) */
    return air ? { x: x, y: y, s: 1.08, l: 1 } : { x: x, y: y, s: 1, l: 0 };
  }
  function wPlace(p) {
    wPose = p;
    var t = 'translate(' + p.x.toFixed(2) + '%,' + p.y.toFixed(2) + '%) scale(' + (p.s * accXf().s).toFixed(4) + ')', f = p.l > 0.01 ? 'drop-shadow(' + (10 * p.l).toFixed(1) + 'px ' + (18 * p.l).toFixed(1) + 'px ' + (16 * p.l).toFixed(1) + 'px rgba(0,26,26,' + (0.33 * p.l).toFixed(3) + '))' : 'none';
    kwEl.style.transform = kwNext.style.transform = t; kwEl.style.filter = kwNext.style.filter = f;
  }
  function wLerp(a, b, t) { return { x: a.x + (b.x - a.x) * t, y: a.y + (b.y - a.y) * t, s: a.s + (b.s - a.s) * t, l: a.l + (b.l - a.l) * t }; }
  function wGlide(from, to, ms) { return kTween(ms, function (t) { var p = wLerp(from, to, kEaseIO(t)), b = Math.sin(Math.PI * t); p.l = Math.max(p.l, b * 0.9); p.s *= 1 + b * 0.05; wPlace(p); }); }
  function wSnap(to) {
    var from = wPose;
    try { if (navigator.vibrate) navigator.vibrate(12); } catch (e) {}
    try { if (kRipple.animate) kRipple.animate([{ opacity: .9, transform: 'translate(-50%,-50%) scale(.92)' }, { opacity: 0, transform: 'translate(-50%,-50%) scale(1.45)' }], { duration: 420, easing: 'cubic-bezier(.2,.8,.2,1)' }); } catch (e) {}
    return kTween(200, function (q) {
      var p = wLerp(from, to, Math.min(1, q / .55));
      p.s = q < .55 ? from.s - (from.s - to.s * 0.97) * Math.pow(q / .55, 2) : to.s * (0.97 + 0.03 * kEaseOut((q - .55) / .45));
      p.l = Math.max(0, from.l * (1 - q / .55)); wPlace(p);
    }).then(function () { wPlace(to); });
  }
  function kwShow(on) {
    if (KW.shown === on) return;
    KW.shown = on; kLayerSync(); kwEl.style.opacity = on ? 1 : 0; kLabels();
    if (!on && !K.shown) kCap('');
    render();                                                     /* canvas piirtää / jättää staattisen KARBin */
  }
  /* KARB kuoreen (KRIP ensin sivuun, jos se on kuoressa) */
  function karbAttachSeq() {
    var pre = (K.shown && !K.parked) ? kripParkSeq(true) : Promise.resolve();
    return pre.then(function () { kCap('krip_c_snap'); return wGlide(wPose, wOn(true), 560); }).then(function () { return wSnap(wOn(false)); }).then(function () { KW.attached = true; kLabels(); kCap('karb_c_cards'); });
  }
  function karbDetachSeq() { kCap('krip_c_parked'); return wGlide(wPose, W_SIDE, 600).then(function () { KW.attached = false; kLabels(); }); }
  function karbSelect(i, animate) {
    if (!kripEls() || !kwEl) return;
    var prev = KW.idx, src = D.addons[i].img;
    KW.on = true; KW.idx = i;
    loadImage(src).then(function (im) { KW.staticImg = im; });
    /* Värin vaihto (musta ↔ vihreä): ristiinhäivytys, ei esittelyä uudestaan */
    if (KW.shown && prev >= 0 && prev !== i) {
      kwNext.src = src; kwNext.style.opacity = 0; void kwNext.offsetWidth; kwNext.style.opacity = 1;
      setTimeout(function () { kwEl.src = src; kwNext.style.opacity = 0; }, 320);
      return;
    }
    kwEl.src = src; kwNext.src = src;
    if (K.parked && K.shown && !K.busy) kripPlace(K_PARK_R);       /* KRIP pois lompakon tieltä */
    if (!animate || kripReduce() || K.busy) { KW.attached = false; wPlace(W_SIDE); kwShow(true); return; }   /* toinen esittely kesken → ei keskeytetä */
    kCancel(); kLock(true);
    var kripWasOn = K.shown && !K.parked;
    wPlace(W_OFF); kwShow(true); kCap('krip_c_fly');
    kTween(350, function (t) { wPlace(wLerp(W_OFF, W_SIDE, kEaseOut(t))); })
      .then(function () { return kWait(150); })
      .then(karbAttachSeq)
      .then(function () { return kWait(1000); })
      .then(karbDetachSeq)
      .then(function () { return kripWasOn ? kripAttachSeq() : null; })
      .then(function () { kCap(K.shown && !K.parked && K.open ? 'krip_c_rest' : 'krip_c_parked'); kLabels(); kLock(false); }, function () {});
  }
  function karbUnselect() {
    KW.on = false; KW.idx = -1;
    if (!KW.shown) return;
    kCancel(); kLock(false);
    if (kripReduce()) { KW.attached = false; kwShow(false); return; }
    var from = wPose;
    kTween(420, function (q) { wPlace(wLerp(from, W_OFF, Math.pow(q, 2))); kwEl.style.opacity = 1 - Math.max(0, (q - .7) / .3); })
      .then(function () { KW.attached = false; if (!KW.on) kwShow(false); }, function () { KW.attached = false; if (!KW.on) kwShow(false); });
  }
  function karbToggle() {
    if (K.busy || !KW.shown) return;
    hintDone();
    if (kripReduce()) { KW.attached = !KW.attached; if (KW.attached && K.shown && !K.parked) { K.parked = true; K.open = false; K.f = 0; kripDraw(0); kripPlace(K_PARK_R); } wPlace(KW.attached ? wOn(false) : W_SIDE); kLabels(); return; }
    kLock(true);
    (KW.attached ? karbDetachSeq() : karbAttachSeq()).then(function () { kLabels(); kLock(false); }, function () {});
  }
  /* ───────── LEKA-näytönsuojat esikatselussa (1.10.2026) ─────────
     Oikeaan alakulmaan kurkistaa 1–3 lasimaista suojaa viuhkana (valittu määrä). Muoto = valitun mallin
     ääriviivan mittasuhteet (phoneCache), muuten oletus. Pelkkä SVG + CSS-transitio, ei kuvia. Ei koriin menevään kuvaan. */
  var LK = { n: 0, key: '', uid: 0 }, lkStack = null, lkSheets = [];
  function kLayerSync() { if (kLayer) kLayer.hidden = !(K.shown || KW.shown || LK.n > 0 || MSG.on); }

  /* ───────── MagSafe-esittely (1.10.2026) ─────────
     Kun asiakas lisää MagSafen: keltainen 1,5 px ääriviiva piirtyy renkaan ja kohdistusmagneetin ympäri (0,9 s),
     hengähtää kerran, hehkuu hetken ja häivyttyy pois 2 s:ssa (yht. 4,3 s). EI pysyvää reunaa: musta magneetti saa uppoutua mustaan puuhun (HIILI) –
     animaatio vain näyttää, missä se on. Ääriviivat = MagSafe-overlayn omat reunat (SVG, sama kaikissa malleissa). */
  var MSG = { on: false, anims: [], timer: 0, capTimer: 0 }, msSvg = null;
  function msCapClear() { if (kCapEl && kCapEl.getAttribute('data-key') === 'ms_c') kCap(''); }
  function msStop(clearCap) {
    MSG.anims.forEach(function (a) { try { a.cancel(); } catch (e) {} }); MSG.anims = []; clearTimeout(MSG.timer);
    if (msSvg) msSvg.style.opacity = 0;
    if (MSG.on) { MSG.on = false; kLayerSync(); }
    if (clearCap) { clearTimeout(MSG.capTimer); msCapClear(); }
  }
  function msGlow() {
    if (!kripEls()) return;
    msSvg = msSvg || kLayer.querySelector('.lastu-k__ms-glow'); if (!msSvg) return;
    msStop(true); MSG.on = true; kLayerSync();
    var paths = [].slice.call(msSvg.querySelectorAll('path'));
    if (!msSvg.animate || kripReduce()) {                           /* ilman liikettä: näkyy hetken ja häviää */
      msSvg.style.opacity = 1; paths.forEach(function (p) { p.style.strokeDasharray = 'none'; p.style.strokeDashoffset = 0; });
      MSG.timer = setTimeout(msStop, 3000); return;
    }
    if (!K.busy) { kCap('ms_c'); clearTimeout(MSG.capTimer); MSG.capTimer = setTimeout(msCapClear, 3000); }   /* teksti 3 s (2.10.2026, ennen 7 s) */
    paths.forEach(function (p, i) {
      var len = p.getTotalLength ? p.getTotalLength() : 1000;
      p.style.strokeDasharray = len; p.style.strokeDashoffset = len;
      /* renkaan reunat piirtyvät yhtä aikaa, kohdistusmagneetti perässä */
      MSG.anims.push(p.animate([{ strokeDashoffset: len }, { strokeDashoffset: 0 }], { duration: i < 2 ? 900 : 450, delay: i < 2 ? 0 : 650, easing: 'cubic-bezier(.45,0,.25,1)', fill: 'forwards' }));
    });
    /* 3,0 s (2.10.2026, ennen 4,3 s): piirto 0,9 s → hengähdys → hehku → häivytys; samat suhteelliset offsetit */
    MSG.anims.push(msSvg.animate([
      { opacity: 1, filter: 'drop-shadow(0 0 3px rgba(246,226,122,.8))', offset: 0 },
      { opacity: 1, filter: 'drop-shadow(0 0 3px rgba(246,226,122,.8))', offset: .21 },
      { opacity: 1, filter: 'drop-shadow(0 0 9px rgba(246,226,122,.95))', offset: .30 },
      { opacity: 1, filter: 'drop-shadow(0 0 4px rgba(246,226,122,.85))', offset: .40 },
      { opacity: 1, filter: 'drop-shadow(0 0 4px rgba(246,226,122,.85))', offset: .535, easing: 'cubic-bezier(.4,0,.6,1)' },
      { opacity: 0, filter: 'drop-shadow(0 0 2px rgba(246,226,122,.5))', offset: 1 }
    ], { duration: 3000, easing: 'linear', fill: 'forwards' }));
    MSG.timer = setTimeout(msStop, 3050);
  }
  function lekaSvg(w, h) {
    var r = Math.round(w * 0.13), id = 'lastu-lk-g' + (++LK.uid), f = function (v) { return Math.round(v); };
    return '<svg viewBox="0 0 ' + w + ' ' + h + '" width="100%" height="100%" aria-hidden="true" focusable="false"><defs><linearGradient id="' + id + '" x1="0" y1="0" x2="1" y2="1">' +
      '<stop offset="0" stop-color="#fff" stop-opacity=".62"/><stop offset=".4" stop-color="#e9f3f2" stop-opacity=".26"/><stop offset="1" stop-color="#fff" stop-opacity=".12"/></linearGradient></defs>' +
      '<rect x="3" y="3" width="' + (w - 6) + '" height="' + (h - 6) + '" rx="' + r + '" fill="url(#' + id + ')" stroke="rgba(0,26,26,.42)" stroke-width="3"/>' +
      '<rect x="10" y="10" width="' + (w - 20) + '" height="' + (h - 20) + '" rx="' + (r - 7) + '" fill="none" stroke="rgba(255,255,255,.95)" stroke-width="3.5"/>' +
      '<path d="M' + f(w * .07) + ' ' + f(h * .3) + 'L' + f(w * .5) + ' ' + f(h * .03) + 'L' + f(w * .64) + ' ' + f(h * .03) + 'L' + f(w * .07) + ' ' + f(h * .4) + 'Z" fill="#fff" fill-opacity=".42"/>' +
      '<path d="M' + f(w * .07) + ' ' + f(h * .47) + 'L' + f(w * .74) + ' ' + f(h * .03) + 'L' + f(w * .8) + ' ' + f(h * .03) + 'L' + f(w * .07) + ' ' + f(h * .51) + 'Z" fill="#fff" fill-opacity=".22"/></svg>';
  }
  function lekaShape() {
    if (!lkStack) return;
    var m = currentModel(), u = m && m.img, ph = (u && phoneCache[u]) || { x: 365, y: 40, w: 470, h: 880 }, key = ph.x + ':' + ph.w + 'x' + ph.h;
    if (key === LK.key) return;
    LK.key = key;
    /* Suojien vasen reuna aina kuoren oikean reunan oikealle puolelle (+26 px), viuhka avautuu oikealle ylös → ei kuoren päälle. */
    var left = Math.min(1200 - 230, ph.x + ph.w + 26);
    lkStack.style.setProperty('--lk-l', (left / 12).toFixed(2) + '%');
    lkStack.style.setProperty('--lk-w', (ph.w / 12).toFixed(2) + '%'); lkStack.style.setProperty('--lk-ar', (ph.w / ph.h).toFixed(4));
    lkSheets.forEach(function (el) { el.innerHTML = lekaSvg(ph.w, ph.h); });
  }
  function lekaSync(instant) {
    if (!kripEls()) return;
    if (!lkStack) { lkStack = document.getElementById('lastu-k-leka-stack'); lkSheets = lkStack ? [].slice.call(lkStack.querySelectorAll('.lastu-k__leka-sheet')) : []; }
    if (!lkStack) return;
    lekaShape();
    var n = st.leka ? Math.max(1, Math.min(3, st.lekaCount || 1)) : 0, wasHidden = kLayer.hidden;
    LK.n = n; kLayerSync();
    lkStack.classList.toggle('is-instant', !!instant || kripReduce());
    if (wasHidden && !kLayer.hidden) void lkStack.offsetWidth;    /* kerros juuri näkyviin → transitio alkaa piilosta */
    lkSheets.forEach(function (el) { el.classList.toggle('is-on', +el.getAttribute('data-i') < n); });
    if (!n) setTimeout(kLayerSync, 520);                            /* piilotus vasta kun suojat ovat liukuneet pois */
  }

  /* Staattinen KRIP koriin menevään esikatselukuvaan, kun animaatiokerros on näkyvissä. */
  function kripSnapshot(x) { if (K.shown && K.staticImg && st.magsafe && st.addons[KRIP_I]) accDraw(x, K.staticImg); if (KW.shown && KW.staticImg && st.magsafe && st.addons[KW.idx]) accDraw(x, KW.staticImg, true); }
  function kripSkip(i) { return (K.shown && +i === KRIP_I) || (KW.shown && D.addons[+i] && D.addons[+i].type === 'karb'); }

  /* LEKA */
  var lekaInput = $('input[data-leka]');
  var lekaRadios = $$('input[data-leka-count]');
  function setLeka(on) {
    st.leka = on;
    var reveal = rowOf(lekaInput).querySelector('.lastu-k__reveal'); if (reveal) kReveal(reveal, on);
    lekaRadios.forEach(function (r) { r.disabled = !on; if (!on) r.checked = false; });
    if (on && !st.lekaCount) { lekaRadios[0].checked = true; st.lekaCount = 1; }
    if (!on) st.lekaCount = 0;
    setStatus('leka', on ? st.lekaCount + '×' : null);
    updatePrice(); lekaSync(memRestoring);
  }
  if (lekaInput) lekaInput.addEventListener('change', function () { setLeka(lekaInput.checked); });
  /* Kaarevareunainen näyttö (metaobjekti kaareva_naytto, esim. OnePlus 12, S23 Ultra) → suora LEKA ei istu:
     valinta pois ja lukkoon, tilalle lyhyt selitys. Merkin vaihto nollaa mallin → rivi palaa. */
  var lekaCurvedNote = $('[data-leka-curved]');
  function syncLekaCurved() {
    if (!lekaInput) return;
    var m = currentModel(), curved = !!(m && m.curved), lbl = lekaInput.closest('.lastu-k__toggle');
    if (curved && lekaInput.checked) { lekaInput.checked = false; setLeka(false); }
    lekaInput.disabled = curved;
    if (lbl) lbl.hidden = curved;
    if (lekaCurvedNote) lekaCurvedNote.hidden = !curved;
  }
  lekaRadios.forEach(function (r) {
    r.addEventListener('change', function () { if (r.checked) { st.lekaCount = +r.getAttribute('data-leka-count'); setStatus('leka', st.lekaCount + '×'); updatePrice(); lekaSync(memRestoring); } });
  });

  /* Hinta */
  var totalEl = $('#lastu-k-total'), totalVal = $('[data-total-value]'), sumEl = $('[data-sum]');
  /* Hinnan erittely: [nimi, senttiä] jokaisesta valitusta lisästä – sama lähde kuin summalle. */
  function priceLines() {
    var L = [], P = D.consts.prices;
    if (st.persona === 'upload') L.push([S.sum_upload, P.engraving5]);
    if (st.persona === 'print') L.push([S.sum_print, P.print7]);
    if (st.persona === 'kartta') L.push([S.sum_kartta, P.kartta7]);
    if (st.persona === 'engraving') L.push([S.sum_engraving, P.engravingCollection || 0]);
    if (st.persona === 'velcro' && !VELCRO) L.push([S.sum_velcro, P.velcro || 0]);
    if (st.text.on) L.push([S.sum_text, P.text3]);
    if (st.magsafe) L.push([S.sum_magsafe, P.magsafe]);
    Object.keys(st.addons).forEach(function (i) { L.push([D.addons[i].name, D.addons[i].price || 0]); });
    if (st.leka && st.lekaCount) L.push([S.sum_leka + (st.lekaCount > 1 ? ' ×' + st.lekaCount : ''), D.consts.lekaPrices[st.lekaCount - 1] || 0]);
    return L;
  }
  function extras() { return priceLines().reduce(function (a, l) { return a + l[1]; }, 0); }
  function renderSum(lines) {
    if (!sumEl) return; sumEl.innerHTML = '';
    [[S.sum_base, basePrice, true]].concat(lines).forEach(function (l) {
      var li = document.createElement('li'); var n = document.createElement('span'); n.textContent = l[0];
      var v = document.createElement('span'); v.textContent = l[2] ? money(l[1]) : (l[1] ? '+ ' + money(l[1]) : S.sum_free);
      if (!l[2] && !l[1]) v.className = 'is-free';
      li.appendChild(n); li.appendChild(v); sumEl.appendChild(li);
    });
  }
  var priceWriting = false, lastTotalText = '';
  function updatePrice() {
    var lines = priceLines(), total = basePrice + extras();
    if (totalEl) { totalEl.hidden = !lines.length; if (totalVal) totalVal.textContent = money(total); renderSum(lines); }
    lastTotalText = money(total); applyButtonPrice(); atcNeedState();
  }
  /* 9.10.2026 UX: ennen mallin valintaa nappi kertoo mitä puuttuu ("Valitse ensin puhelinmalli") eikä näytä pelkkää hintaa. */
  function atcNeedState() {
    var btn = submitButton(); if (!btn) return;
    var v = null; try { v = validate(); } catch (e) {}
    var need = !!(v && v.el && /lastu-k-step-(brand|model)/.test(v.el.id || ''));
    var bt = btn.querySelector('.btn-text') || btn;
    if (need) bt.setAttribute('data-lastu-need', S.atc_need || 'Valitse ensin puhelinmalli');
    btn.classList.toggle('lastu-k-atc-need', need);
    var rd = document.getElementById('lastu-k-req-done'); if (rd) rd.hidden = !!v;   /* 10.10.2026: "✓ Valmis – voit lisätä koriin" kun mitään ei puutu */
    var lab = btn.querySelector('.btn-text > span');   /* §9 muokkaustila */
    if (lab && (edit || lab.__lk != null)) { if (lab.__lk == null) lab.__lk = lab.textContent; lab.textContent = edit ? ET.atc : lab.__lk; if (!edit) lab.__lk = null; }
    document.documentElement.classList.toggle('lastu-k-need-model', need);
  }
  function applyButtonPrice() {
    var pb = document.querySelector('product-buy-price[form="' + (form ? form.id : '') + '"]') || document.querySelector('product-buy-price');
    if (!pb || !lastTotalText || pb.textContent.trim() === lastTotalText) return;
    priceWriting = true; pb.textContent = lastTotalText; priceWriting = false;
  }
  /* Teema kirjoittaa napin hinnan uudelleen (variantti/kori-tapahtumat) → palautetaan oma summa. */
  (function watchButtonPrice() {
    var btn = submitButton(); if (!btn || !('MutationObserver' in window)) return;
    new MutationObserver(function () { if (!priceWriting) applyButtonPrice(); }).observe(btn, { childList: true, characterData: true, subtree: true });
  })();
  ['cart:refresh', 'cart:updated', 'ajaxProduct:added', 'variant:change'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(applyButtonPrice, 50); setTimeout(applyButtonPrice, 800); });
  });

  /* ───────── 3. Esikatselu ───────── */
  var canvas = $('#lastu-k-canvas'), ctx = canvas.getContext('2d');
  var W = 1200, H = 960;
  /* MagSafe-renkaan keskipiste kuoripohjissa (sama kaikilla malleilla,
     mitattu magsafe-overlayn alfasta 449–749 × 345–753). Kokoelman
     kaiverrukset ja oman kuvan oletussijainti keskitetään tähän. */
  var RING = { x: 599, y: 495 };
  /* ───────── Lisäosien mallikohtainen mittakaava (1.10.2026) ─────────
     Pienissä Galaxy-perusmalleissa ja iPhone 16e/17e:ssä puhelin on kuvassa suhteessa isompi → MagSafe-rengas, KRIP ja
     KARB suurennetaan samassa suhteessa niin, että lompakko ≈ 93 % kuoren leveydestä (66 mm / ~71 mm), kuten oikeasti.
     Galaxy S23–S26: magneetti asennetaan matalalle → lompakon alareuna 3 mm kuoren alareunan yläpuolelle, rengas
     5 mm lompakon yläreunan alle; ei kamerarajausta (lompakko menee hieman kameran päälle kuten oikeasti).
     Vain esikatselu: kaiverrusten ja tuotantotiedoston paikat (RING) eivät muutu. */
  /* Camo-merkki renkaan keskelle myös siirretyssä renkaassa */
  function badgeC() { var a = accXf(); return { x: BADGE.x + a.dx, y: BADGE.y + a.dy }; }
  var ACC_C = { x: 599.1, y: 493 }, ACC_K = { x: 198.5, y: 649.5 };
  var ACC_MODELS = { 'Galaxy S23': { s: 1.03, low: 1 }, 'Galaxy S24': { s: 1.08, low: 1 }, 'Galaxy S25': { s: 1.08, low: 1 }, 'Galaxy S26': { s: 1.02, low: 1, dy: -12 }, 'iPhone 16e / 17e': { s: 1.10 } };
  function accXf() {
    var m = LOMPAKKO ? null : currentModel(), d = m && ACC_MODELS[m.name];
    if (!d) return { s: 1, dx: 0, dy: 0, low: false };
    var dy = 0, box = m.img && winCache[m.img];
    if (d.dy != null) dy = d.dy;                                         /* S26: kiinteä – rengas kameran alle, lompakko kuoren sisään (tarkistettu kuvista) */
    else if (d.low && box) dy = (box.y + box.h - (d.m || 17)) - (ACC_C.y + 360.8 * d.s);   /* m = alavara px (S26: 2 mm, ettei rengas osu kameraan) */   /* lompakon alareuna = rengas + (−146,7 − 27 + 535)·s */
    return { s: d.s, dx: 0, dy: Math.round(dy * 10) / 10, low: !!d.low };
  }
  /* Täyden kanvaksen lisäosakuva (rengas / KRIP / KARB sivussa) piirtoon mallin mittakaavassa. */
  function accDraw(x, img, karb) {
    var a = accXf();
    if (a.s === 1 && !a.dy) { x.drawImage(img, 0, 0, W, H); return; }
    var c = karb ? ACC_K : ACC_C, tx = karb ? 0 : a.dx, ty = karb ? 0 : a.dy;
    x.save(); x.translate(c.x * (1 - a.s) + tx, c.y * (1 - a.s) + ty); x.scale(a.s, a.s); x.drawImage(img, 0, 0, W, H); x.restore();
  }
  /* Animaatiokerroksen elementit samaan paikkaan (kutsutaan jokaisessa piirrossa; muuttuu vain mallin vaihtuessa). */
  var accKey = '';
  function accLayer() {
    if (!kLayer) return;
    var a = accXf(), key = a.s + '|' + a.dy;
    if (key === accKey) return; accKey = key;
    var g = kLayer.querySelector('.lastu-k__ms-glow');
    if (g) g.style.transform = a.s === 1 && !a.dy ? '' : 'translate(' + (a.dx / 12).toFixed(3) + '%,' + (a.dy / 9.6).toFixed(3) + '%) scale(' + a.s + ')';
    if (kRipple) { kRipple.style.left = (((595.6 - ACC_C.x) * a.s + ACC_C.x + a.dx) / 12).toFixed(3) + '%'; kRipple.style.top = (((492.4 - ACC_C.y) * a.s + ACC_C.y + a.dy) / 9.6).toFixed(3) + '%'; kRipple.style.width = (27 * a.s).toFixed(3) + '%'; }
    if (kEl && K.shown && !K.busy) kripPlace(kPose);
    if (kwEl && KW.shown && !K.busy) wPlace(KW.attached ? wOn(false) : wPose);
  }  /* rengas 449–749 × 345–645; pilleri alapuolella ei kuulu keskipisteeseen */
  var imgCache = {}, winCache = {};
  function loadImage(url) {
    if (!url) return Promise.resolve(null);
    if (imgCache[url]) return imgCache[url];
    imgCache[url] = new Promise(function (res) {
      var im = new Image(); im.crossOrigin = 'anonymous';
      im.onload = function () { res(im); }; im.onerror = function () { log('kuva ei latautunut', url); res(null); };
      im.src = url;
    });
    return imgCache[url];
  }
  /* Kuoren läpinäkyvä takaikkuna: bbox alfasta keskikaistalta (x 300–900). */
  var phoneCache = {};
  function windowBox(img, url) {
    if (winCache[url]) return winCache[url];
    var box = { x: 400, y: 60, w: 400, h: 840 };
    try {
      var c = document.createElement('canvas'); c.width = W; c.height = H;
      var cx = c.getContext('2d', { willReadFrequently: true }); cx.drawImage(img, 0, 0, W, H);
      var d = cx.getImageData(300, 0, 600, H).data, minx = 9999, miny = 9999, maxx = -1, maxy = -1;
      for (var y = 0; y < H; y += 2) for (var x = 0; x < 600; x += 2) {
        if (d[(y * 600 + x) * 4 + 3] < 10) { if (x < minx) minx = x; if (x > maxx) maxx = x; if (y < miny) miny = y; if (y > maxy) maxy = y; }
      }
      if (maxx > 0) box = { x: minx + 300, y: miny, w: maxx - minx, h: maxy - miny };
      /* Turvallinen yläreuna kartalle: alin rivi, jolla ikkuna EI ole lähes kokonaan läpinäkyvä
         (kameramoduulin alareuna). Kamera-alueen lasi on PNG:ssä osittain läpinäkyvä, joten pelkkä
         alfa-bbox ulottuu kameran päälle. */
      if (maxx > 0) {
        var safe = miny;
        for (var yy = Math.round(miny + (maxy - miny) * 0.5); yy >= miny; yy -= 2) {   /* keskeltä ylös: alakulmien pyöristys ei häiritse */
          var tr = 0, tot = 0;
          for (var xx = minx; xx <= maxx; xx += 2) { tot++; if (d[(yy * 600 + xx) * 4 + 3] < 10) tr++; }
          if (tr < tot * 0.9) { safe = yy + 6; break; }
        }
        box.safeY = Math.min(safe, box.y + box.h * 0.4);
        /* Oikean yläkulman vapaa yläreuna (pohjoisnuolelle): ensimmäinen rivi ylhäältä, jolla oikea
           kaista (72–92 % leveydestä) on lähes kokonaan läpinäkyvä – kameran ei tarvitse olla koko leveydellä. */
        var x0 = Math.round(minx + (maxx - minx) * 0.72), x1 = Math.round(minx + (maxx - minx) * 0.92), safeR = box.y + box.h * 0.4;
        for (var yr = miny; yr < miny + (maxy - miny) * 0.45; yr += 2) {
          var trr = 0, totr = 0;
          for (var xr = x0; xr <= x1; xr += 2) { totr++; if (d[(yr * 600 + xr) * 4 + 3] < 10) trr++; }
          if (trr >= totr * 0.96) { safeR = yr + 4; break; }
        }
        box.safeYR = safeR;
      }
      /* Koko puhelimen ääriviivat (läpinäkymätön alue) zoomia varten. */
      var d2 = cx.getImageData(0, 0, W, H).data, pminx = 9999, pminy = 9999, pmaxx = -1, pmaxy = -1;
      for (y = 0; y < H; y += 3) for (x = 0; x < W; x += 3) {
        if (d2[(y * W + x) * 4 + 3] >= 10) { if (x < pminx) pminx = x; if (x > pmaxx) pmaxx = x; if (y < pminy) pminy = y; if (y > pmaxy) pmaxy = y; }
      }
      /* Vain jos kuvassa on läpinäkyvä tausta (muuten ääriviiva = koko canvas). */
      if (pmaxx > 0 && pmaxx - pminx < 900) phoneCache[url] = { x: pminx, y: pminy, w: pmaxx - pminx, h: pmaxy - pminy };
    } catch (e) { log('alfa-luku estyi (CORS?)', e); }
    winCache[url] = box; return box;
  }
  function roundRect(c, x, y, w, h, r) {
    c.beginPath(); c.moveTo(x + r, y); c.arcTo(x + w, y, x + w, y + h, r); c.arcTo(x + w, y + h, x, y + h, r); c.arcTo(x, y + h, x, y, r); c.arcTo(x, y, x + w, y, r); c.closePath();
  }
  function coverTransform(iw, ih, box) {
    var s = Math.max(box.w / iw, box.h / ih);
    return { s: s, x: box.x + (box.w - iw * s) / 2, y: box.y + (box.h - ih * s) / 2 };
  }
  var tmp = document.createElement('canvas'), tctx = tmp.getContext('2d');
  function tinted(img, w, h, color, drawFn) {
    tmp.width = w; tmp.height = h; tctx.clearRect(0, 0, w, h);
    drawFn(tctx);
    tctx.globalCompositeOperation = 'source-in'; tctx.fillStyle = color; tctx.fillRect(0, 0, w, h);
    tctx.globalCompositeOperation = 'source-over';
    return tmp;
  }
  var camoRingImg = null, velcroImgs = null;
  if (CAMO) {
    loadImage(D.consts.camoRing).then(function (i) { camoRingImg = i; render(); });
    Promise.all([loadImage(D.consts.velcroBrown), loadImage(D.consts.velcroSand)]).then(function (r) { velcroImgs = { brown: r[0], sand: r[1] }; render(); });
  }
  var renderQueued = false, renderToken = 0;
  function render() {
    if (typeof stageBusy === 'function') stageBusy();
    if (typeof syncStageModes === 'function') syncStageModes();   /* esim. kuva poistettiin kesken piirroksen → ilmoitus pois */
    scheduleSave();
    if (renderQueued) return; renderQueued = true;
    /* 2.10.2026: rAF ei suoriudu taustavälilehdellä → renderQueued jäi true:ksi ja esikatselu tyhjäksi
       (esim. sivu ladattu taustalla). Varana ajastin; kumpi ehtii ensin, piirtää. */
    var fired = false, run = function () { if (fired) return; fired = true; renderQueued = false; draw(); };
    requestAnimationFrame(run); setTimeout(run, 150);
    clearTimeout(tintTimer); clearTimeout(tintTimer2); tintTimer = setTimeout(stageTint, 400); tintTimer2 = setTimeout(stageTint, 1500);   /* 2. luku: materiaalikuva latautuu 1. kerralla hitaammin */
  }
  /* 3.10.2026 Materiaalilasi: mobiilin kelluvan esikatselun reunasävy materiaalista. Keskiarvo kuoren
     takakannen keskeltä, sekoitettuna paperiin (32 %) → haaleampi sävy; CSS: --k-tint-ring / --k-tint-glow. */
  var tintTimer = 0, tintTimer2 = 0, tintKey = '';
  function stageTint() {
    var el = document.getElementById('lastu-k-stage'); if (!el) return;
    try {
      var d = ctx.getImageData(520, 430, 160, 260).data, r = 0, g = 0, b = 0, n = 0;
      for (var i = 0; i < d.length; i += 28) { if (d[i + 3] < 200) continue; r += d[i]; g += d[i + 1]; b += d[i + 2]; n++; }
      if (!n) return;
      var m = function (v, p) { return Math.round(v / n * 0.8 + p * 0.2); };   /* 3.10.: 68/32 → 80/20 (näkyvämpi) */
      r = m(r, 244); g = m(g, 241); b = m(b, 235);
      var key = r + ',' + g + ',' + b; if (key === tintKey) return; tintKey = key;
      el.style.setProperty('--k-tint-rgb', key);
      el.style.setProperty('--k-tint-ring', 'rgba(' + key + ',.55)');
      el.style.setProperty('--k-tint-glow', 'rgba(' + key + ',.45)');
    } catch (e) {}
  }
  var stageNote = $('#lastu-k-stage-note');
  function draw() {
    applyZoom();
    var token = ++renderToken;
    var model = currentModel(), mat = currentMaterial();
    var modelUrl = model && model.img ? model.img : '';
    var eng = st.persona === 'engraving' && st.engraving >= 0 ? D.engravings[st.engraving] : null;
    var addonIdx = st.magsafe ? Object.keys(st.addons).filter(function (i) { return !kripSkip(i); }) : [], addonImgs = addonIdx.map(function (i) { return D.addons[i].img; });
    var magsafeImg = st.magsafe ? (D.consts.magsafeImg || '') : '';
    return Promise.all([loadImage(modelUrl), loadImage(mat ? mat.texture : ''), loadImage(eng ? eng.img : ''), loadImage(magsafeImg)].concat(addonImgs.map(loadImage)))
      .then(function (imgs) {
        if (token !== renderToken) return;
        var phone = imgs[0], tex = imgs[1], engImg = imgs[2], ms = imgs[3], overlays = imgs.slice(4);
        var box;
        ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.globalAlpha = 1; ctx.globalCompositeOperation = 'source-over';
        ctx.clearRect(0, 0, W, H);
        ctx.fillStyle = '#F4F1EB'; ctx.fillRect(0, 0, W, H);
        if (!model) { drawInstructions(); return; }
        if (LOMPAKKO) { drawLompakko(tex, mat); return; }
        if (phone) { box = windowBox(phone, modelUrl); if (stageNote) stageNote.hidden = true; if (LK.n) lekaShape(); }
        else {
          box = { x: 400, y: 50, w: 400, h: 860 };
          if (stageNote) { stageNote.textContent = S.preview_generic; stageNote.hidden = false; }
        }
        var r = Math.min(56, box.w * 0.14);
        if (KARTTA()) { lastBox = box; karttaPlace(box); }
        /* 1) materiaali. Kuoripohja-PNG on läpinäkyvä vain takakannen kohdalta
           ja peittää kaiken muun → materiaali piirretään täyskorkuisena ilman
           rajausta; PNG:n leikkaus tekee muodon. Rajaus vain yleiskuorelle. */
        ctx.save();
        if (!phone) { roundRect(ctx, box.x, box.y, box.w, box.h, r); ctx.clip(); }
        if (tex) {
          var t;
          if (phone) { var ts = Math.max(H / tex.naturalHeight, 560 / tex.naturalWidth); t = { s: ts, x: (W - tex.naturalWidth * ts) / 2, y: (H - tex.naturalHeight * ts) / 2 }; }
          else t = coverTransform(tex.naturalWidth, tex.naturalHeight, box);
          ctx.drawImage(tex, t.x, t.y, tex.naturalWidth * t.s, tex.naturalHeight * t.s);
        }
        else { ctx.fillStyle = '#2b2b2c'; ctx.fillRect(0, 0, W, H); }
        /* 2) design */
        var col = mat ? mat.color : '#D9C49C';
        if (CAMO && engImg) {
          ctx.drawImage(engImg, badgeC().x - RING_D / 2, badgeC().y - RING_D / 2, RING_D, RING_D);
        } else if (engImg && eng.ring) {
          /* Renkaaseen merkitty kaiverrus: MagSafe-magneetin pyöreän osan kokoisena sen keskelle. */
          var rs = RING_D / Math.max(engImg.naturalWidth, engImg.naturalHeight);
          var rw = engImg.naturalWidth * rs, rh = engImg.naturalHeight * rs;
          var rc0 = tinted(engImg, W, H, col, function (c) { var ax1 = accXf(); c.drawImage(engImg, RING.x + ax1.dx - rw / 2, RING.y + ax1.dy - rh / 2, rw, rh); });
          ctx.globalAlpha = 0.94; ctx.drawImage(rc0, 0, 0); ctx.globalAlpha = 1;
        } else if (engImg) {
          var te = coverTransform(engImg.naturalWidth, engImg.naturalHeight, box);
          /* Kuviot 10 % suurempina, merkkilogot (nimi sisältää "logo") alkuperäiskoossa. */
          if (!/logo/i.test(eng.name)) te.s *= 1.1;
          /* Sama siirto kaikille: keskitetään MagSafe-renkaan keskipisteeseen, ei ikkunan keskelle. */
          if (phone) { var ax0 = accXf(); te.x = RING.x + ax0.dx - engImg.naturalWidth * te.s / 2; te.y = RING.y + ax0.dy - engImg.naturalHeight * te.s / 2; }   /* + mallikohtainen renkaan siirto (S23–S26) */
          else { te.x = box.x + (box.w - engImg.naturalWidth * te.s) / 2; te.y = box.y + (box.h - engImg.naturalHeight * te.s) / 2; }
          /* sijainti = ala (esim. Taivasalla): kankaan alareuna kuoren takaikkunan alareunaan → maisema pysyy alhaalla kaikissa malleissa */
          if (eng.bottom) te.y = box.y + box.h - engImg.naturalHeight * te.s;
          var tc = tinted(engImg, W, H, col, function (c) { c.drawImage(engImg, te.x, te.y, engImg.naturalWidth * te.s, engImg.naturalHeight * te.s); });
          ctx.globalAlpha = 0.94; ctx.drawImage(tc, 0, 0); ctx.globalAlpha = 1;
        }
        if (st.persona === 'upload') st.uploads.forEach(function (u) { if (u.maskCanvas) drawTransformed(u.maskCanvasTinted(col), u.tf, box); });
        drawUploadThumbs(col);
        if (CAMO && st.persona === 'print' && st.print && st.print.canvas) {
          if (camoRingImg) ctx.drawImage(camoRingImg, badgeC().x - RING_D / 2, badgeC().y - RING_D / 2, RING_D, RING_D);
          ctx.save(); ctx.beginPath(); ctx.arc(badgeC().x, badgeC().y, RING_D / 2 - 4, 0, Math.PI * 2); ctx.clip();
          drawTransformed(st.print.canvas, st.print.tf, box); ctx.restore();
        } else if (st.persona === 'print' && st.print && st.print.canvas) drawTransformed(st.print.canvas, st.print.tf, box);
        if (KUWA) st.images.forEach(function (im) { if (im.canvas) drawTransformed(im.canvas, im.tf, box); });
        if (SANAT) { buildWords(box); if (st.words.maskCanvas) drawTransformed(st.words.maskCanvasTinted(col), st.words.tf, box); }
        if (st.text.on) st.text.items.forEach(function (t, ti) { if (!t.maskCanvas) return; if (!t.tf) t.tf = defaultTextTf(ti); drawTransformed(t.maskCanvasTinted(col), t.tf, box); });
        ctx.restore();
        if (KARTTA()) { drawOverlay(box); accLayer(); return; }   /* kuori, rengas, lisäosat ja teksti piirretään overlay-canvasille kartan PÄÄLLE */
        /* 3) MagSafe-rengas */
        if (st.magsafe) {
          if (ms) accDraw(ctx, ms);
          else drawMagsafeRing(box);
        }
        /* 4) kuori */
        if (phone) ctx.drawImage(phone, 0, 0, W, H); else drawGenericCase(box, r);
        /* 5) lisäosat */
        overlays.forEach(function (o, j) { if (o) accDraw(ctx, o, D.addons[addonIdx[j]].type === 'karb'); });
        accLayer();
        /* 6) Velcro kaiken päälle (sand MM14/M04-kankailla) */
        if (CAMO && st.persona === 'velcro' && velcroImgs) { var vi = /MM14|M04/i.test(mat ? mat.orderName : '') ? velcroImgs.sand : velcroImgs.brown; if (vi) ctx.drawImage(vi, 0, 0, W, H); }
        drawOverlay(box);
      });
  }
  /* Lähdekuvan varjo on rajattu vasempaan reunaan (x = 0) → häivytetään reuna, ettei jää pystyviivaa. */
  var fadeCache = typeof WeakMap === 'function' ? new WeakMap() : null;
  function lompakkoFade(tex) {
    if (fadeCache && fadeCache.has(tex)) return fadeCache.get(tex);
    var c = document.createElement('canvas'); c.width = tex.naturalWidth; c.height = tex.naturalHeight;
    var x = c.getContext('2d'); x.drawImage(tex, 0, 0);
    var gr = x.createLinearGradient(0, 0, c.width * 0.045, 0); gr.addColorStop(0, 'rgba(0,0,0,0)'); gr.addColorStop(1, 'rgba(0,0,0,1)');
    x.globalCompositeOperation = 'destination-in'; x.fillStyle = gr; x.fillRect(0, 0, c.width, c.height);
    if (fadeCache) fadeCache.set(tex, c);
    return c;
  }
  function drawLompakko(tex, mat) {
    var g = lompakkoGeom(), box = g.box, col = mat ? mat.color : '#000000';
    if (stageNote) stageNote.hidden = true;
    lastBox = box;
    if (tex) ctx.drawImage(lompakkoFade(tex), g.img.x, g.img.y, g.img.w, g.img.h);
    ctx.save(); roundRect(ctx, g.pocket.x, g.pocket.y, g.pocket.w, g.pocket.h, g.pocket.r); ctx.clip();
    ctx.globalAlpha = 0.92;
    if (st.persona === 'upload') st.uploads.forEach(function (u) { if (u.maskCanvas) drawTransformed(u.maskCanvasTinted(col), u.tf, box); });
    if (st.text.on) st.text.items.forEach(function (t, ti) { if (!t.maskCanvas) return; if (!t.tf) t.tf = defaultTextTf(ti); drawTransformed(t.maskCanvasTinted(col), t.tf, box); });
    ctx.globalAlpha = 1; ctx.restore();
    drawUploadThumbs(col);
    drawOverlay(box);
  }
  /* Ohjenäkymä ennen mallin valintaa: merkkikohtainen, kielen mukaan. */
  function wrapText(c, text, maxW) {
    var words = text.split(' '), lines = [], cur = '';
    words.forEach(function (w) { var t = cur ? cur + ' ' + w : w; if (c.measureText(t).width > maxW && cur) { lines.push(cur); cur = w; } else cur = t; });
    if (cur) lines.push(cur); return lines;
  }
  function drawInstructions() {
    if (stageNote) stageNote.hidden = true;
    var b = currentBrand(), key = b ? b.key : '';
    var head = (S.font_head || '"DM Serif Display", Georgia, serif'), mono = (S.font_mono || '"DM Mono", Menlo, monospace'), body = (S.font_body || '"Hanken Grotesk", system-ui, sans-serif');
    /* himmeä kuorisiluetti taustalle */
    ctx.save(); ctx.globalAlpha = 0.08; ctx.lineWidth = 14; ctx.strokeStyle = '#001A1A';
    roundRect(ctx, 400, 70, 400, 820, 64); ctx.stroke();
    ctx.fillStyle = '#001A1A'; roundRect(ctx, 440, 100, 320, 170, 44); ctx.fill(); ctx.restore();
    ctx.save(); ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.fillStyle = '#001A1A';
    ctx.font = '600 22px ' + mono; ctx.fillStyle = '#7A5F22';
    ctx.fillText((S.ins_kicker || 'ESIKATSELU').toUpperCase(), 600, 330);
    ctx.fillStyle = '#001A1A'; ctx.font = '600 58px ' + head;
    wrapText(ctx, S.ins_title, 700).forEach(function (l, i) { ctx.fillText(l, 600, 405 + i * 66); });
    ctx.font = '500 30px ' + body; ctx.fillStyle = 'rgba(0,26,26,.72)';
    var step = b ? S.ins_step_model.replace('{brand}', key) : S.ins_step_brand;
    wrapText(ctx, step, 640).forEach(function (l, i) { ctx.fillText(l, 600, 560 + i * 40); });
    /* askelmerkit */
    ctx.font = '600 20px ' + mono; ctx.fillStyle = '#7A5F22';
    var steps = [S.ins_s1, S.ins_s2, S.ins_s3], xs = [380, 600, 820];
    steps.forEach(function (t, i) {
      var done = (i === 0 && b);
      ctx.beginPath(); ctx.arc(xs[i], 700, 22, 0, Math.PI * 2);
      ctx.fillStyle = done ? '#001A1A' : '#F6E27A'; ctx.fill(); ctx.lineWidth = 2; ctx.strokeStyle = '#001A1A'; ctx.stroke();
      ctx.fillStyle = done ? '#F9FAFA' : '#001A1A'; ctx.fillText(done ? '✓' : String(i + 1), xs[i], 701);
      ctx.fillStyle = '#001A1A'; ctx.font = '600 18px ' + mono; ctx.fillText(t.toUpperCase(), xs[i], 748); ctx.font = '600 20px ' + mono;
    });
    ctx.restore();
  }
  function drawMagsafeRing(box) {
    var cx = box.x + box.w / 2, cy = box.y + box.h * 0.5, rr = box.w * 0.34;
    ctx.save(); ctx.strokeStyle = 'rgba(20,20,20,.92)'; ctx.lineWidth = box.w * 0.045; ctx.lineCap = 'round';
    ctx.beginPath(); ctx.arc(cx, cy, rr, 0, Math.PI * 2); ctx.stroke();
    ctx.beginPath(); ctx.moveTo(cx, cy + rr + box.w * 0.08); ctx.lineTo(cx, cy + rr + box.w * 0.2); ctx.stroke(); ctx.restore();
  }
  function drawGenericCase(box, r) {
    ctx.save(); ctx.lineWidth = 22; ctx.strokeStyle = '#111'; roundRect(ctx, box.x - 11, box.y - 11, box.w + 22, box.h + 22, r + 10); ctx.stroke();
    ctx.fillStyle = '#111'; roundRect(ctx, box.x + box.w * 0.08, box.y + box.h * 0.03, box.w * 0.84, box.h * 0.2, 40); ctx.fill();
    ctx.restore();
  }
  /* Asiakkaan kuva: tf = {x,y (keskipiste, box-suhteelliset 0–1), s (leveys suhteessa boxin leveyteen), r (rad)} */
  function drawTransformed(src, tf, box) {
    if (!src || !src.width) return;
    var w = box.w * tf.s, h = w * src.height / src.width;
    ctx.save(); ctx.translate(box.x + box.w * tf.x, box.y + box.h * tf.y); ctx.rotate(tf.r);
    ctx.drawImage(src, -w / 2, -h / 2, w, h); ctx.restore();
  }
  function defaultTf() {
    if (LOMPAKKO) return { x: 0.5, y: 0.42, s: 0.62, r: 0 };
    var m = currentModel(), u = m && m.img, box = (u && winCache[u]) || null;
    var y = box ? Math.min(0.9, Math.max(0.1, (RING.y - box.y) / box.h)) : 0.5;
    var x = box ? Math.min(0.9, Math.max(0.1, (RING.x - box.x) / box.w)) : 0.5;
    if (CAMO && box) return { x: x, y: y, s: (RING_D * 0.8) / box.w, r: 0 };
    return { x: x, y: y, s: 0.72, r: 0 };
  }

  /* ───────── 4. Kaiverrusmuunnin ───────── */
  /* HEIC/HEIF (iPhonen oletusmuoto): Safari dekoodaa natiivisti, muut selaimet eivät → muunnetaan
     selaimessa JPEG:ksi heic2any-kirjastolla (libheif-WASM, ladataan vasta tarvittaessa). Muunnettu
     tiedosto palautetaan img.__file:ssä, jotta muisti + Photoroom saavat JPEG:n eikä HEIC:iä. */
  function decodeImage(file) {
    return new Promise(function (res, rej) {
      var url = URL.createObjectURL(file), im = new Image();
      im.onload = function () { res(im); }; im.onerror = function () { URL.revokeObjectURL(url); rej(new Error('decode')); };
      im.src = url;
    });
  }
  var heicLib = null;
  function heicToJpeg(file) {
    if (!heicLib) heicLib = new Promise(function (res, rej) {
      if (window.heic2any) return res();
      var sc = document.createElement('script'); sc.src = 'https://cdn.jsdelivr.net/npm/heic2any@0.0.4/dist/heic2any.min.js'; sc.async = true;
      sc.onload = function () { res(); }; sc.onerror = function () { heicLib = null; rej(new Error('heic')); }; document.head.appendChild(sc);
    });
    return heicLib.then(function () { return window.heic2any({ blob: file, toType: 'image/jpeg', quality: 0.92 }); }).then(function (b) {
      var bl = Array.isArray(b) ? b[0] : b; if (!bl) throw new Error('heic');
      return new File([bl], (file.name || 'kuva').replace(/\.(heic|heif)$/i, '') + '.jpg', { type: 'image/jpeg' });
    }, function () { throw new Error('heic'); });
  }
  function readFile(file) {
    var isHeic = /heic|heif/i.test(file.type) || /\.(heic|heif)$/i.test(file.name);
    if (!isHeic) return decodeImage(file);
    return decodeImage(file).then(function (im) { return im; }, function () {
      return heicToJpeg(file).then(function (jpg) { return decodeImage(jpg).then(function (im) { im.__file = jpg; return im; }); });
    });
  }
  function toImageData(img, maxSide) {
    var w = img.naturalWidth || img.width, h = img.naturalHeight || img.height;
    var s = Math.min(1, maxSide / Math.max(w, h)); w = Math.max(1, Math.round(w * s)); h = Math.max(1, Math.round(h * s));
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    var cx = c.getContext('2d', { willReadFrequently: true }); cx.drawImage(img, 0, 0, w, h);
    return cx.getImageData(0, 0, w, h);
  }
  /* Tausta: jos kuvassa on jo alfa → se; muuten tulvatäyttö kulmista */
  function backgroundMask(id, tol) {
    var w = id.width, h = id.height, d = id.data, n = w * h, bg = new Uint8Array(n), hasAlpha = false;
    for (var i = 0; i < n; i++) if (d[i * 4 + 3] < 250) { hasAlpha = true; break; }
    if (hasAlpha) { for (i = 0; i < n; i++) bg[i] = d[i * 4 + 3] < 40 ? 1 : 0; return { bg: bg, hasAlpha: true }; }
    var seeds = [0, w - 1, (h - 1) * w, h * w - 1, Math.floor(w / 2), (h - 1) * w + Math.floor(w / 2), Math.floor(h / 2) * w, Math.floor(h / 2) * w + w - 1];
    var stack = [], tol2 = tol * tol;
    seeds.forEach(function (s) {
      if (bg[s]) return;
      var r0 = d[s * 4], g0 = d[s * 4 + 1], b0 = d[s * 4 + 2];
      stack.push(s); bg[s] = 1;
      while (stack.length) {
        var p = stack.pop(), x = p % w, y = (p - x) / w;
        var nb = [p - 1, p + 1, p - w, p + w];
        for (var k = 0; k < 4; k++) {
          var q = nb[k];
          if (q < 0 || q >= n || bg[q]) continue;
          if ((k === 0 && x === 0) || (k === 1 && x === w - 1)) continue;
          var dr = d[q * 4] - r0, dg = d[q * 4 + 1] - g0, db = d[q * 4 + 2] - b0;
          if (dr * dr + dg * dg + db * db <= tol2) { bg[q] = 1; stack.push(q); }
        }
      }
    });
    return { bg: bg, hasAlpha: false };
  }
  /* Taustamaskin siistintä: 1 px laajennus taustaan (reunahuntu pois) ja
     pienten taustasaarekkeiden (< 0,2 % kuvasta) täyttö kohteeksi. */
  function cleanMask(bg, w, h) {
    var n = w * h, out = new Uint8Array(bg);
    for (var y = 1; y < h - 1; y++) for (var x = 1; x < w - 1; x++) {
      var p = y * w + x; if (bg[p]) continue;
      if (bg[p - 1] || bg[p + 1] || bg[p - w] || bg[p + w]) out[p] = 1;
    }
    bg.set(out);
  }
  function luminance(id, invert, gamma) {
    var d = id.data, n = id.width * id.height, L = new Float32Array(n), lut = new Float32Array(256);
    for (var v = 0; v < 256; v++) { var t = Math.pow(v / 255, gamma) * 255; lut[v] = invert ? 255 - t : t; }
    for (var i = 0; i < n; i++) L[i] = lut[Math.round(0.299 * d[i * 4] + 0.587 * d[i * 4 + 1] + 0.114 * d[i * 4 + 2])];
    return L;
  }
  function otsu(L, fg) {
    var hist = new Float64Array(256), total = 0;
    for (var i = 0; i < L.length; i++) if (fg[i]) { hist[Math.min(255, Math.max(0, Math.round(L[i])))]++; total++; }
    if (!total) return 128;
    var sum = 0; for (i = 0; i < 256; i++) sum += i * hist[i];
    var sumB = 0, wB = 0, best = 128, maxVar = -1;
    for (var t = 0; t < 256; t++) {
      wB += hist[t]; if (!wB) continue; var wF = total - wB; if (!wF) break;
      sumB += t * hist[t]; var mB = sumB / wB, mF = (sum - sumB) / wF, v = wB * wF * (mB - mF) * (mB - mF);
      if (v > maxVar) { maxVar = v; best = t; }
    }
    return best;
  }
  function autoMode(L, fg) {
    var mid = 0, tot = 0;
    for (var i = 0; i < L.length; i += 3) { if (!fg[i]) continue; tot++; if (L[i] > 70 && L[i] < 190) mid++; }
    return tot && mid / tot > 0.22 ? 'dither' : 'threshold';
  }
  var AI_DETAIL = 0.35, AI_GAMMA = Math.pow(2, (0.5 - 0.69) * 2);
  function convert(u) {
    /* 'ai' = Geminin piirtämä kaiverruspiirros (mustaa valkoisella) kynnystetään;
       kuva on valmiiksi rajattu, joten koko kuva on etualaa. */
    /* Taustanpoisto päällä → lähteenä Photoroomin leikkaama kuva (u.cut). Piirros tehdään aina
       alkuperäisestä valokuvasta (geometria säilyy) ja leikkausmaski sovitetaan sen päälle. */
    var cut = u.removeBg && u.cut ? u.cut : null, base = cut || u;
    var style = aiStyle(), aiData = u.aiBy && u.aiBy[style], ai = u.mode === 'ai' && aiData;
    var id = ai ? aiData : base.imageData, w = id.width, h = id.height, n = w * h;
    var fg = new Uint8Array(n), i;
    if (ai && cut) {
      var cw = cut.imageData.width, ch = cut.imageData.height;
      for (var yy = 0; yy < h; yy++) { var cy = Math.floor(yy * ch / h) * cw; for (var xx = 0; xx < w; xx++) fg[yy * w + xx] = cut.bg[cy + Math.floor(xx * cw / w)] ? 0 : 1; }
    } else for (i = 0; i < n; i++) fg[i] = ai || !base.bg[i] ? 1 : 0;
    /* 29.9.2026: Piirros-tilassa (Gemini) säätimet piilotettu → kiinteät arvot, jotka vastaavat vanhoja
       säädinarvoja Yksityiskohdat 35 / Tummuus 69 (testattu 10 kuvalla: ~15 % kaiverrettua, viivat ehjät,
       ei laajaa täyttöä). Muissa tiloissa Tummuus korjattu oikeaan suuntaan: ↑ = gamma > 1 = enemmän mustaa
       (aiemmin käänteinen; oletus 50 → gamma 1 → tulos ennallaan). */
    var dark = u.dark / 100;           // 0..1, 0.5 neutraali
    var gamma = ai ? AI_GAMMA : Math.pow(2, (dark - 0.5) * 2);
    /* neg-piirros = valkoista siellä missä kaiverretaan → käännetään kynnystystä varten. */
    var L = luminance(id, ai && style === 'neg' ? !u.invert : u.invert, gamma);
    /* Piirros valittu mutta ei vielä saapunut → näytetään ääriviiva odotuksen ajan. */
    var mode = ai ? 'threshold' : u.mode === 'ai' ? 'edge' : u.mode === 'auto' ? autoMode(L, fg) : u.mode;
    var out = new Uint8ClampedArray(n * 4), detail = ai ? AI_DETAIL : u.detail / 100;
    if (mode === 'threshold') {
      var t = otsu(L, fg) + (detail - 0.5) * 120;
      for (i = 0; i < n; i++) out[i * 4 + 3] = fg[i] && L[i] < t ? 255 : 0;
    } else if (mode === 'edge') {
      var thr = 40 + (1 - detail) * 120;
      for (var y = 1; y < h - 1; y++) for (var x = 1; x < w - 1; x++) {
        var p = y * w + x; if (!fg[p]) continue;
        var gx = -L[p - w - 1] - 2 * L[p - 1] - L[p + w - 1] + L[p - w + 1] + 2 * L[p + 1] + L[p + w + 1];
        var gy = -L[p - w - 1] - 2 * L[p - w] - L[p - w + 1] + L[p + w - 1] + 2 * L[p + w] + L[p + w + 1];
        out[p * 4 + 3] = Math.sqrt(gx * gx + gy * gy) > thr ? 255 : 0;
      }
    } else { /* dither: kontrasti + Floyd–Steinberg */
      var contrast = 0.6 + detail * 1.2, E = new Float32Array(n);
      for (i = 0; i < n; i++) E[i] = Math.min(255, Math.max(0, (L[i] - 128) * contrast + 128));
      for (y = 0; y < h; y++) for (x = 0; x < w; x++) {
        p = y * w + x; if (!fg[p]) { continue; }
        var old = E[p], nw = old < 128 ? 0 : 255, err = old - nw;
        out[p * 4 + 3] = nw === 0 ? 255 : 0;
        if (x + 1 < w) E[p + 1] += err * 7 / 16;
        if (y + 1 < h) { if (x > 0) E[p + w - 1] += err * 3 / 16; E[p + w] += err * 5 / 16; if (x + 1 < w) E[p + w + 1] += err * 1 / 16; }
      }
    }
    u.resolvedMode = mode;
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    c.getContext('2d').putImageData(new ImageData(out, w, h), 0, 0);
    if (u.round) { c = roundClip(c, u.roundPos); w = c.width; h = c.height; }
    u.maskCanvas = c;
    if (u.autoFit) fitUpload(u);
    var tintCache = {};
    u.maskCanvasTinted = function (color) {
      if (tintCache[color]) return tintCache[color];
      var t2 = document.createElement('canvas'); t2.width = w; t2.height = h; var k = t2.getContext('2d');
      k.drawImage(c, 0, 0); k.globalCompositeOperation = 'source-in'; k.fillStyle = color; k.fillRect(0, 0, w, h);
      tintCache[color] = t2; return t2;
    };
    return c;
  }
  /* Tuotanto-PNG: musta = kaiverretaan, läpinäkyvä muualla, 4× ikkunan koko.
     Sama funktio kuvakerrokselle ja tekstikerrokselle – aina ERI tiedostot. */
  function layerPng(layer) { return layersPng([layer]); }
  /* Useampi kerros samaan tiedostoon (kaiverruskuvat 1–3): sama koko ja koordinaatisto kuin yhdellä. */
  function layersPng(list) {
    list = (list || []).filter(function (l) { return l && l.maskCanvas && l.tf; });
    if (!list.length) return null;
    var model = currentModel(), url = model && model.img, box = LOMPAKKO ? lompakkoGeom().box : url && winCache[url] ? winCache[url] : { x: 400, y: 50, w: 400, h: 860 };
    var k = 4, c = document.createElement('canvas'); c.width = Math.round(box.w * k); c.height = Math.round(box.h * k);
    var x = c.getContext('2d');
    list.forEach(function (layer) {
      var tf = layer.tf, src = layer.maskCanvasTinted('#000000');
      var w = c.width * tf.s, h = w * src.height / src.width;
      x.save(); x.translate(c.width * tf.x, c.height * tf.y); x.rotate(tf.r); x.drawImage(src, -w / 2, -h / 2, w, h); x.restore();
    });
    return c.toDataURL('image/png');
  }
  /* TUOTANTOTIEDOSTO (23.9.2026, tuotannon pyyntö): KAIKKI kaiverrettava samassa PNG:ssä –
     kaiverruskuvat 1–3 + sanat + tekstikaiverrus (kartta: ks. karttaProductionPng). Väripainatus
     (KUWA / print) on eri prosessi, joten siellä teksti pysyy omana tiedostonaan (textPng). */
  function engravingLayers() {
    var L = [];
    if (st.persona === 'upload') st.uploads.forEach(function (u) { if (u.maskCanvas) L.push(u); });
    if (SANAT && st.words.maskCanvas) L.push(st.words);
    liveTexts().forEach(function (t) { L.push(t); });
    return L;
  }
  function printProcess() { return KUWA || st.persona === 'print'; }
  function productionPng() { if (KARTTA() || printProcess()) return null; return layersPng(engravingLayers()); }
  function textPng() { var L = liveTexts(); return L.length ? layersPng(L) : null; }
  function liveTexts() { return st.text.on ? st.text.items.filter(function (t) { return t.maskCanvas; }) : []; }

  function printPng() {
    if (CAMO) {
      if (!(st.persona === 'print' && st.print && st.print.canvas)) return null;
      var model = currentModel(), url = model && model.img, box = url && winCache[url] ? winCache[url] : { x: 400, y: 50, w: 400, h: 860 };
      var k = 4, d = Math.round(RING_D * k), c = document.createElement('canvas'); c.width = d; c.height = d;
      var x = c.getContext('2d'); x.beginPath(); x.arc(d / 2, d / 2, d / 2, 0, Math.PI * 2); x.clip();
      var tf = st.print.tf, w = box.w * k * tf.s, h = w * st.print.canvas.height / st.print.canvas.width;
      /* kerroksen keskipiste suhteessa renkaan keskipisteeseen */
      var cx = (box.x + box.w * tf.x - badgeC().x) * k + d / 2, cy = (box.y + box.h * tf.y - badgeC().y) * k + d / 2;
      x.translate(cx, cy); x.rotate(tf.r); x.drawImage(st.print.canvas, -w / 2, -h / 2, w, h);
      return c.toDataURL('image/png');
    }
    if (KUWA) {
      if (!st.images.some(function (im) { return im.canvas; })) return null;
      var model = currentModel(), url = model && model.img, box = url && winCache[url] ? winCache[url] : { x: 400, y: 50, w: 400, h: 860 };
      var k = 4, c = document.createElement('canvas'); c.width = Math.round(box.w * k); c.height = Math.round(box.h * k);
      var x = c.getContext('2d');
      st.images.forEach(function (im) {
        if (!im.canvas) return; var tf = im.tf, w = c.width * tf.s, h = w * im.canvas.height / im.canvas.width;
        x.save(); x.translate(c.width * tf.x, c.height * tf.y); x.rotate(tf.r); x.drawImage(im.canvas, -w / 2, -h / 2, w, h); x.restore();
      });
      return c.toDataURL('image/png');
    }
    if (!(st.persona === 'print' && st.print && st.print.canvas)) return null;
    return st.print.canvas.toDataURL('image/png');
  }
  function dataUrlToBlob(u) {
    if (!u) return null;
    var parts = u.split(','), mime = /data:([^;]+)/.exec(parts[0])[1], bin = atob(parts[1]), arr = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
    return new Blob([arr], { type: mime });
  }

  function makeTinter(c) {
    var cache = {};
    return function (color) {
      if (cache[color]) return cache[color];
      var t2 = document.createElement('canvas'); t2.width = c.width; t2.height = c.height; var k = t2.getContext('2d');
      k.drawImage(c, 0, 0); k.globalCompositeOperation = 'source-in'; k.fillStyle = color; k.fillRect(0, 0, c.width, c.height);
      cache[color] = t2; return t2;
    };
  }
  /* ───────── Tekstikaiverrus: teksti piirretään omaksi kerrokseksi (valkoinen +
     alfa, sävytetään materiaalin väriin; tuotantoon mustana). Oma kerros, oma
     tuotanto-PNG – ei koskaan samassa tiedostossa väripainatuksen kanssa. */
  var TEXT_FONTS = { brush: '400 160px "Satisfy", cursive', poster: '400 160px "Bebas Neue", Impact, sans-serif', head: '400 160px "DM Serif Display", Georgia, serif', body: '600 160px "Hanken Grotesk", system-ui, sans-serif', hand: '400 160px "Gochi Hand", "Comic Sans MS", cursive', mono: '500 160px "DM Mono", Menlo, monospace' };   /* 2.10.2026: mono asteen ohuempi (Medium) */
  function cleanText(v) {
    return String(v || '').replace(/\p{Extended_Pictographic}|\uFE0F|\u200D/gu, '').replace(/[ \t]+\n/g, '\n').replace(/\n{3,}/g, '\n\n').slice(0, 200);
  }
  function buildText(t) {
    var lines = cleanText(t.value).split('\n').slice(0, 6);
    while (lines.length && !lines[lines.length - 1].trim()) lines.pop();
    if (!lines.length || !lines.join('').trim()) { t.maskCanvas = null; return; }
    /* Riviväli fontin mukaan (2.10.2026: 1,18 oli liian väljä, erityisesti Handissa) */
    var size = 160, lh = size * ({ brush: 1.02, hand: 0.98, head: 1.04, mono: 1.08, body: 1.08, poster: 0.96 }[t.font] || 1.04), pad = 24, c = document.createElement('canvas'), x = c.getContext('2d');
    x.font = TEXT_FONTS[t.font] || TEXT_FONTS.head;
    /* t.tracking = kirjainväli em-yksikköinä (26.9.2026: kartan alalaidan teksti). Piirretään merkki
       kerrallaan, koska ctx.letterSpacing puuttuu vanhemmista Safareista. */
    var tr = (t.tracking || 0) * size;
    function lineW(l) { l = l || ' '; return x.measureText(l).width + tr * Math.max(0, Array.from(l).length - 1); }
    var w = Math.max.apply(null, lines.map(lineW)) + pad * 2 + ((t.bold && t.font === 'poster') ? size * 0.1 : 0), top = (t.font === 'hand' || t.font === 'brush') ? size * 0.12 : size * 0.04, h = (lines.length - 1) * lh + size * 1.22 + top + pad * 2;   /* top: Handin korkeat kirjaimet ulottuvat em-laatikon yli */
    c.width = Math.ceil(w); c.height = Math.ceil(h); x = c.getContext('2d');
    x.font = TEXT_FONTS[t.font] || TEXT_FONTS.head; x.fillStyle = '#fff'; x.textBaseline = 'top'; x.textAlign = t.align;
    var ax = t.align === 'left' ? pad : t.align === 'right' ? c.width - pad : c.width / 2;
    /* Bebas Neuesta on vain Regular-leikkaus → lihavoidaan kaiverrusta varten piirtämällä
       täytön päälle saman levyinen ääriviiva (semibold-vaikutelma, kaivertuu selvästi). */
    var faux = (t.bold && t.font === 'poster') ? size * 0.05 : 0;
    if (faux) { x.strokeStyle = '#fff'; x.lineWidth = faux; x.lineJoin = 'round'; x.miterLimit = 2; }
    lines.forEach(function (l, i) {
      var yy = pad + top + i * lh;
      if (!tr) { x.fillText(l, ax, yy); if (faux) x.strokeText(l, ax, yy); return; }
      var lw = lineW(l), cx = t.align === 'left' ? ax : t.align === 'right' ? ax - lw : ax - lw / 2;
      x.textAlign = 'left';
      Array.from(l).forEach(function (ch) { x.fillText(ch, cx, yy); if (faux) x.strokeText(ch, cx, yy); cx += x.measureText(ch).width + tr; });
      x.textAlign = t.align;
    });
    t.maskCanvas = c; t.maskCanvasTinted = makeTinter(c);
  }
  function defaultTextTf(i) {
    var m = currentModel(), u = m && m.img, box = (u && winCache[u]) || null;
    var y = box ? Math.min(0.92, Math.max(0.1, (RING.y + 250 - box.y) / box.h)) : 0.8;
    /* Lisätekstit (29.9.2026): 2., 3.… vuorotellen ylös ja alas, ettei uusi jää edellisen päälle. */
    if (i) { var k = Math.ceil(i / 2), dir = i % 2 ? -1 : 1; y = Math.min(0.94, Math.max(0.06, y + dir * k * 0.09)); }
    var x = box ? Math.min(0.9, Math.max(0.1, (RING.x - box.x) / box.w)) : 0.5;
    return { x: x, y: y, s: 0.55, r: 0 };
  }
  /* Fontit varmasti ladattu ennen piirtoa – muuten teksti välähtää varafontilla. */
  /* 29.9.2026: Gochi Hand (tekstikaiverruksen käsialafontti) ladataan Google Fontsista vasta,
     kun asiakas valitsee tekstikaiverruksen – ei jokaisella sivulatauksella. */
  var handFontP = null;
  function loadHandFont() {
    if (handFontP) return handFontP;
    handFontP = new Promise(function (res) {
      var done = function () { if (document.fonts && document.fonts.load) Promise.all([document.fonts.load('400 40px "Gochi Hand"'), document.fonts.load('500 40px "DM Mono"')]).then(res, res); else res(); };
      var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = 'https://fonts.googleapis.com/css2?family=Gochi+Hand&display=swap';
      l.onload = done; l.onerror = function () { res(); }; document.head.appendChild(l); setTimeout(res, 5000);
    });
    return handFontP;
  }
  function ensureFonts(cb) {
    if (!document.fonts || !document.fonts.load) { cb(); return; }
    if (st.text.on) { loadHandFont()   /* Hand on oletus → ladataan vasta kun tekstikaiverrus valitaan */.then(function () { ensureFontsBase(cb); }); return; }
    ensureFontsBase(cb);
  }
  function ensureFontsBase(cb) {
    var loads = [document.fonts.load('400 40px "DM Serif Display"'), document.fonts.load('600 40px "Hanken Grotesk"'), document.fonts.load('500 40px "DM Mono"')];
    if (SANAT) loads.push(document.fonts.load('600 40px "Caveat"'));
    if (SANAT || st.text.on) loads.push(document.fonts.load('400 40px "Satisfy"')); if (SANAT || KARTTA_MODE || KARTTA_ADDON) loads.push(document.fonts.load('400 40px "Bebas Neue"'));
    Promise.all(loads).then(cb, cb);
  }

  /* ───────── SANAT: sanapilvi koko takakanteen (21.9.2026) ─────────
     Sanat ladotaan ikkuna-alueelle skyline-pakkauksella: kolme kokoluokkaa, joka ~4. sana
     pystyyn, lista toistuu kunnes pinta on täynnä. Siemenluku (seed) tekee ladonnasta
     toistettavan: sama seed + sanat + fontti + tiheys = sama kuva esikatselussa ja tuotannossa.
     Maski = box-kokoinen (2×) canvas, tf kiinteä {0.5,0.5,1} → drawTransformed/layerPng toimivat
     kuten tekstikerroksella. Ei kahvoja: kokonaisuus on suunniteltu, ei siirreltävä. */
  var WORD_FONTS = { brush: '400 {px}px "Satisfy", cursive', script: '600 {px}px "Caveat", cursive', poster: '400 {px}px "Bebas Neue", Impact, sans-serif', head: '400 {px}px "DM Serif Display", Georgia, serif', body: '600 {px}px "Hanken Grotesk", system-ui, sans-serif', mono: '500 {px}px "DM Mono", Menlo, monospace' };
  var WORD_GLYPHS = {};
  function wordList() { return st.words.list.map(function (w) { return cleanText(w).replace(/\s+/g, ' ').trim().slice(0, 20); }).filter(Boolean); }
  function rng(seed) { var t = seed >>> 0 || 1; return function () { t += 0x6D2B79F5; var r = Math.imul(t ^ (t >>> 15), 1 | t); r ^= r + Math.imul(r ^ (r >>> 7), 61 | r); return ((r ^ (r >>> 14)) >>> 0) / 4294967296; }; }
  function buildWords(box) {
    var words = wordList();
    var key = [words.join('|'), st.words.font, st.words.seed, st.words.density, box.w, box.h].join('#');
    if (key === st.words.key) return;
    st.words.key = key;
    if (!words.length) { st.words.maskCanvas = null; return; }
    var K = 2, W = Math.round(box.w * K), H = Math.round(box.h * K);
    var c = document.createElement('canvas'); c.width = W; c.height = H; var x = c.getContext('2d');
    var rnd = rng(st.words.seed * 7919 + words.length);
    /* 11.10.2026 SANAPILVI (käyttäjä: "luovempi, nyt suurin osa vaakarivissä ja tylsä"):
       Sanat sijoitetaan kirjainten OIKEAN muodon mukaan (ei laatikoina) solukarttaan, spiraalihaulla satunnaisesta
       aloituspisteestä → lomittuvat toistensa koloihin kuten tuotekuvissa. Kokohierarkia: 1–2 isoa, keskikokoiset,
       sitten yhä pienemmät täytteet kunnes pinta on täynnä. ~1/3 pystyssä (kumpaankin suuntaan). Deterministinen
       (seed = Sekoita), tiheys säätää kokoja, välejä ja täyttöastetta. */
    var dens = st.words.density / 100;                      // 0 harva … 1 tiivis
    var upper = st.words.font === 'poster';                 /* Bebas Neue = versaali julistetyyli */
    var pad = Math.round(W * 0.035);
    var CS = Math.max(3, Math.round(W / 135));               // solun koko (px)
    var GW = Math.ceil(W / CS), GH = Math.ceil(H / CS), grid = new Uint8Array(GW * GH);
    var p0 = Math.ceil(pad / CS), free0 = 0, used = 0;
    for (var gy0 = 0; gy0 < GH; gy0++) for (var gx0 = 0; gx0 < GW; gx0++) {
      if (gx0 < p0 || gy0 < p0 || gx0 >= GW - p0 || gy0 >= GH - p0) grid[gy0 * GW + gx0] = 1; else free0++;
    }
    var halo = dens > 0.7 ? 0 : 1;                           // tyhjä väli sanojen ympärillä (soluina)
    var target = 0.58 + dens * 0.24;                         // täyttöaste, johon lopetetaan
    var base = W * (0.30 - dens * 0.10);                     // suurimman sanan fonttikoko
    function fontOf(px) { return WORD_FONTS[st.words.font].replace('{px}', px); }
    var cache = WORD_GLYPHS[st.words.font + '|' + CS] || (WORD_GLYPHS[st.words.font + '|' + CS] = {});   /* säilyy kirjoittaessa → ei piirretä samoja sanoja uudelleen */
    function glyph(word, px, rot) {
      px = Math.max(8, Math.round(px / 4) * 4);
      var ck = word + '|' + px + '|' + rot; if (cache[ck]) return cache[ck];
      x.font = fontOf(px); var m = x.measureText(word);
      var asc = m.actualBoundingBoxAscent || px * 0.8, desc = m.actualBoundingBoxDescent || px * 0.25;
      var lft = m.actualBoundingBoxLeft || 0, rgt = m.actualBoundingBoxRight || m.width;
      var tw = Math.ceil(lft + rgt) + 4, th = Math.ceil(asc + desc) + 4;
      var gc = document.createElement('canvas'); gc.width = rot ? th : tw; gc.height = rot ? tw : th;
      var g = gc.getContext('2d'); g.font = fontOf(px); g.fillStyle = '#fff'; g.textBaseline = 'alphabetic';
      if (rot === -1) { g.translate(0, gc.height); g.rotate(-Math.PI / 2); } else if (rot === 1) { g.translate(gc.width, 0); g.rotate(Math.PI / 2); }
      g.fillText(word, 2 + lft, 2 + asc);
      var cw = Math.ceil(gc.width / CS), ch = Math.ceil(gc.height / CS), mk = new Uint8Array(cw * ch), cells = [];
      var dd = g.getImageData(0, 0, gc.width, gc.height).data;
      for (var yy = 0; yy < gc.height; yy++) { var row = Math.floor(yy / CS) * cw, o = yy * gc.width * 4 + 3; for (var xx = 0; xx < gc.width; xx++, o += 4) if (dd[o] > 70) mk[row + Math.floor(xx / CS)] = 1; }
      for (var q = 0; q < mk.length; q++) if (mk[q]) cells.push(q % cw, Math.floor(q / cw));
      return (cache[ck] = { c: gc, cw: cw, ch: ch, cells: cells });
    }
    function fits(gl, gx, gy) {
      if (gx < 0 || gy < 0 || gx + gl.cw > GW || gy + gl.ch > GH) return false;
      var cl = gl.cells; for (var i = 0; i < cl.length; i += 2) if (grid[(gy + cl[i + 1]) * GW + gx + cl[i]]) return false;
      return true;
    }
    function mark(gl, gx, gy) {
      var cl = gl.cells;
      for (var i = 0; i < cl.length; i += 2) for (var ny = -halo; ny <= halo; ny++) for (var nx = -halo; nx <= halo; nx++) {
        var X = gx + cl[i] + nx, Y = gy + cl[i + 1] + ny; if (X < 0 || Y < 0 || X >= GW || Y >= GH) continue;
        var id = Y * GW + X; if (!grid[id]) { grid[id] = 1; used++; }
      }
    }
    function tryPlace(gl, steps) {
      var spanX = GW - 2 * p0 - gl.cw, spanY = GH - 2 * p0 - gl.ch; if (spanX < 0 || spanY < 0) return null;
      var sx = p0 + rnd() * spanX, sy = p0 + rnd() * spanY, t = 0, maxR = Math.max(GW, GH), dir = rnd() < 0.5 ? 1 : -1;
      for (var k = 0; k < steps; k++) {
        var rr = 0.55 * t; if (rr > maxR) break;
        var gx = Math.round(sx + rr * Math.cos(t * dir)), gy = Math.round(sy + rr * Math.sin(t * dir));
        if (fits(gl, gx, gy)) return { gx: gx, gy: gy };
        t += rr < 2 ? 0.6 : 1.6 / rr;
      }
      return null;
    }
    function rotFor(word, big) {
      var r = rnd(), pv = big ? 0.15 : (word.length > 7 ? 0.42 : 0.32);
      return r < pv * 0.7 ? -1 : r < pv ? 1 : 0;
    }
    function put(word, px, big) {
      if (upper) word = word.toUpperCase();
      var rot = rotFor(word, big);
      for (var att = 0; att < 3; att++) {
        var gl = glyph(word, px, rot), pos = tryPlace(gl, big ? 6000 : 2500);
        if (pos) { x.drawImage(gl.c, pos.gx * CS, pos.gy * CS); mark(gl, pos.gx, pos.gy); return true; }
        rot = att === 0 ? (rot ? 0 : -1) : rot; px = Math.round(px * 0.88);   /* toinen suunta, sitten pienempänä */
      }
      return false;
    }
    function shuffled(a) { a = a.slice(); for (var s2 = a.length - 1; s2 > 0; s2--) { var r2 = Math.floor(rnd() * (s2 + 1)); var t2 = a[s2]; a[s2] = a[r2]; a[r2] = t2; } return a; }
    var order = shuffled(words), placed = 0, LIMIT = 170;
    /* 1) pääsanat isoina, 2) kaikki sanat keskikokoisina, 3) täyttökierrokset pienenevillä koilla */
    var nBig = Math.min(order.length, words.length > 3 ? 2 : 1);
    for (var bi = 0; bi < nBig; bi++) if (put(order[bi], Math.round(base * (bi ? 0.82 : 1) * (0.92 + rnd() * 0.12)), true)) placed++;
    var tiers = [0.7, 0.57, 0.47, 0.39, 0.32, 0.27];
    var minReps = Math.ceil(10 / words.length);              /* 1–2 sanaa → sama sana toistuu, jotta pinta täyttyy */
    for (var ti = 0; ti < tiers.length && placed < LIMIT && used / free0 < target; ti++) {
      var reps = Math.max(minReps, ti < 2 ? 1 : ti < 4 ? 2 : 3);
      for (var rp = 0; rp < reps && placed < LIMIT && used / free0 < target; rp++) {
        var ord = shuffled(words);
        for (var wi = 0; wi < ord.length && placed < LIMIT; wi++) {
          var px = Math.round(base * tiers[ti] * (0.9 + rnd() * 0.2));
          if (px < W * 0.05) break;
          if (put(ord[wi], px, false)) placed++;
          if (used / free0 >= target) break;
        }
      }
    }
    st.words.maskCanvas = c; st.words.maskCanvasTinted = makeTinter(c);
  }
  var sanatList = $('#lastu-k-sanat-list'), sanatAdd = $('#lastu-k-sanat-add'), sanatIdeas = $('#lastu-k-sanat-ideas'), sanatValue = $('input[data-sanat-value]'), sanatDensity = $('input[data-sanat-density]'), sanatShuffle = $('#lastu-k-sanat-shuffle');
  function wordsChanged() { st.words.key = ''; if (sanatValue) sanatValue.value = wordList().join(' · '); setStatus('sanat', wordList().length ? wordList().length + ' ' + (lang === 'en' ? 'words' : 'sanaa') : null); ensureFonts(function () { render(); }); }
  function renderWordInputs() {
    if (!sanatList) return; sanatList.innerHTML = '';
    if (!st.words.list.length) st.words.list = [''];
    st.words.list.forEach(function (w, i) {
      var row = document.createElement('div'); row.className = 'lastu-k__sanat-item';
      var inp = document.createElement('input'); inp.type = 'text'; inp.maxLength = 20; inp.value = w; inp.placeholder = S.sanat_placeholder || ''; inp.setAttribute('autocomplete', 'off');
      inp.addEventListener('input', function () { st.words.list[i] = inp.value; wordsChanged(); });
      inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); if (st.words.list.length < 15 && inp.value.trim()) { st.words.list.push(''); renderWordInputs(); var last = sanatList.querySelector('.lastu-k__sanat-item:last-child input'); if (last) last.focus(); } } });
      var x = document.createElement('button'); x.type = 'button'; x.className = 'lastu-k__image-x'; x.textContent = '×'; x.setAttribute('aria-label', S.remove || 'Poista');
      x.addEventListener('click', function () { st.words.list.splice(i, 1); renderWordInputs(); wordsChanged(); });
      row.appendChild(inp); row.appendChild(x); sanatList.appendChild(row);
    });
    if (sanatAdd) sanatAdd.hidden = st.words.list.length >= 15;
  }
  function syncWordsUI() {
    $$('input[data-sanat-font]').forEach(function (r) { r.checked = r.getAttribute('data-sanat-font') === st.words.font; });
    if (sanatDensity) sanatDensity.value = st.words.density;
  }
  if (SANAT) {
    renderWordInputs();
    if (sanatAdd) sanatAdd.addEventListener('click', function () { if (st.words.list.length < 15) { st.words.list.push(''); renderWordInputs(); var last = sanatList.querySelector('.lastu-k__sanat-item:last-child input'); if (last && !isMobile()) last.focus(); } });
    if (sanatIdeas) (S.sanat_ideas_list || '').split('|').forEach(function (w) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'lastu-k__sanat-idea'; b.textContent = w;
      b.addEventListener('click', function () { if (wordList().indexOf(w) >= 0) return; var empty = st.words.list.findIndex(function (v) { return !v.trim(); }); if (empty >= 0) st.words.list[empty] = w; else if (st.words.list.length < 15) st.words.list.push(w); else return; renderWordInputs(); wordsChanged(); });
      sanatIdeas.appendChild(b);
    });
    $$('input[data-sanat-font]').forEach(function (r) { r.addEventListener('change', function () { if (r.checked) { st.words.font = r.getAttribute('data-sanat-font'); wordsChanged(); } }); });
    if (sanatDensity) sanatDensity.addEventListener('input', function () { st.words.density = +sanatDensity.value; wordsChanged(); });
    if (sanatShuffle) sanatShuffle.addEventListener('click', function () { st.words.seed = Math.floor(Math.random() * 1e6) + 1; wordsChanged(); });
    st.words.seed = Math.floor(Math.random() * 1e6) + 1;
    ensureFonts(function () { render(); });
  }

  /* ───────── KARTTA(): MapLibre GL + MapTiler (21.9.2026) ─────────
     Kartta on DOM-elementti (#lastu-k-map) tasan takaikkunan kohdalla, canvasin päällä ja
     overlay-canvasin alla: [canvas: materiaali] < [kartta] < [overlay: kuori, rengas, lisäosat,
     alalaidan teksti, nasta]. Tyylit generoidaan JS:ssä kaiverrusvärillä, ilman taustaa – sama
     kartta, jonka asiakas näkee, kaiverretaan. Tuotanto: näkymätön kartta 4× pixelRatio mustana. */
  var karttaEl = $('#lastu-k-map'), karttaSearch = $('input[data-kartta-search]'), karttaList = $('[data-kartta-list]'), karttaListBox = $('[data-kartta-listbox]'), karttaTextIn = $('input[data-kartta-text]');
  var KSIZE = { s: 0.75, m: 1, l: 1.3 };
  var KT_KEY = D.consts.maptilerKey || '', KT_SRC = 'https://api.maptiler.com/tiles/v3/tiles.json?key=' + KT_KEY, KT_CONT = 'https://api.maptiler.com/tiles/contours-v2/tiles.json?key=' + KT_KEY;
  /* Viivanpaksuudet ja tekstikoot ovat CSS-pikseleitä → suhde kuoreen riippuisi kartta-elementin koosta
     (mobiilissa 1,8× paksummat). sf skaalaa tyylin niin, että suhde kuoreen on sama kaikilla näytöillä
     ja tuotanto-PNG:ssä (referenssi: desktop, canvas 50 % koosta). */
  var karttaStyleTs = null, karttaGuardT = 0;
  /* 7.10.2026 VAHTI: viivanleveys kompensoidaan tiilikoon mukaan → jos lähteen tileSize ≠ tyylin laskennassa käytetty,
     viivat ovat 2–8× liian paksut tai ohuet (asiakastilaus #OR99744). Tarkistetaan aina kartan rauhoituttua. */
  function karttaGuard(map) {
    if (!map || st.kartta.busy || st.kartta.prod || !karttaStyleTs || Date.now() - karttaGuardT < 1500) return;
    var bad = Object.keys(karttaStyleTs).some(function (id) { var sr = map.getSource(id); return sr && Math.abs((sr.tileSize || 512) - karttaStyleTs[id]) > 1; });
    if (bad) { karttaGuardT = Date.now(); log('kartta: tiilikoko ≠ tyyli → restyle'); karttaRestyle(); }
  }
  function karttaStyle(color, kind, sf, zo, hq) {
    var L = []; sf = sf || 1; zo = zo || 0;
    /* Kuviot: esikatselussa matala tarkkuus (näytön DPR:n mukaan → ei moiréa), tuotannossa hq. */
    /* Sama tarkkuus molemmille kuvioille, muuten meri näyttää sumealta (kaksi eri rasteria päällekkäin). */
    var q = hq ? 24 : Math.min(8, Math.max(3, Math.ceil((window.devicePixelRatio || 1) * 2))), qb = hq ? 8 : q;   /* zo = zoom-siirtymä (karttaZoomOff): zoom-portaat ja minzoom siirretään, jotta sisältö vastaa kanonista zoomia */
    function sc(e) {   /* skaalaa lausekkeen ULOSTULOT (zoom-interpolate saa olla vain ylimmällä tasolla) */
      if (typeof e === 'number') return e * sf;
      if (!Array.isArray(e)) return e;
      var o, i;
      if (e[0] === 'interpolate') { var isZ = Array.isArray(e[2]) && e[2][0] === 'zoom'; o = e.slice(0, 3); for (i = 3; i < e.length; i += 2) { o.push(isZ ? e[i] + zo : e[i]); o.push(sc(e[i + 1])); } return o; }
      if (e[0] === 'case') { o = [e[0]]; for (i = 1; i < e.length - 1; i += 2) { o.push(e[i]); o.push(sc(e[i + 1])); } o.push(sc(e[e.length - 1])); return o; }
      if (e[0] === '*') { return ['*', sc(e[1]), e[2]]; }   /* maaston ohennuskerroin */
      return e;
    }
    function scaleWidths(layer) {
      /* Boostattu lähde (pienempi tileSize) → MapLibre arvioi sekä min/maxzoomin, filtterit että
         zoom-lausekkeet TIILEN zoomilla, joka on bz tasoa näkymää suurempi. Siirretään rajat ja
         zoom-portaat vastaavasti ja kompensoidaan viivanleveys (tiili piirtyy 512/tileSize kertaa suurempana). */
      var ts0 = KT_BOOST[layer.source], bz = ts0 ? Math.log2(512 / ts0) : 0, zo0 = zo;
      zo = zo + bz;
      /* min/maxzoom vertautuu NÄKYMÄN zoomiin (ei tiilen) → siirretään vain zo:lla.
         Aiemmin tähän lisättiin myös bz, jolloin kadut ja rakennukset jäivät piiloon 1–2 tasoa liian pitkään. */
      if (layer.minzoom !== undefined) layer.minzoom = Math.max(0, layer.minzoom + zo0);
      if (layer.maxzoom !== undefined) layer.maxzoom = layer.maxzoom + zo0;
      var comp = ts0 ? ts0 / 512 : 1;
      if (layer.paint && layer.paint['line-width'] !== undefined) { var sf0 = sf; sf = sf * comp; layer.paint['line-width'] = sc(layer.paint['line-width']); sf = sf0; }
      if (layer.layout && layer.layout['text-size'] !== undefined) layer.layout = Object.assign({}, layer.layout, { 'text-size': sc(layer.layout['text-size']) });
      zo = zo0;
      return layer;
    }
    /* Viivanleveydet VAKIOITA: kaiverrusjälki on yhtä paksu riippumatta kartan zoomista. */
    var rw = 0.7;   /* pientie */
    var RW = 1.6;   /* päätie */
    /* Vesistöt: reunaviiva + pisterasteri (umpitäyttö kaivertaisi liikaa). Kuvio luodaan styleimagemissing-tapahtumassa. */
    var water = { id: 'water', type: 'fill', source: 'omt', 'source-layer': 'water', paint: { 'fill-pattern': 'wave|' + q + '|' + color + '|' + sf.toFixed(2), 'fill-antialias': false } };
    /* Meri ja järvet: sama pisterasteri + harvakseltaan täytettyjä ikoneita (purjevene, kala, soutuvene) pistehalon kera. */
    var waterIcons = { id: 'water-icons', type: 'fill', source: 'omt', 'source-layer': 'water', filter: ['in', 'class', 'ocean', 'lake'], paint: { 'fill-pattern': 'boats|' + qb + '|' + color + '|' + sf.toFixed(2), 'fill-antialias': false } };
    var waterline = { id: 'water-line', type: 'line', source: 'omt', 'source-layer': 'water', paint: { 'line-color': color, 'line-width': 1.3 }, layout: { 'line-join': 'round' } };
    var waterway = { id: 'waterway', type: 'line', source: 'omt', 'source-layer': 'waterway', paint: { 'line-color': color, 'line-width': 0.9 } };
    var paths = { id: 'paths', type: 'line', source: 'omtc', minzoom: 11.3, 'source-layer': 'transportation', filter: ['in', 'class', 'minor', 'tertiary'], paint: { 'line-color': color, 'line-width': 0.9 } };
    var small = { id: 'small', type: 'line', source: 'omtb', 'source-layer': 'transportation', minzoom: 13.5, filter: ['in', 'class', 'path', 'track', 'service'], paint: { 'line-color': color, 'line-width': 0.7 } };   /* polut, pihatiet vasta lähellä */
    var roads = { id: 'roads', type: 'line', source: 'omt', 'source-layer': 'transportation', filter: ['in', 'class', 'motorway', 'trunk', 'primary'], paint: { 'line-color': color, 'line-width': 1.6 }, layout: { 'line-join': 'round' } };
    /* Seututiet vasta lähempää: kaukaa ne sulkevat kaupungin keskustan umpeen. */
    var roadsSec = { id: 'roads-sec', type: 'line', source: 'omt', 'source-layer': 'transportation', minzoom: 9, filter: ['==', 'class', 'secondary'], paint: { 'line-color': color, 'line-width': 1.3 }, layout: { 'line-join': 'round' } };
    var rail = { id: 'rail', type: 'line', source: 'omt', 'source-layer': 'transportation', filter: ['==', 'class', 'rail'], paint: { 'line-color': color, 'line-width': 0.9, 'line-dasharray': [4, 3] } };
    /* Rakennukset: viiva paksunee koon (render_height = korkeus ~ kerrokset) mukaan → kerrostalot ja
       julkiset rakennukset erottuvat omakotitaloista. */
    var bh = ['coalesce', ['get', 'render_height'], 5];
    var buildings = { id: 'buildings', type: 'line', source: 'omt', 'source-layer': 'building', minzoom: 13,
      paint: { 'line-color': color, 'line-width': ['interpolate', ['linear'], bh, 4, 0.7, 12, 0.95, 30, 1.3], 'line-opacity': 1 }, layout: { 'line-join': 'round' } };
    /* Urheilukentät, hautausmaat, laiturit, lentokentät */
    var pitch = { id: 'pitch', type: 'line', source: 'omt', 'source-layer': 'landuse', minzoom: 14.5, filter: ['in', 'class', 'pitch', 'stadium', 'playground', 'track'], paint: { 'line-color': color, 'line-width': 0.8 } };
    var cemetery = { id: 'cemetery', type: 'line', source: 'omt', 'source-layer': 'landuse', minzoom: 12, filter: ['==', 'class', 'cemetery'], paint: { 'line-color': color, 'line-width': 0.9, 'line-dasharray': [3, 2] } };
    var pier = { id: 'pier', type: 'line', source: 'omt', 'source-layer': 'transportation', filter: ['==', 'class', 'pier'], paint: { 'line-color': color, 'line-width': 1.0 } };
    var runway = { id: 'runway', type: 'line', source: 'omt', 'source-layer': 'aeroway', filter: ['in', 'class', 'runway'], paint: { 'line-color': color, 'line-width': 2.0 } };
    var taxiway = { id: 'taxiway', type: 'line', source: 'omt', 'source-layer': 'aeroway', filter: ['in', 'class', 'taxiway', 'apron', 'aerodrome'], paint: { 'line-color': color, 'line-width': 0.9 } };
    /* Kadunnimet päätielle (kaiverrettavuus: versaali, harva välistys, tien VIERESSÄ ettei sekoitu viivaan) */
    var lab = { 'symbol-placement': 'line', 'text-field': ['coalesce', ['get', 'name:fi'], ['get', 'name']], 'text-font': ['Open Sans Bold'], 'text-size': ['interpolate', ['linear'], ['zoom'], 13, 10, 16, 14, 18, 17], 'text-transform': 'uppercase', 'text-letter-spacing': 0.12, 'symbol-spacing': 130, 'text-max-angle': 32, 'text-padding': 6, 'text-offset': [0, -1.05], 'text-anchor': 'center', 'text-pitch-alignment': 'viewport', 'text-rotation-alignment': 'map' };
    var labelsMain = { id: 'road-labels', type: 'symbol', source: 'omt', 'source-layer': 'transportation_name', minzoom: 12.5, filter: ['in', 'class', 'motorway', 'trunk', 'primary', 'secondary'], layout: lab, paint: { 'text-color': color } };
    var labelsSmall = { id: 'road-labels-small', type: 'symbol', source: 'omt', 'source-layer': 'transportation_name', minzoom: 14, filter: ['in', 'class', 'tertiary', 'minor'], layout: lab, paint: { 'text-color': color } };
    var parks = { id: 'parks', type: 'line', source: 'omt', 'source-layer': 'park', minzoom: 13, paint: { 'line-color': color, 'line-width': 0.8, 'line-dasharray': [2, 2] } };
    var wood = { id: 'wood', type: 'line', source: 'omt', 'source-layer': 'landcover', filter: ['in', 'class', 'wood', 'grass', 'wetland'], paint: { 'line-color': color, 'line-width': 0.8, 'line-dasharray': [1, 2] } };
    /* MAASTO: tiheät korkeuskäyrät (myös kaukaa), vain päätiet ja vesistöt → tunturit ja vaarat esiin.
   contours-v2 tarjoaa käyrät z9:stä ylös; joka 5. käyrä paksumpana antaa topografisen rytmin. */
    var cw = { 'line-color': color, 'line-width': ['case', ['==', ['%', ['coalesce', ['get', 'nth_line'], 1], 5], 0], 1.0, 0.5] };
    /* Kaukaa katsottuna 10 m:n käyrät menevät jyrkillä rinteillä mössöksi → alle z13 vain 20 m:n käyrät.
       HUOM: zoom-lauseke FILTTERISSÄ katsoo tiilen (boostattua) zoomia, ei näkymän → rajaus min/maxzoomilla. */
    function contourLayer(id, extra) { return Object.assign({ id: id, type: 'line', source: 'contb', 'source-layer': 'contour', paint: cw, layout: { 'line-join': 'round' } }, extra); }
    /* Yksi käyräkerros: harvennusyritykset (height % 20, nth_line, min/maxzoom) eivät toimi, koska
       boostatussa lähteessä suodattimet ja zoom-rajat arvioidaan TIILEN zoomilla eikä näkymän. */
    /* Kaksi käyräkerrosta: 'contours' = kaikki käyrät, 'contours-thin' = joka toinen (20 m).
       JS vaihtaa näkyvyyden näkymän zoomin mukaan (karttaContourLod), koska tyylin zoom-lausekkeet
       katsovat tiilen zoomia. Näin käyräväli pysyy tasaisena zoomatessa eikä hyppää. */
    var contours = contourLayer('contours');
    var contoursThin = contourLayer('contours-thin', { filter: ['==', ['%', ['get', 'height'], 20], 0], layout: { 'line-join': 'round', visibility: 'none' } });
    /* Harvat maastomerkit: huiput, autiotuvat/laavut ja nuotiopaikat. icon-allow-overlap pois +
       reilu icon-padding → merkkejä tulee vain sen verran, että kartta elävöityy. */
    function markers(id, src, layer, filter, kind, minz, size) {
      return { id: id, type: 'symbol', source: src, 'source-layer': layer, filter: filter, minzoom: minz,
        layout: { 'icon-image': 'mark|' + kind + '|' + qb + '|' + color + '|' + sf.toFixed(2), 'icon-size': size, 'icon-padding': 14, 'icon-allow-overlap': false, 'symbol-avoid-edges': false } };
    }
    /* Lähelle zoomattaessa myös pikkutiet ja rakennukset → asiakas löytää oman mökkinsä. */
    var roadsNear = { id: 'roads-near', type: 'line', source: 'omtc', 'source-layer': 'transportation', minzoom: 10, filter: ['in', 'class', 'tertiary', 'minor', 'service', 'track'], paint: { 'line-color': color, 'line-width': 0.8 }, layout: { 'line-join': 'round' } };
    var buildingsT = { id: 'buildings-t', type: 'line', source: 'omtc', 'source-layer': 'building', minzoom: 11.5, paint: { 'line-color': color, 'line-width': 0.8 }, layout: { 'line-join': 'round' } };
    var peaks = markers('peaks', 'omt', 'mountain_peak', ['in', ['get', 'class'], ['literal', ['peak', 'volcano']]], 'peak', 8, 1.05);
    var huts = markers('huts', 'poib', 'poi', ['in', ['get', 'subclass'], ['literal', ['shelter', 'wilderness_hut', 'alpine_hut', 'hut', 'cabin', 'camp_site', 'lean_to']]], 'hut', 9, 1.0);
    var fires = markers('fires', 'poib', 'poi', ['in', ['get', 'subclass'], ['literal', ['firepit', 'fireplace', 'bbq', 'picnic_site', 'picnic_table']]], 'fire', 9, 1.0);
    /* Vaellusreitit ja isommat polut katkoviivalla (maasto) */
    var trails = { id: 'trails', type: 'line', source: 'omtc', minzoom: 10, 'source-layer': 'transportation', filter: ['in', 'class', 'path', 'track'], paint: { 'line-color': color, 'line-width': 0.9, 'line-dasharray': [2.4, 2.4] }, layout: { 'line-cap': 'butt' } };
    /* Maastossa isot tiet ovat ainoat tiet → ohuemmat kuin Kaupungissa, jottei kartta näytä paksulta. */
    var roadsBig = { id: 'roads-big', type: 'line', source: 'omt', 'source-layer': 'transportation', filter: ['in', 'class', 'motorway', 'trunk', 'primary', 'secondary'], paint: { 'line-color': color, 'line-width': 1.4 }, layout: { 'line-join': 'round' } };
    /* 26.9.2026: rakennukset ja urheilukentät pois kaupunkikartasta – kaupungeissa ne tekivät kaiverruksesta sekavan. */
    if (kind === 'city') L = [water, waterIcons, waterline, waterway, parks, cemetery, pier, runway, taxiway, small, paths, roadsSec, roads, rail];   /* kadunnimet pois: liikaa tavaraa kaiverrukseen */
    else if (kind === 'nature') L = [water, waterIcons, waterline, waterway, wood, parks, pitch, cemetery, pier, runway, taxiway, small, paths, roads];
    else L = [water, waterIcons, waterline, waterway, contours, contoursThin, trails, roadsNear, roadsBig, buildingsT, peaks, huts, fires];   /* maasto: käyrät + vesistöt + vaellusreitit + päätiet */
    if (kind === 'terrain') {
      /* Maasto piirretään huomattavasti ohuemmalla viivalla: käyrät ja rakennukset ovat siellä
         pääosassa, ja liian paksu viiva sulkee kuvion umpeen. */
      var THIN = { contours: 0.55, 'contours-thin': 0.55, trails: 0.6, 'roads-near': 0.6, 'roads-big': 0.7, 'buildings-t': 0.6, 'water-line': 0.7, waterway: 0.7, pier: 0.7, runway: 0.7 };
      L = L.map(function (l) {
        var f = THIN[l.id]; if (!f || !l.paint || l.paint['line-width'] === undefined) return l;
        var lw = l.paint['line-width'];
        l.paint = Object.assign({}, l.paint, { 'line-width': typeof lw === 'number' ? lw * f : ['*', lw, f] });
        return l;
      });
    }
    L = L.map(scaleWidths);
    if (!hq) karttaStyleTs = Object.assign({}, KT_BOOST);   /* vahti: millä tiilikoilla viivat kompensoitiin */
    return { version: 8, glyphs: 'https://api.maptiler.com/fonts/{fontstack}/{range}.pbf?key=' + KT_KEY, sources: { omt: { type: 'vector', url: KT_SRC }, omtb: { type: 'vector', url: KT_SRC }, omtc: { type: 'vector', url: KT_SRC } /* omtc: kaksi tasoa tarkempi → kaupungin katuristikko näkyviin jo kaukaa */, poib: { type: 'vector', url: KT_SRC } /* omtb: sama data, tileSize 256 ajonaikaisesti (karttaTileBoost) → kadut pykälää aiemmin; tileSize EI kelpaa tyyliin */, cont: { type: 'vector', url: KT_CONT }, contb: { type: 'vector', url: KT_CONT } /* contb: korkeuskäyrät yhtä tasoa tarkempina → puolet tiheämpi käyräväli (10 m tunturissa) */ }, layers: L };
  }
  /* Alalaidan sisältö: 'none' | 'coords' (karttamerkin koordinaatit automaattisesti) | 'text' (oma teksti). */
  function karttaCoords() {
    var map = st.kartta.map, ll = null;
    if (!st.kartta.center) return '';
    try {
      if (map && st.kartta.ready && lastBox) {
        var rect = canvas.getBoundingClientRect(), k = rect.width / W;   /* kartan vasen yläkulma = ikkunan (lastBox) vasen yläkulma */
        if (rect.width) ll = map.unproject([(RING.x - lastBox.x) * k, (RING.y - lastBox.y) * k]);
      }
    } catch (e) {}
    var lat = ll ? ll.lat : st.kartta.center[1], lng = ll ? ll.lng : st.kartta.center[0];
    return Math.abs(lat).toFixed(4) + '° ' + (lat >= 0 ? 'N' : 'S') + '   ' + Math.abs(lng).toFixed(4) + '° ' + (lng >= 0 ? 'E' : 'W');
  }
  function karttaText() { return st.kartta.mode === 'text' ? st.kartta.text.trim() : st.kartta.mode === 'coords' ? karttaCoords() : ''; }
  function karttaRect(box) {
    /* Kartan alue ikkunan sisällä: teksti varaa alalaidasta kaistan. */
    /* Kartta täyttää koko ikkunan; kuori piirretään päälle 'kovennettuna' (ks. hardPhone), joten
       kameralasin läpi ei kuulla ja kartta näkyy kaikkialla, mihin puhelinkuva jättää aukon. */
    var band = karttaText() ? Math.round(box.h * 0.11 * (KSIZE[st.kartta.size] || 1)) : 0;
    return { x: box.x, y: box.y, w: box.w, h: box.h - band, band: band };
  }
  var karttaLastGeom = '';
  function karttaKcss() { var rect = canvas.getBoundingClientRect(); if (rect.width) st.kartta.kcss = rect.width / W; return st.kartta.kcss || 0.5; }   /* piilossa (width 0) → viimeisin tunnettu, ei 0.5 */
  function karttaSf() { return Math.max(0.4, Math.min(1.6, karttaKcss() / 0.5)); }
  /* st.kartta.zoom on 'kanoninen' zoom (canvas näytettynä 50 % koossa). Pienemmässä kartta-elementissä
     karttaa loitonnetaan vastaavasti, jotta kuoreen tulee sama maantieteellinen alue kaikilla laitteilla. */
  function karttaZoomOff() { return Math.log2(karttaKcss() / 0.5); }
  function karttaPlace(box) {
    if (!karttaEl || !currentModel()) return;
    var rc = karttaRect(box), rect = canvas.getBoundingClientRect(), k = rect.width / W;
    if (!rect.width) return;
    /* Lähennetyssä tilassa canvasia siirretään ja skaalataan CSS-muunnoksella. Kartta ei ole canvasin
       sisällä, joten sen paikka lasketaan canvasin TODELLISESTA rectistä suhteessa korttiin → kartta
       pysyy ikkunan kohdalla myös zoomattuna (ja renderöityy tarkkana, ei venytettynä). */
    var cardEl = stage.querySelector('.lastu-k__stage-card'), cr = cardEl ? cardEl.getBoundingClientRect() : rect;
    var ox = rect.left - cr.left, oy = rect.top - cr.top;
    var geom = [rc.x, rc.y, rc.w, rc.h, k.toFixed(4), Math.round(ox), Math.round(oy)].join(',');
    if (geom === karttaLastGeom) return; karttaLastGeom = geom;
    var cs = getComputedStyle(canvas), rad = Math.round(Math.min(56, box.w * 0.14) * k);
    karttaEl.hidden = false; var zb0 = document.getElementById('lastu-k-map-zoom'); if (zb0) zb0.hidden = false;
    karttaEl.style.left = (ox + rc.x * k) + 'px'; karttaEl.style.top = (oy + rc.y * k) + 'px';
    karttaEl.style.width = (rc.w * k) + 'px'; karttaEl.style.height = (rc.h * k) + 'px';
    karttaEl.style.borderRadius = rad + 'px ' + rad + 'px ' + (rc.band ? '0 0' : rad + 'px ' + rad + 'px');
    if (!st.kartta.map) karttaInit(); else setTimeout(function () { var m = st.kartta.map; st.kartta.busy = true; try { m.resize(); try { m.setPixelRatio(karttaPr()); } catch (e) {} if (st.kartta.center) { var z = st.kartta.zoom + karttaZoomOff(); if (Math.abs(m.getZoom() - z) > 0.01) m.jumpTo({ center: st.kartta.center, zoom: z }); } } finally { st.kartta.busy = false; }   /* resize/jumpTo eivät saa muuttaa kanonista zoomia (moveend ohitetaan) */ var sf = karttaSf(), zo = karttaZoomOff(); if (Math.abs(sf - (st.kartta.sf || 1)) > 0.02 || Math.abs(zo - (st.kartta.zo || 0)) > 0.02) { karttaRestyle(); karttaTileBoostNow(m, true); } }, 0);
  }
  function karttaInit() {
    if (!window.maplibregl || st.kartta.map) { if (!window.maplibregl) setTimeout(function () { karttaLastGeom = ''; render(); }, 400); return; }
    /* WebGL-tarkistus (maplibregl.supported poistui v3:ssa) */
    try { var tc = document.createElement('canvas'); if (!(tc.getContext('webgl2') || tc.getContext('webgl'))) { showError(S.kartta_nomap); return; } } catch (e) { showError(S.kartta_nomap); return; }
    var mat = currentMaterial(), col = mat ? mat.color : '#D9C49C';
    karttaSyncTiles();
    var map = new maplibregl.Map({ container: karttaEl, style: karttaStyle(col, st.kartta.style, karttaSf(), karttaZoomOff()), center: st.kartta.center || [25.4711, 65.0123], zoom: st.kartta.center ? st.kartta.zoom + karttaZoomOff() : 4.2, attributionControl: false, preserveDrawingBuffer: true, trackResize: false /* koko hallitaan karttaPlacessa (busy-suoja), ettei automaattinen resize sotke kanonista zoomia */, dragRotate: false, pitchWithRotate: false, touchPitch: false, maxZoom: 18, minZoom: 3, fadeDuration: 0 });
    map.touchZoomRotate.disableRotation(); map.keyboard.disable();
    map.on('styleimagemissing', function (e) { karttaMakeImage(map, e.id); });
    /* Kartta luodaan usein ennen kuin esikatselukortti on lopullisessa koossaan (mobiilin mini→expand,
       desktopin siirto galleriaan). Silloin sf/zo on laskettu väärällä koolla ja viivat ovat liian
       paksut, kunnes jokin zoomaus laukaisee restylen. Synkataan heti kun kartta on valmis. */
    function karttaSyncScale() {
      var sf = karttaSf(), zo = karttaZoomOff();
      if (Math.abs(sf - (st.kartta.sf || 1)) > 0.02 || Math.abs(zo - (st.kartta.zo || 0)) > 0.02) { karttaRestyle(); karttaTileBoostNow(map, true); }
    }
    map.on('load', function () { st.kartta.ready = true; setTimeout(karttaSyncScale, 60); setTimeout(karttaSyncScale, 700); karttaFlatCheck(); karttaContourLod(); var zb = document.getElementById('lastu-k-map-zoom'); if (zb) zb.hidden = false; render(); });
    map.on('idle', function () { karttaGuard(map); });
    map.on('moveend', function () { if (st.kartta.busy) return; var c = map.getCenter(); if (st.kartta.center) { st.kartta.center = [c.lng, c.lat]; st.kartta.zoom = map.getZoom() - karttaZoomOff(); karttaSyncInputs(); scheduleSave(); if (st.kartta.mode === 'coords') render(); } karttaContourLod(); karttaFlatCheck(); });
    /* Esikatselu on pieni (mobiilissa ~125 px) → ohuet viivat jäisivät MapLibren minimileveyden
       (1 laitepikseli) alle ja sulautuisivat möykyksi. Nostetaan kartan pikselitiheyttä. */
    try { map.setPixelRatio(karttaPr()); } catch (e) {}
    st.kartta.sf = karttaSf(); st.kartta.zo = karttaZoomOff(); st.kartta.map = map; window.__lastuMap = map;
    karttaEnsureImages(map, col, st.kartta.sf, false); karttaKickPatterns(map); karttaTileBoost(map);
  }
  /* Kuvioiden esirekisteröinti heti tyylin asettamisen jälkeen: styleimagemissing ei aina ehdi
     ennen tiilien parsintaa (toinen kuvio jäi piirtymättä). */
  /* MapLibre-omituisuus: fill-pattern-kerrokset jäävät joskus tyhjiksi, kun tiilet parsitaan ennen kuin
     kuvio on atlaksessa (myös vaikka kuva on jo lisätty). Varma kikka: vaihdetaan kerrosten näkyvyys
     kerran tyylin latauduttua → tiilet parsitaan uudelleen kuvion kanssa. cb kutsutaan lopuksi. */
  function karttaKickPatterns(map, cb) {
    var ids = ['water', 'water-icons'];
    function kick() {
      try { ids.forEach(function (i) { if (map.getLayer(i)) map.setLayoutProperty(i, 'visibility', 'none'); }); } catch (e) {}
      requestAnimationFrame(function () { try { ids.forEach(function (i) { if (map.getLayer(i)) map.setLayoutProperty(i, 'visibility', 'visible'); }); } catch (e) {} if (cb) cb(); });
    }
    if (map.isStyleLoaded()) kick(); else map.once('style.load', kick);
  }
  /* Kadut pykälää aiemmin: MapLibre valitsee tiilitason lähteen tileSize:n mukaan (512 → floor(zoom)).
     tileSize ei ole sallittu vektorilähteen tyylissä (koko tyyli hylättäisiin), mutta ajonaikaisesti
     asetettuna 256 → ladataan yhtä tasoa tarkemmat tiilet (floor(zoom+1)) → pienet kadut näkyvät
     jo zoomista 12. Tehdään joka tyylin latauksen jälkeen (setStyle luo lähteen uudelleen). */
  /* Boostatut lähteet: pienempi tileSize → MapLibre lataa tarkemman zoom-tason tiilet.
     omtb: kadut pykälää aiemmin. contb: korkeuskäyrät kolme tasoa tiheämmin (z11 näyttää z14-datan = 10 m väli). */
  /* Boostatut lähteet: kuinka monta zoom-tasoa TARKEMPAA dataa halutaan KANONISEEN zoomiin nähden.
     tileSize lasketaan esikatselun koon mukaan (karttaTileSizes), jotta kartan yksityiskohtien määrä
     on sama minissä, normaalissa, lähennetyssä ja tuotanto-PNG:ssä. */
  /* Esikatselun kartta renderöidään aina n. 1600 px leveänä riippumatta kortin koosta: MapLibren
     minimiviivanleveys on yksi laitepikseli, joten pienessä kortissa ohuet viivat sulautuisivat yhteen. */
  function karttaPr() {
    var el = karttaEl && karttaEl.getBoundingClientRect(), w = el && el.width ? el.width : 200;
    return Math.max(2, Math.min(16, 1600 / w));   /* 7.10.2026: katto 10 → 16: mobiilin mini-kortti (~120 px) renderöityi 1190 px:nä → reunapehmennys paksunsi viivoja suhteessa */
  }
  var KT_LEVEL = { omt: 0, cont: 0, omtb: 1, omtc: 2, contb: 2, poib: 3 };
  var KT_BOOST = { omt: 512, cont: 512, omtb: 256, omtc: 128, contb: 128, poib: 64 };   /* nykyiset tileSizet, päivitetään karttaTileSizes():ssa */
  function karttaTileSizes(zo) {
    /* Tuotannon aikana aina kanoninen (zo 0) → myös style.load-käsittelijä antaa lähteille kanoniset koot. */
    if (typeof zo !== 'number') zo = st.kartta.prod ? 0 : karttaZoomOff();
    var out = {};
    Object.keys(KT_LEVEL).forEach(function (id) {
      var need = KT_LEVEL[id] - zo;                       /* log2(512 / tileSize) */
      /* TARKKA tileSize (ei kahden potenssiin pyöristettyä): näin tiilizoom on täsmälleen
         kanoninen + taso jokaisella esikatselun koolla → kartan sisältö ei muutu Lähennä/Pienennä-napista. */
      var ts = Math.round(512 / Math.pow(2, need));
      out[id] = Math.max(32, Math.min(512, ts));
    });
    return out;
  }   /* contb 64 = kolme tasoa tarkemmat käyrät (lähteen maksimi z14 = 10 m väli) */
  function karttaTileBoostNow(map, skipRestyle) {
    try {
      var boosted = false, want = karttaTileSizes();
      Object.keys(want).forEach(function (id) {
        KT_BOOST[id] = want[id];
        var src = map.getSource(id); if (src && src.tileSize !== want[id]) { src.tileSize = want[id]; boosted = true; karttaReloadSource(map, id); }
      });
      if (boosted) {
        /* Viivanleveydet ja zoom-portaat on laskettu tileSizen mukaan → tyyli on päivitettävä samalla,
           muuten viivat ovat 2–4× liian paksut (näkyi Maastossa ja ensinäkymässä). */
        if (!skipRestyle) karttaRestyle(); else map.jumpTo({ center: map.getCenter(), zoom: map.getZoom() });
      }
    } catch (e) {}
  }
  function karttaTileBoost(map) {
    function apply() {
      try {
        var boosted = false, want = karttaTileSizes();
        Object.keys(want).forEach(function (id) {
          KT_BOOST[id] = want[id];
          var src = map.getSource(id); if (src && src.tileSize !== want[id]) { src.tileSize = want[id]; boosted = true; karttaReloadSource(map, id); }
        });
        if (boosted) map.jumpTo({ center: map.getCenter(), zoom: map.getZoom() });
      } catch (e) {}
    }
    map.on('style.load', apply); if (map.isStyleLoaded()) apply();
  }
  function karttaEnsureImages(map, color, sf, hq) {
    var stl; try { stl = karttaStyle(color, 'city', sf, 0, hq); } catch (e) { return; }
    stl.layers.forEach(function (l) { var pat = (l.paint && l.paint['fill-pattern']) || (l.layout && l.layout['icon-image']); if (typeof pat === 'string') karttaMakeImage(map, pat); });
    try { karttaStyle(color, 'terrain', sf, 0, hq).layers.forEach(function (l) { var ic = l.layout && l.layout['icon-image']; if (typeof ic === 'string') karttaMakeImage(map, ic); }); } catch (e) {}
  }
  /* Maastomerkit (huippu, autiotupa/laavu, nuotiopaikka) piirretään canvasilla samalla tyylillä kuin
     veneet: ohut ääriviiva + täyttö, jotta ne kaivertuvat selvästi. */
  function karttaMarkerImage(map, id) {
    var m = /^mark\|(\w+)\|(\d+)\|(.+)\|([\d.]+)$/.exec(id); if (!m) return false;
    var kind = m[1], Q = parseInt(m[2], 10) || 8, col = m[3], f = parseFloat(m[4]) || 1, T = 26;
    var c = document.createElement('canvas'); c.width = T * Q; c.height = T * Q;
    var x = c.getContext('2d'); x.scale(Q, Q); x.fillStyle = col; x.strokeStyle = col; x.lineWidth = 1.5; x.lineJoin = 'round'; x.lineCap = 'round';
    if (kind === 'peak') {           /* tunturin huippu: täytetty kolmio */
      x.beginPath(); x.moveTo(13, 5); x.lineTo(20, 18); x.lineTo(6, 18); x.closePath(); x.fill();
    } else if (kind === 'hut') {     /* autiotupa / laavu: harjakattoinen mökki */
      x.beginPath(); x.moveTo(13, 5); x.lineTo(21, 13); x.lineTo(19, 13); x.lineTo(19, 20); x.lineTo(7, 20); x.lineTo(7, 13); x.lineTo(5, 13); x.closePath(); x.fill();
      x.save(); x.globalCompositeOperation = 'destination-out'; x.fillRect(11, 14, 4, 6); x.restore();
    } else if (kind === 'fire') {    /* nuotiopaikka: liekki + halot */
      x.beginPath(); x.moveTo(13, 4); x.quadraticCurveTo(18, 10, 15, 14); x.quadraticCurveTo(13, 11, 13, 9); x.quadraticCurveTo(11, 12, 11.5, 14); x.quadraticCurveTo(8, 10, 13, 4); x.closePath(); x.fill();
      x.beginPath(); x.moveTo(5, 21); x.lineTo(21, 17); x.moveTo(5, 17); x.lineTo(21, 21); x.stroke();
    } else return false;
    map.addImage(id, x.getImageData(0, 0, T * Q, T * Q), { pixelRatio: Q / f });
    return true;
  }
  function karttaMakeImage(map, id) {
    try { if (map.hasImage(id)) return; } catch (e) { return; }
    if (karttaMarkerImage(map, id)) return;
      var mb = /^boats\|(\d+)\|(.+)\|([\d.]+)$/.exec(id);
      if (mb) {
        /* 120 px ruutu, 3 pientä viivaikonia epäsäännöllisissä kohdissa → näyttää satunnaiselta */
        var colB = mb[2], fB = parseFloat(mb[3]) || 1, TB = 120, QB = parseInt(mb[1], 10) || 8, cb = document.createElement('canvas'); cb.width = TB * QB; cb.height = TB * QB; var g = cb.getContext('2d'); g.scale(QB, QB);
        g.fillStyle = colB; g.strokeStyle = colB; g.lineCap = 'round'; g.lineJoin = 'round';
        function halo() {}
        function sail(x0, y0) {   /* purjevene: täytetty runko + purje, masto viivana */
          g.beginPath(); g.moveTo(x0 - 8, y0 + 3); g.lineTo(x0 + 8, y0 + 3); g.lineTo(x0 + 5.5, y0 + 7); g.lineTo(x0 - 5.5, y0 + 7); g.closePath(); g.fill();
          g.lineWidth = 1.2; g.beginPath(); g.moveTo(x0 - 0.5, y0 + 3); g.lineTo(x0 - 0.5, y0 - 9); g.stroke();
          g.beginPath(); g.moveTo(x0 + 0.8, y0 - 8.5); g.lineTo(x0 + 7.5, y0 + 1); g.lineTo(x0 + 0.8, y0 + 1); g.closePath(); g.fill();
          g.beginPath(); g.moveTo(x0 - 1.8, y0 - 6); g.lineTo(x0 - 6, y0 + 1); g.lineTo(x0 - 1.8, y0 + 1); g.closePath(); g.fill();
        }
        function fish(x0, y0) {   /* kala: täytetty runko + pyrstö, silmä tyhjänä */
          g.beginPath(); g.moveTo(x0 - 7, y0); g.quadraticCurveTo(x0 - 1, y0 - 6, x0 + 5, y0); g.quadraticCurveTo(x0 - 1, y0 + 6, x0 - 7, y0); g.closePath(); g.fill();
          g.beginPath(); g.moveTo(x0 + 4, y0); g.lineTo(x0 + 9, y0 - 4); g.lineTo(x0 + 9, y0 + 4); g.closePath(); g.fill();
          g.save(); g.globalCompositeOperation = 'destination-out'; g.beginPath(); g.arc(x0 - 4, y0 - 1.2, 1, 0, Math.PI * 2); g.fill(); g.restore();
        }
        function row(x0, y0) {   /* soutuvene: täytetty runko + kaksi airoa */
          g.beginPath(); g.moveTo(x0 - 8, y0); g.lineTo(x0 + 8, y0); g.quadraticCurveTo(x0 + 6, y0 + 6, x0, y0 + 6); g.quadraticCurveTo(x0 - 6, y0 + 6, x0 - 8, y0); g.closePath(); g.fill();
          g.lineWidth = 1.4; g.beginPath(); g.moveTo(x0 - 2, y0 - 1); g.lineTo(x0 - 10, y0 - 7); g.moveTo(x0 + 2, y0 - 1); g.lineTo(x0 + 10, y0 - 7); g.stroke();
        }
        function icon(fn, x0, y0, sc) { g.save(); g.translate(x0, y0); g.scale(sc, sc); g.lineWidth = 1.5 / sc; fn(0, 0); g.restore(); }
        icon(sail, 26, 34, 0.95); icon(fish, 88, 92, 0.95);   /* purjevene + kala (soutuvene poistettu) */
        map.addImage(id, g.getImageData(0, 0, TB * QB, TB * QB), { pixelRatio: QB / fB });
        return;
      }
      var m = /^wave\|(\d+)\|(.+)\|([\d.]+)$/.exec(id); if (!m) return;
      /* Tiheä, pieni pisterasteri (≈12 % peitto, lomittain) → kaivertuu kevyenä 'harmaana' sävynä, ei umpinaisena. */
      var col = m[2], f = parseFloat(m[3]) || 1, T = 4, Q = parseInt(m[1], 10) || 24, c = document.createElement('canvas'); c.width = T * Q; c.height = T * Q; var x = c.getContext('2d'); x.scale(Q, Q);   /* 16× tarkkuus tuotantoa varten */
      x.fillStyle = col;
      x.beginPath(); x.arc(1, 1, 0.55, 0, Math.PI * 2); x.fill();
      x.beginPath(); x.arc(3, 3, 0.55, 0, Math.PI * 2); x.fill();   /* kaksi lyhyttä aaltoa/ruutu, lomittain */
      map.addImage(id, x.getImageData(0, 0, T * Q, T * Q), { pixelRatio: Q / f });
  }
  /* Maasto tasaisella maalla: käyriä ei yksinkertaisesti ole. Kerrotaan se asiakkaalle
     sen sijaan, että kuori näyttäisi rikkinäiseltä. */
  var karttaFlatTimer = null;
  function karttaFlatCheck() {
    var el = $('[data-kartta-flat]'); if (!el) return;
    clearTimeout(karttaFlatTimer);
    karttaFlatTimer = setTimeout(function () {
      var map = st.kartta.map, few = false;
      if (map && st.kartta.style === 'terrain' && st.kartta.center) {
        try { few = map.queryRenderedFeatures({ layers: ['contours'] }).length < 4; } catch (e) { few = false; }
      }
      el.hidden = !few;
    }, 900);
  }
  /* Näkymän zoom 12–13: tiilet ovat z14 (10 m käyräväli) mutta alue on laaja → käyriä tulee liikaa.
     Käytetään silloin harvennettua kerrosta, jolloin väli pysyy 20 metrissä. */
  function karttaContourLod() {
    var map = st.kartta.map; if (!map || st.kartta.style !== 'terrain') return;
    try {
      if (!map.getLayer('contours') || !map.getLayer('contours-thin')) return;
      var z = map.getZoom(), thin = z >= 11.9 && z < 13.0;
      map.setLayoutProperty('contours', 'visibility', thin ? 'none' : 'visible');
      map.setLayoutProperty('contours-thin', 'visibility', thin ? 'visible' : 'none');
    } catch (e) {}
  }
  /* 26.9.2026 (iPhone): tileSize-muutos ei yksin riitä – jo ladatut tiilet jäävät piirtymään vanhan
     koon viivoilla (oletusnäkymä näytti paksummalta kuin +/−-zoomauksen jälkeen). Tiili muistaa
     latauksen aikaisen tileSizen (pixelsToTileUnits) → reload() ei riitä, tiilet tyhjennetään ja haetaan uudelleen. */
  function karttaReloadSource(map, id) {
    try { var sc = map.style && map.style.sourceCaches && map.style.sourceCaches[id]; if (sc && typeof sc.clearTiles === 'function') { sc.clearTiles(); if (typeof sc.update === 'function' && map.transform) sc.update(map.transform); } } catch (e) {}
    try { map.triggerRepaint(); } catch (e) {}
  }
  function karttaSyncTiles() { var w = karttaTileSizes(); Object.keys(w).forEach(function (id) { KT_BOOST[id] = w[id]; }); return w; }
  function karttaRestyle() {
    var map = st.kartta.map; if (!map) return;
    var mat = currentMaterial(), col = mat ? mat.color : '#D9C49C';
    st.kartta.sf = karttaSf(); st.kartta.zo = karttaZoomOff(); var wantR = karttaSyncTiles();
    map.setStyle(karttaStyle(col, st.kartta.style, st.kartta.sf, st.kartta.zo), { diff: true });
    /* HUOM: tileSize on asetettava VASTA setStylen jälkeen – diff luo lähteet uudelleen tyylin
       oletuskoolla (512), jolloin viivanleveydet olisivat hetken 2–4× liian paksut. */
    function applyTs() { Object.keys(wantR).forEach(function (id) { var sr = map.getSource(id); if (sr && sr.tileSize !== wantR[id]) { sr.tileSize = wantR[id]; karttaReloadSource(map, id); } }); }
    applyTs(); map.once('styledata', applyTs); setTimeout(applyTs, 120);   /* diff:true → tiilet säilyvät, kartta ei välky */ karttaEnsureImages(map, col, st.kartta.sf, false); karttaKickPatterns(map); karttaContourLod(); karttaFlatCheck();
  }
  function karttaSyncInputs() {
    var pl = $('input[data-kartta-place]'), co = $('input[data-kartta-coords]');
    if (pl) pl.value = st.kartta.place || st.kartta.q; if (co && st.kartta.center) co.value = st.kartta.center[1].toFixed(5) + ', ' + st.kartta.center[0].toFixed(5);
    setStatus('kartta', st.kartta.center ? (st.kartta.place || S.kartta_status).split(',')[0].slice(0, 26) : null);
    if (hintIcon) { var wasH = hintIcon.hidden; hintIcon.hidden = !st.kartta.center; if (wasH && !hintIcon.hidden) hintNudge(); }   /* sormisäätöohje kun kartta on valittu */
  }
  function karttaGoto(f) {
    st.kartta.place = f.place_name || f.text || ''; st.kartta.center = [f.center[0], f.center[1]];
    /* 26.9.2026: oletukset yhden +-klikkauksen (zoom +1) verran lähempänä kaikissa karttatuotteissa. */
    var bbox = f.bbox, z = 15.5;
    if (f.place_type && /country|region|state/.test(f.place_type[0])) z = 7; else if (f.place_type && /municipality|county|city|place/.test(f.place_type[0]) && bbox) z = 12.5; else if (f.place_type && /locality|neighbourhood|postal/.test(f.place_type[0])) z = 14;
    st.kartta.zoom = z;
    if (st.kartta.map) st.kartta.map.jumpTo({ center: st.kartta.center, zoom: z + karttaZoomOff() });
    karttaSyncInputs(); render(); scheduleSave();
    if (isMobile() && stage.getAttribute('data-state') === 'mini') setStage('expand');
  }
  var karttaTimer = null, karttaAbort = null;
  function karttaFitList() {
    if (!karttaListBox || karttaListBox.hidden || !karttaSearch) return;
    var vv = window.visualViewport, h = vv ? vv.height : window.innerHeight;
    var top = karttaListBox.getBoundingClientRect().top;
    karttaListBox.style.maxHeight = Math.max(150, Math.round(h - top - 12)) + 'px';   /* mahtuu näppäimistön yläpuolelle */
  }
  function karttaShowList(on) {
    if (karttaListBox) karttaListBox.hidden = !on;
    if (karttaList) karttaList.hidden = false;
    if (on) { karttaFitList(); setTimeout(karttaFitList, 320); }
  }
  if (window.visualViewport) window.visualViewport.addEventListener('resize', function () { karttaFitList(); });
  function karttaSuggest(q) {
    if (!karttaList) return;
    if (!q || q.length < 2) { karttaShowList(false); karttaList.innerHTML = ''; return; }
    if (karttaAbort) karttaAbort.abort(); karttaAbort = new AbortController();
    var url = 'https://api.maptiler.com/geocoding/' + encodeURIComponent(q) + '.json?key=' + KT_KEY + '&autocomplete=true&limit=5&language=' + (lang === 'en' ? 'en' : 'fi') + '&proximity=25.47,65.01';
    fetch(url, { signal: karttaAbort.signal }).then(function (r) { return r.json(); }).then(function (d) {
      var f = (d.features || []).slice(0, 5); karttaList.innerHTML = '';
      f.forEach(function (ft) {
        var li = document.createElement('li'); var parts = (ft.place_name || '').split(', ');
        li.innerHTML = '<span></span><small></small>'; li.firstChild.textContent = parts[0]; li.lastChild.textContent = parts.slice(1).join(', ');
        li.addEventListener('mousedown', function (e) { e.preventDefault(); karttaSearch.value = ft.place_name || ''; st.kartta.q = karttaSearch.value; karttaShowList(false); karttaSearch.blur();   /* näppäimistö kiinni → esikatselu takaisin ja sivu samaan kohtaan */ karttaGoto(ft); });
        karttaList.appendChild(li);
      });
      karttaShowList(!!f.length);
    }).catch(function () {});
  }
  /* Kuorikuvan kameralasi on PNG:ssä osittain läpinäkyvä → kartta kuultaisi läpi. Kovennus: ikkunan
     yläosassa (box.y … safeY) kaikki pikselit, joilla alfa ≥ 10, tehdään täysin peittäviksi. Ikkunan
     aukko (alfa < 10) pysyy läpinäkyvänä, joten kartta näkyy kameran vierestäkin. */
  var hardCache = {};
  function hardPhone(img, url, box) {
    if (hardCache[url]) return hardCache[url];
    try {
      var c = document.createElement('canvas'); c.width = W; c.height = H; var x = c.getContext('2d', { willReadFrequently: true });
      x.drawImage(img, 0, 0, W, H);
      /* Koko ikkuna-alue (myös kameraneliö keskellä, esim. iPhone Pro Max): vain ikkunan sisäpuoli x-suunnassa. */
      var y0 = Math.max(0, box.y - 4), y1 = Math.min(H, box.y + box.h + 4), h = y1 - y0, x0 = Math.max(0, box.x - 4), w = Math.min(W - x0, box.w + 8);
      if (h > 0) {
        var id = x.getImageData(x0, y0, w, h), d = id.data;
        for (var i = 3; i < d.length; i += 4) if (d[i] >= 10 && d[i] < 255) d[i] = 255;
        x.putImageData(id, x0, y0);
      }
      hardCache[url] = c; return c;
    } catch (e) { return img; }
  }
  function drawCompass(x, box, rc, k, color, rel) {   /* rel: koordinaatit ikkunan (box) suhteen (tuotanto-PNG) */
    var r = box.w * 0.062, top = Math.max(box.y, box.safeYR || box.safeY || box.y), cx = (box.x + box.w - box.w * 0.07 - r), cy = (top + box.w * 0.08 + r);
    if (cy + r > rc.y + rc.h - box.w * 0.05) return;
    if (rel) { cx = (cx - box.x) * k; cy = (cy - box.y) * k; r *= k; }
    x.save(); x.strokeStyle = color; x.fillStyle = color; x.lineWidth = Math.max(1, r * 0.11); x.lineJoin = 'round';
    /* pohjoiskärki täytetty, etelä ääriviivana */
    x.beginPath(); x.moveTo(cx, cy - r); x.lineTo(cx + r * 0.28, cy); x.lineTo(cx - r * 0.28, cy); x.closePath(); x.fill();
    x.beginPath(); x.moveTo(cx, cy + r); x.lineTo(cx + r * 0.28, cy); x.lineTo(cx - r * 0.28, cy); x.closePath(); x.stroke();
    /* itä–länsi pienempinä */
    x.beginPath(); x.moveTo(cx - r * 0.75, cy); x.lineTo(cx, cy - r * 0.18); x.lineTo(cx, cy + r * 0.18); x.closePath(); x.stroke();
    x.beginPath(); x.moveTo(cx + r * 0.75, cy); x.lineTo(cx, cy - r * 0.18); x.lineTo(cx, cy + r * 0.18); x.closePath(); x.stroke();
    x.beginPath(); x.arc(cx, cy, r * 0.12, 0, Math.PI * 2); x.fill();
    x.font = '400 ' + Math.round(r * 0.8) + 'px "Bebas Neue", Impact, sans-serif'; x.textAlign = 'center'; x.textBaseline = 'bottom'; x.fillText('N', cx, cy - r * 1.08);
    x.restore();
  }
  function drawKarttaTop(box) {
    var mat = currentMaterial(), col = mat ? mat.color : '#D9C49C', rc = karttaRect(box);
    /* Nasta keskipisteeseen */
    if (st.kartta.pin && st.kartta.center) {
      var cx = RING.x, cy = RING.y, r = Math.round(box.w * 0.055);
      octx.save(); octx.fillStyle = col; octx.beginPath(); octx.arc(cx, cy - r * 1.3, r, Math.PI * 0.8, Math.PI * 2.2); octx.lineTo(cx, cy + r * 0.9); octx.closePath(); octx.fill();
      octx.globalCompositeOperation = 'destination-out'; octx.beginPath(); octx.arc(cx, cy - r * 1.3, r * 0.42, 0, Math.PI * 2); octx.fill(); octx.restore();
    }
    /* Pohjoisnuoli oikeaan yläkulmaan (kameran alapuolelle: box.safeY) */
    if (st.kartta.center) drawCompass(octx, box, rc, 1, col, false);
    /* Alalaidan teksti kaistaan */
    var ktxt = karttaText();
    if (rc.band && ktxt) {
      var t = st.kartta.textLayer || (st.kartta.textLayer = { value: '', font: '', maskCanvas: null, align: 'center' });
      /* Puukuorten karttapersonoinnissa alalaidan teksti lihavoidaan (Bebasissa ei ole semiboldia);
         KARTTA-tuotteessa pidetään alkuperäinen ohuempi leikkaus. */
      t.bold = KARTTA_ADDON && !KARTTA_MODE;
      /* 26.9.2026: hieman lisää kirjainväliä Bebasille (kaikki karttatuotteet). */
      var ktr = st.kartta.font === 'poster' ? 0.06 : 0;
      if (t.value !== ktxt || t.font !== st.kartta.font || t.tracking !== ktr) { t.tracking = ktr; t.value = ktxt; t.font = st.kartta.font; buildText(t); }
      if (t.maskCanvas) {
        var maxW = box.w * 0.84, maxH = rc.band * (st.kartta.font === 'poster' ? 0.8 : 0.62), sc = Math.min(maxW / t.maskCanvas.width, maxH / t.maskCanvas.height);
        t.tf = { x: 0.5, y: (rc.y - box.y + rc.h + rc.band / 2) / box.h, s: (t.maskCanvas.width * sc) / box.w, r: 0 };
        var w = box.w * t.tf.s, h = w * t.maskCanvas.height / t.maskCanvas.width;
        octx.drawImage(t.maskCanvasTinted(col), box.x + box.w * t.tf.x - w / 2, box.y + box.h * t.tf.y - h / 2, w, h);
      }
    }
    /* Rengas, kuori, lisäosat kartan päälle */
    var model = currentModel(), addonIdx = st.magsafe ? Object.keys(st.addons).filter(function (i) { return !kripSkip(i); }) : [], addonImgs = addonIdx.map(function (i) { return D.addons[i].img; });
    Promise.all([loadImage(model ? model.img : ''), loadImage(st.magsafe ? (D.consts.magsafeImg || '') : '')].concat(addonImgs.map(loadImage))).then(function (im) {
      if (st.magsafe) { if (im[1]) accDraw(octx, im[1]); }
      if (im[0]) octx.drawImage(hardPhone(im[0], model.img, box), 0, 0, W, H);
      im.slice(2).forEach(function (o, j) { if (o) accDraw(octx, o, D.addons[addonIdx[j]].type === 'karb'); });
    });
  }
  /* Esikatselukuva koriin: canvas + kartan GL-canvas + overlay. */
  function karttaComposite(target) {
    var x = target.getContext('2d'); x.drawImage(canvas, 0, 0, W, H);
    var map = st.kartta.map; if (map && st.kartta.ready) {
      var rc = karttaRect(boxNow()), gl = map.getCanvas();
      x.save(); roundRect(x, rc.x, rc.y, rc.w, rc.h, Math.min(56, boxNow().w * 0.14)); x.clip(); x.drawImage(gl, rc.x, rc.y, rc.w, rc.h); x.restore();
    }
    x.drawImage(overlay, 0, 0, W, H);
  }
  /* Tuotanto: NÄKYVÄ kartta nostetaan hetkeksi 4× pixelRatioon (renderöityy varmasti, koska
     on ruudulla), canvas kopioidaan, viivat mustataan alfan perusteella (source-in) ja
     pixelRatio palautetaan. Ikkunan kokoinen PNG: kartta + nasta + alalaidan teksti. */
  function karttaProductionPng() {
    return new Promise(function (res) {
      var map = st.kartta.map; if (!map || !st.kartta.center || !st.kartta.ready) return res(null);
      var box = boxNow(), rc = karttaRect(box), k = 4, done = false, orig = window.devicePixelRatio || 1;
      /* Tuotanto riippumatta kartta-elementin näyttökoosta (mobiilissa mini-tilassa ~60 px!):
         pixelRatio nostetaan niin, että GL-canvas on aina box.w×4 px leveä, ja tyyli skaalataan
         TARKALLA sf:llä (ei näyttöä varten rajatulla) → viivat/tekstit samassa suhteessa kuoreen. */
      /* Tuotanto aina KANONISESSA geometriassa: kartta-elementti asetetaan hetkeksi 50 %-kokoon
         (rc.w×0.5 CSS-px), zoom kanoniseksi, tyyli sf=1/zo=0 ja pixelRatio 8 → GL-canvas = box.w×4 px.
         Näin tuotanto-PNG on identtinen laitteesta ja esikatselun koosta riippumatta (mobiilin
         mini-tila olisi muuten 60 px leveä ja tiilidata puuttuisi). Lopuksi palautetaan. */
      st.kartta.busy = true; st.kartta.prod = true; var pr = 8, saved = { w: karttaEl.style.width, h: karttaEl.style.height }, matP = currentMaterial(), colP = matP ? matP.color : '#D9C49C';
      function finish(png) {
        if (done) return; done = true;
        try {
          karttaEl.style.width = saved.w; karttaEl.style.height = saved.h; map.resize(); map.setPixelRatio(karttaPr());
          st.kartta.prod = false;
          karttaRestyle();   /* sama polku kuin tavallinen tyylinvaihto (tiilikoot synkassa tyylin kanssa) */
          map.jumpTo({ center: st.kartta.center, zoom: st.kartta.zoom + karttaZoomOff() });
        } catch (e) {}
        st.kartta.busy = false;
        res(png);
      }
      var capture = null, timer = setTimeout(function () { window.__lastuProdDbg = { timeout: true, style: map.isStyleLoaded(), tiles: map.areTilesLoaded() }; try { capture(); } catch (e) { log('kartta tuotanto', e); finish(null); } }, 15000);   /* aikakatkaisu: otetaan mitä on */
      try {
        var zC = st.kartta.zoom, cC = st.kartta.center;
        karttaEl.style.width = (rc.w * 0.5) + 'px'; karttaEl.style.height = (rc.h * 0.5) + 'px';
        /* 7.10.2026 KORJAUS (mobiilissa kaiverrusviivat ~2× paksut): tyyli laskettiin kanonisilla tiilikoilla, mutta
           diff:false-tyylinvaihdon jälkeen style.load-käsittelijä antoi lähteille NÄYTÖN tiilikoot → viivakompensointi ei
           vastannut tiiliä. Nyt: tiilikoot lukittu kanonisiin (st.kartta.prod), diff:true säilyttää lähteet ja koot
           asetetaan tyylin jälkeen kuten karttaRestylessa. */
        var wantP = karttaTileSizes(0); Object.keys(wantP).forEach(function (id) { KT_BOOST[id] = wantP[id]; });
        /* diff:true: lähteet ja niiden tiilikoot säilyvät (diff:false loi lähteet uudelleen → style.load-käsittelijä vaihtoi
           tiilikoon ja tyhjensi tiilet kesken latauksen → tiiliä jäi joskus pysyvästi lataukseen ja tuotanto aikakatkaistiin). */
        map.setStyle(karttaStyle(colP, st.kartta.style, 1, 0, true), { diff: true }); karttaEnsureImages(map, colP, 1, true);
        var applyP = function () { Object.keys(wantP).forEach(function (id) { var sp = map.getSource(id); if (sp && sp.tileSize !== wantP[id]) { sp.tileSize = wantP[id]; karttaReloadSource(map, id); } }); };
        applyP(); map.once('styledata', applyP); setTimeout(applyP, 120);
        map.setPixelRatio(pr); map.resize(); map.jumpTo({ center: cC, zoom: zC }); map.triggerRepaint();
        capture = function () {
          try {
            var gl = map.getCanvas(), c = document.createElement('canvas'); c.width = Math.round(box.w * k); c.height = Math.round(box.h * k); var x = c.getContext('2d');
            x.drawImage(gl, 0, 0, gl.width, gl.height, 0, Math.round((rc.y - box.y) * k), Math.round(rc.w * k), Math.round(rc.h * k));
            x.globalCompositeOperation = 'source-in'; x.fillStyle = '#000000'; x.fillRect(0, 0, c.width, c.height); x.globalCompositeOperation = 'source-over';
            if (st.kartta.pin) { var cx = (RING.x - box.x) * k, cy = (RING.y - box.y) * k, r = Math.round(box.w * 0.055) * k; x.fillStyle = '#000'; x.beginPath(); x.arc(cx, cy - r * 1.3, r, Math.PI * 0.8, Math.PI * 2.2); x.lineTo(cx, cy + r * 0.9); x.closePath(); x.fill(); x.globalCompositeOperation = 'destination-out'; x.beginPath(); x.arc(cx, cy - r * 1.3, r * 0.42, 0, Math.PI * 2); x.fill(); x.globalCompositeOperation = 'source-over'; }
            drawCompass(x, box, rc, k, '#000000', true);
            var t = st.kartta.textLayer; if (rc.band && t && t.maskCanvas && t.tf) { var w = c.width * t.tf.s, h = w * t.maskCanvas.height / t.maskCanvas.width; x.drawImage(t.maskCanvasTinted('#000000'), c.width * t.tf.x - w / 2, c.height * t.tf.y - h / 2, w, h); }
            /* Tekstikaiverrus (kartta personointina puukuoressa) samaan tuotantotiedostoon (23.9.2026). */
            liveTexts().forEach(function (tt) { if (!tt.tf) return; var tw = c.width * tt.tf.s, th = tw * tt.maskCanvas.height / tt.maskCanvas.width; x.save(); x.translate(c.width * tt.tf.x, c.height * tt.tf.y); x.rotate(tt.tf.r); x.drawImage(tt.maskCanvasTinted('#000000'), -tw / 2, -th / 2, tw, th); x.restore(); });
            clearTimeout(timer); finish(c.toDataURL('image/png'));
          } catch (e) { log('kartta tuotanto', e); clearTimeout(timer); finish(null); }
        };
        /* Odotetaan, että tyyli JA uuden zoomin tiilet ovat ladattu (idle voisi laueta vanhoilla tiilillä). */
        /* diff:true ei laukaise style.loadia → kuvioiden potkaisu erikseen ja valmiuden odotus suoraan pollaten
           (idle saattoi laueta ennen kuuntelijaa). Pieni viive, jotta tiilikokojen vaihto ehtii käynnistää latauksen. */
        karttaKickPatterns(map);
        var t0 = Date.now();
        (function onIdle() {
          if (done) return;
          var ok = false; try { ok = map.isStyleLoaded() && map.areTilesLoaded(); } catch (e) {}
          if (ok && Date.now() - t0 > 600) capture(); else setTimeout(onIdle, 250);
        })();
      } catch (e) { log('kartta tuotanto', e); clearTimeout(timer); finish(null); }
    });
  }
  function karttaTextUi() {
    var m = st.kartta.mode, idle = m === 'none';
    $$('.lastu-k__kartta-fonts,.lastu-k__kartta-sizes').forEach(function (el) { el.hidden = idle; });
    if (karttaTextIn) karttaTextIn.hidden = m !== 'text';
  }
  function karttaRestore(d) {
    st.kartta.q = d.q || ''; st.kartta.place = d.place || ''; st.kartta.center = d.center || null; st.kartta.zoom = d.zoom || 14.5; st.kartta.style = d.style === 'nature' ? 'terrain' : (d.style || 'city');   /* Luonto poistettu → vanhat luonnokset Maastoon */ st.kartta.text = d.text || ''; st.kartta.font = d.font || 'poster'; st.kartta.size = d.size || 'm'; st.kartta.pin = !!d.pin; st.kartta.mode = d.mode || (d.text ? 'text' : 'none');
    if (karttaSearch) karttaSearch.value = st.kartta.q; if (karttaTextIn) karttaTextIn.value = st.kartta.text; $$('input[data-kartta-pin]').forEach(function (r) { r.checked = (r.getAttribute('data-kartta-pin') === '1') === !!st.kartta.pin; }); $$('input[data-kartta-size]').forEach(function (r) { r.checked = r.getAttribute('data-kartta-size') === st.kartta.size; }); $$('input[data-kartta-mode]').forEach(function (r) { r.checked = r.getAttribute('data-kartta-mode') === st.kartta.mode; }); karttaTextUi();
    $$('input[data-kartta-style]').forEach(function (r) { r.checked = r.getAttribute('data-kartta-style') === st.kartta.style; });
    $$('input[data-kartta-font]').forEach(function (r) { r.checked = r.getAttribute('data-kartta-font') === st.kartta.font; });
    if (st.kartta.map) { karttaRestyle(); if (st.kartta.center) st.kartta.map.jumpTo({ center: st.kartta.center, zoom: st.kartta.zoom + karttaZoomOff() }); }
    karttaLastGeom = ''; karttaSyncInputs(); render();
  }
  if (KARTTA_MODE || KARTTA_ADDON) {
    karttaTextUi();
    /* Varmistus: sama radioryhmän nimi on myös (pois käytöstä olevalla) tekstikaiverrusrivillä → selain voi
       nollata kartan oletusvalinnan. Asetetaan valinta koodista. */
    $$('input[data-kartta-font]').forEach(function (r) { r.checked = r.getAttribute('data-kartta-font') === st.kartta.font; });
    $$('input[data-kartta-size]').forEach(function (r) { r.checked = r.getAttribute('data-kartta-size') === st.kartta.size; });
    $$('input[data-kartta-mode]').forEach(function (r) { r.checked = r.getAttribute('data-kartta-mode') === st.kartta.mode; });
    if (karttaSearch) {
      karttaSearch.placeholder = S.kartta_placeholder || '';
      karttaSearch.addEventListener('input', function () { st.kartta.q = karttaSearch.value; clearTimeout(karttaTimer); karttaTimer = setTimeout(function () { karttaSuggest(karttaSearch.value.trim()); }, 250); });
      karttaSearch.addEventListener('blur', function () { setTimeout(function () { karttaShowList(false); }, 200); });
      karttaSearch.addEventListener('focus', function () { if (karttaList && karttaList.children.length) karttaShowList(true); });
      karttaSearch.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); var first = karttaList && karttaList.querySelector('li'); if (first) first.dispatchEvent(new MouseEvent('mousedown')); else karttaSuggest(karttaSearch.value.trim()); } });
    }
    if (karttaTextIn) { karttaTextIn.placeholder = S.kartta_text_placeholder || ''; karttaTextIn.addEventListener('input', function () { st.kartta.text = cleanText(karttaTextIn.value).replace(/\n/g, ' ').slice(0, 40); karttaLastGeom = ''; karttaTextUi(); ensureFonts(function () { render(); }); scheduleSave(); }); }
    $$('input[data-kartta-pin]').forEach(function (r) { r.addEventListener('change', function () { if (r.checked) { st.kartta.pin = r.getAttribute('data-kartta-pin') === '1'; render(); scheduleSave(); } }); });
    $$('input[data-kartta-mode]').forEach(function (r) { r.addEventListener('change', function () { if (r.checked) { st.kartta.mode = r.getAttribute('data-kartta-mode'); karttaLastGeom = ''; karttaTextUi(); if (st.kartta.mode === 'text' && karttaTextIn) karttaTextIn.focus(); ensureFonts(function () { render(); }); scheduleSave(); } }); });
    $$('input[data-kartta-size]').forEach(function (r) { r.addEventListener('change', function () { if (r.checked) { st.kartta.size = r.getAttribute('data-kartta-size'); karttaLastGeom = ''; render(); scheduleSave(); } }); });
    $$('input[data-kartta-style]').forEach(function (r) { r.addEventListener('change', function () { if (r.checked) { st.kartta.style = r.getAttribute('data-kartta-style'); karttaRestyle(); scheduleSave(); } }); });
    $$('input[data-kartta-font]').forEach(function (r) { r.addEventListener('change', function () { if (r.checked) { st.kartta.font = r.getAttribute('data-kartta-font'); ensureFonts(function () { render(); }); } }); });
    [].slice.call(document.querySelectorAll('[data-map-zoom]')).forEach(function (b) { b.addEventListener('click', function (e) { e.stopPropagation(); var map = st.kartta.map; if (!map) return; if (b.getAttribute('data-map-zoom') === 'in') map.zoomIn({ duration: 250 }); else map.zoomOut({ duration: 250 }); }); });
    window.addEventListener('resize', function () { karttaLastGeom = ''; render(); });
    document.addEventListener('visibilitychange', function () { karttaLastGeom = ''; render(); });
    /* Varmistus: jos kartta ei ole vielä paikallaan (esim. sivu avattiin taustavälilehteen), yritetään uudelleen. */
    setInterval(function () { if (karttaEl && karttaEl.hidden && currentModel() && document.visibilityState === 'visible') { karttaLastGeom = ''; render(); } }, 1000);
  }
  /* ───────── Tekstikaiverrus: 1–8 tekstiä (29.9.2026) ─────────
     Jokainen teksti on oma kerros (siirto, skaalaus, kierto esikatselussa), fontti ja tasaus
     ovat yhteiset. Hinta +3 € kerran. Kaikki tekstit samaan tuotanto-PNG:hen. */
  var MAX_TEXTS = LOMPAKKO ? 1 : 8;   /* KARB-lompakko: yksi teksti ja yksi kuva */
  var textInput = $('input[data-text]'), textList = $('#lastu-k-texts'), textAddBtn = $('[data-text-add]'), textFontInputs = $$('input[data-text-font]');
  var textArea = null;   /* yhteensopivuus: ensimmäinen tekstikenttä */
  /* Kirjainkoko pysyy samana: tf.s on kerroksen leveys suhteessa ikkunaan, joten kun teksti
     pitenee/lyhenee (tai fontti vaihtuu), leveys skaalataan samassa suhteessa. Ensimmäisellä
     kerralla koko lasketaan tekstin pituudesta → kaikki tekstit samankokoisia. Asiakkaan oma
     skaalaus säilyy suhteellisena; luonnoksesta palautettu koko (keepS) säilyy sellaisenaan. */
  function buildTextItem(t) {
    var ow = t.maskCanvas ? t.maskCanvas.width : 0;
    t.font = st.text.font; t.align = st.text.align; buildText(t);
    if (!t.maskCanvas || !t.tf) return;
    var nw = t.maskCanvas.width, cl = function (v) { return Math.max(0.06, Math.min(1.2, v)); };
    if (ow) t.tf.s = cl(t.tf.s * nw / ow);
    else if (!t.keepS) {
      /* 9.10.2026 (käyttäjä): oletuskoko tuplana (0,55 → 1,1); pitkä teksti enintään 90 % pinnan leveydestä
         ja lohko pysyy pinnan alareunan sisällä. */
      t.tf.s = cl(Math.min(0.9, 1.1 * nw / 760));
      var tm = currentModel(), tb = tm && tm.img && winCache[tm.img];
      if (tb) { var half = tb.w * t.tf.s * t.maskCanvas.height / nw / 2 / tb.h; t.tf.y = Math.max(0.04 + half, Math.min(0.96 - half, t.tf.y)); }
    }
    t.keepS = false;
  }
  function buildAllTexts() { st.text.items.forEach(buildTextItem); }
  function textStatus() {
    var f = st.text.items.map(function (t) { return cleanText(t.value).trim(); }).filter(Boolean);
    setStatus('text', st.text.on && f.length ? f[0].split('\n')[0].slice(0, 20) + (f.length > 1 ? ' +' + (f.length - 1) : '') : null);
  }
  function syncTextRowActive() {
    if (!textList) return;
    $$('.lastu-k__text-row', textList).forEach(function (r, i) { r.classList.toggle('is-active', active === st.text.items[i]); });
  }
  function renderTextRows(focusIndex) {
    if (!textList) return;
    textList.innerHTML = '';
    st.text.items.forEach(function (t, i) {
      var row = document.createElement('div'); row.className = 'lastu-k__text-row';
      var num = document.createElement('span'); num.className = 'lastu-k__text-num'; num.textContent = String(i + 1);
      var ta = document.createElement('textarea'); ta.className = 'lastu-k__textarea'; ta.rows = 2; ta.maxLength = 200; ta.disabled = !st.text.on;
      ta.placeholder = i ? (S.text_placeholder_more || '') : (S.text_placeholder || ''); ta.value = t.value;
      ta.addEventListener('input', function () {
        t.value = cleanText(ta.value); if (ta.value !== t.value) ta.value = t.value; textStatus();
        clearTimeout(t.timer); t.timer = setTimeout(function () { buildTextItem(t); refreshGestureLayer(); if (t.maskCanvas) { active = t; showHandles(); } render(); }, 80);
      });
      ta.addEventListener('focus', function () { if (t.maskCanvas) { active = t; showHandles(); render(); } syncTextRowActive(); });
      row.appendChild(num); row.appendChild(ta);
      if (st.text.items.length > 1) {
        var x = document.createElement('button'); x.type = 'button'; x.className = 'lastu-k__text-x'; x.setAttribute('aria-label', S.remove || 'Poista'); x.textContent = '×';
        x.addEventListener('click', function () { st.text.items.splice(st.text.items.indexOf(t), 1); if (active === t) active = null; renderTextRows(); textStatus(); refreshGestureLayer(); render(); });
        row.appendChild(x);
      }
      textList.appendChild(row);
      if (i === focusIndex && !isMobile()) { try { ta.focus({ preventScroll: true }); } catch (e) {} }
    });
    textArea = $('textarea', textList);
    if (textAddBtn) { textAddBtn.hidden = !st.text.on || st.text.items.length >= MAX_TEXTS; textAddBtn.textContent = (S.text_add || '+ Lisää tekstikenttä') + ' (' + st.text.items.length + '/' + MAX_TEXTS + ')'; }
    syncTextRowActive();
  }
  if (textAddBtn) textAddBtn.addEventListener('click', function () {
    if (st.text.items.length >= MAX_TEXTS) return;
    var t = { value: '', tf: defaultTextTf(st.text.items.length), maskCanvas: null, isText: true };
    st.text.items.push(t); renderTextRows(st.text.items.length - 1);
    var tas = $$('textarea', textList); if (isMobile() && tas.length) { try { tas[tas.length - 1].focus(); } catch (e) {} }
  });
  function setText(on) {
    st.text.on = on;
    textFontInputs.forEach(function (r) { r.checked = r.getAttribute('data-text-font') === st.text.font; });
    var reveal = rowOf(textInput).querySelector('.lastu-k__reveal'); if (reveal) kReveal(reveal, on);
    textFontInputs.forEach(function (r) { r.disabled = !on; });
    renderTextRows();
    if (on) {
      st.text.items.forEach(function (t, i) { if (!t.tf) t.tf = defaultTextTf(i); });
      ensureFonts(function () { buildAllTexts(); refreshGestureLayer(); render(); var f = liveTexts()[0]; if (f) { active = f; showHandles(); } syncTextRowActive(); });
      if (textArea && !isMobile()) { try { textArea.focus({ preventScroll: true }); } catch (e) {} }
    } else { st.text.items.forEach(function (t) { t.maskCanvas = null; if (active === t) active = null; }); }
    textStatus();
    showError(null); updatePrice(); refreshGestureLayer(); render();
  }
  if (textInput) textInput.addEventListener('change', function () { setText(textInput.checked); });
  textFontInputs.forEach(function (r) { r.addEventListener('change', function () { if (r.checked) { st.text.font = r.getAttribute('data-text-font'); ensureFonts(function () { buildAllTexts(); var a = active && active.isText ? active : liveTexts()[0]; if (a) { active = a; showHandles(); } render(); }); } }); });
  $$('[data-text-align]').forEach(function (b) {
    b.addEventListener('click', function () { st.text.align = b.getAttribute('data-text-align'); $$('[data-text-align]').forEach(function (o) { o.classList.toggle('is-active', o === b); }); buildAllTexts(); render(); });
  });

  /* ───────── KUWA: 1–5 omaa kuvaa, jokainen oma kerros ───────── */
  var imagesWrap = $('#lastu-k-images'), addImageLabel = $('#lastu-k-add-image'), imagesCountInput = $('[data-images-count]');
  /* Pyöreä rajaus: ympyrä = lyhyempi sivu; pos 0..1 siirtää ympyrää pidemmän sivun suunnassa
     (pysty­kuvassa ylös/alas, vaakakuvassa vasen/oikea). Sama apuri kaiverrukselle, painatukselle ja KUWAlle. */
  function roundClip(src, pos) {
    var w = src.width, h = src.height, d = Math.min(w, h), t = Math.min(1, Math.max(0, pos == null ? 0.5 : pos));
    var ox = w > h ? (w - d) * t : 0, oy = h > w ? (h - d) * t : 0;
    var c = document.createElement('canvas'); c.width = d; c.height = d; var x = c.getContext('2d');
    x.beginPath(); x.arc(d / 2, d / 2, d / 2, 0, Math.PI * 2); x.closePath(); x.clip();
    x.drawImage(src, -ox, -oy);
    return c;
  }
  function buildImageCanvas(im) {
    var id = im.imageData, w = id.width, h = id.height, c = document.createElement('canvas');
    var src;
    if (im.removeBg && im.cutCanvas) src = im.cutCanvas;
    else { src = document.createElement('canvas'); src.width = w; src.height = h; src.getContext('2d').putImageData(id, 0, 0); }
    if (im.round) c = roundClip(src, im.roundPos);
    else { c.width = src.width; c.height = src.height; c.getContext('2d').drawImage(src, 0, 0); }
    im.canvas = c;
    if (im.thumb) im.thumb.src = c.toDataURL('image/jpeg', 0.7);
  }
  function imageDefaultTf(i) {
    var m = currentModel(), u = m && m.img, box = (u && winCache[u]) || null;
    var cy = box ? (RING.y - box.y) / box.h : 0.5, cx = box ? (RING.x - box.x) / box.w : 0.5;
    var k = i % 5, dx = [0, -0.18, 0.18, -0.18, 0.18][k], dy = [0, -0.16, 0.16, 0.16, -0.16][k];
    return { x: Math.min(0.9, Math.max(0.1, cx + dx)), y: Math.min(0.9, Math.max(0.1, cy + dy)), s: i ? 0.5 : 0.7, r: 0 };
  }
  function renderImageRows() {
    if (!imagesWrap) return;
    imagesWrap.innerHTML = '';
    st.images.forEach(function (im, i) {
      var row = document.createElement('div'); row.className = 'lastu-k__image' + (im.round ? ' is-round' : '') + (currentDesign() === im ? ' is-active' : '');
      var th = document.createElement('img'); th.className = 'lastu-k__image-thumb'; th.alt = ''; im.thumb = th; if (im.canvas) th.src = im.canvas.toDataURL('image/jpeg', 0.7);
      var body = document.createElement('div'); body.className = 'lastu-k__image-body';
      var nm = document.createElement('span'); nm.className = 'lastu-k__image-name'; nm.textContent = (i + 1) + '. ' + im.name;
      var bRound = document.createElement('button'); bRound.type = 'button'; bRound.className = 'lastu-k__chip' + (im.round ? ' is-active' : ''); bRound.textContent = S.kuwa_round;
      var bBg = document.createElement('button'); bBg.type = 'button'; bBg.className = 'lastu-k__chip' + (im.removeBg ? ' is-active' : '') + (im.pending ? ' is-busy' : ''); bBg.textContent = im.pending ? (S.removebg_busy || S.kuwa_bg) : S.kuwa_bg;
      var bFront = document.createElement('button'); bFront.type = 'button'; bFront.className = 'lastu-k__chip'; bFront.textContent = S.kuwa_front; bFront.hidden = st.images.length < 2 || i === st.images.length - 1;
      var bX = document.createElement('button'); bX.type = 'button'; bX.className = 'lastu-k__image-x'; bX.textContent = '×'; bX.setAttribute('aria-label', S.remove);
      bRound.addEventListener('click', function () { im.round = !im.round; if (im.roundPos == null) im.roundPos = 0.5; buildImageCanvas(im); active = im; renderImageRows(); showHandles(); render(); });
      var posWrap = null;
      if (im.round) {
        posWrap = document.createElement('label'); posWrap.className = 'lastu-k__slider lastu-k__image-pos';
        var posLab = document.createElement('span'); posLab.textContent = S.round_pos;
        var posIn = document.createElement('input'); posIn.type = 'range'; posIn.min = 0; posIn.max = 100; posIn.value = Math.round((im.roundPos == null ? 0.5 : im.roundPos) * 100);
        posIn.addEventListener('input', function () { im.roundPos = +posIn.value / 100; buildImageCanvas(im); render(); });
        posWrap.appendChild(posLab); posWrap.appendChild(posIn);
      }
      bBg.addEventListener('click', function () { im.removeBg = !im.removeBg; if (im.removeBg) removeImageBackground(im); else { buildImageCanvas(im); renderImageRows(); render(); } });
      bFront.addEventListener('click', function () { st.images.splice(i, 1); st.images.push(im); active = im; renderImageRows(); showHandles(); render(); });
      bX.addEventListener('click', function () { st.images.splice(i, 1); if (active === im) active = null; syncImages(); render(); });
      row.addEventListener('click', function (e) { if (e.target.tagName === 'BUTTON') return; active = im; renderImageRows(); showHandles(); });
      body.appendChild(nm); body.appendChild(bRound); body.appendChild(bBg); body.appendChild(bFront); if (posWrap) body.appendChild(posWrap);
      row.appendChild(th); row.appendChild(body); row.appendChild(bX); imagesWrap.appendChild(row);
    });
  }
  function syncImages() {
    renderImageRows();
    var n = st.images.length;
    if (addImageLabel) { addImageLabel.hidden = n >= 5; var face = addImageLabel.querySelector('.lastu-k__upload-btn-face'); if (face) face.textContent = n ? S.kuwa_add_more : S.kuwa_add; }
    if (imagesCountInput) { imagesCountInput.value = String(n); imagesCountInput.disabled = !n; }
    setStatus('images', n ? n + ' ' + S.kuwa_count : null);
    refreshGestureLayer(); showError(null);
  }
  function removeImageBackground(im) {
    if (im.cutCanvas) { buildImageCanvas(im); renderImageRows(); render(); return; }
    if (im.pending) return;
    im.pending = true; renderImageRows();
    prCall('segment', im)
      .then(function (blob) { return new Promise(function (res, rej) { var i2 = new Image(); i2.onload = function () { res(i2); }; i2.onerror = rej; i2.src = URL.createObjectURL(blob); }); })
      .then(function (img2) { var c = document.createElement('canvas'); c.width = img2.naturalWidth; c.height = img2.naturalHeight; c.getContext('2d').drawImage(img2, 0, 0); im.cutCanvas = c; })
      .catch(function (e) { log('taustanpoisto epäonnistui', e); im.removeBg = false; showError(S.removebg_error || 'Taustan poisto ei onnistunut.', imagesWrap); })
      .then(function () { im.pending = false; if (st.images.indexOf(im) >= 0) { buildImageCanvas(im); renderImageRows(); render(); } });
  }
  var kuwaInput = $('input[data-file="kuwa"]');
  /* files = File[]; restores = valinnaiset tallennetut asetukset samassa järjestyksessä (muisti). */
  function addKuwaFiles(files, restores) {
    files = files.slice(0, 5 - st.images.length); if (!files.length) return Promise.resolve(); showError(null);
    return files.reduce(function (chain, file, idx) {
      return chain.then(function () {
        return readFile(file).then(function (img) {
          var id = toImageData(img, 1400), bgm = backgroundMask(id, 58); if (!bgm.hasAlpha) cleanMask(bgm.bg, id.width, id.height);
          var r = (restores && restores[idx]) || {};
          var im = { file: img.__file || file, name: (img.__file || file).name, img: img, imageData: id, bg: bgm.bg, hasAlpha: bgm.hasAlpha, tf: r.tf || imageDefaultTf(st.images.length), round: !!r.round, roundPos: r.roundPos, removeBg: !!(r.removeBg && r.cutCanvas), cutCanvas: r.cutCanvas || null };
          buildImageCanvas(im); st.images.push(im); active = im;
        }).catch(function (err) {
          showError(err && err.message === 'heic' ? (lang === 'en' ? 'The HEIC image couldn’t be converted – please export it as JPG or PNG.' : 'HEIC-kuvan muunnos ei onnistunut – tallenna kuva JPG- tai PNG-muodossa.') : (lang === 'en' ? 'The image could not be read.' : 'Kuvaa ei voitu lukea.'));
        });
      });
    }, Promise.resolve()).then(function () { syncImages(); render(); setTimeout(showHandles, 150); });
  }
  if (kuwaInput) kuwaInput.addEventListener('change', function () {
    var files = [].slice.call(kuwaInput.files || []); kuwaInput.value = '';
    addKuwaFiles(files);
  });
  if (KUWA) { $$('input[data-persona]').forEach(function (i) { i.disabled = true; }); }

  /* Upload-kentät */
  var convPanel = $('[data-conv]'), gesture = $('#lastu-k-gesture'), tools = $('#lastu-k-stage-tools');
  var stageToggle = $('#lastu-k-stage-toggle');
  function mainDesign() { return st.persona === 'upload' ? st.upload : st.persona === 'print' ? st.print : null; }
  function layers() {
    var out = [], m = KUWA ? null : mainDesign();
    if (KUWA) st.images.forEach(function (im) { if (im.canvas) out.push(im); });
    if (st.persona === 'upload') st.uploads.forEach(function (u) { if (u.maskCanvas) out.push(u); });
    else if (m && (m.maskCanvas || m.canvas)) out.push(m);
    liveTexts().forEach(function (t) { out.push(t); });
    return out;
  }
  var active = null;
  /* Aktiivinen kerros: viimeksi napautettu; muuten päällimmäinen (teksti). */
  function currentDesign() { var L = layers(); if (active && L.indexOf(active) >= 0) return active; return L[L.length - 1] || null; }
  var hintIcon = $('#lastu-k-hint');
  /* 26.9.2026 Sormisäätöohje: kun säädettävä sisältö ilmestyy ensimmäisen kerran, se liikahtaa
     kerran sivulle ja takaisin (näyttää että sitä voi liikuttaa). Ohje häviää pysyvästi, kun
     asiakas koskee esikatseluun ensimmäisen kerran (localStorage). */
  var HINT_KEY = 'lastu-k-hint-seen', hintNudged = false;
  try { if (localStorage.getItem(HINT_KEY)) document.documentElement.classList.add('lastu-k-hint-seen'); } catch (e) {}
  function hintSeen() { return document.documentElement.classList.contains('lastu-k-hint-seen'); }
  function hintDone() {
    if (hintSeen() || !hintIcon || hintIcon.hidden) return;
    try { localStorage.setItem(HINT_KEY, '1'); } catch (e) {}
    hintIcon.classList.add('is-done');
    setTimeout(function () { document.documentElement.classList.add('lastu-k-hint-seen'); }, 400);
  }
  function hintNudge() {
    if (hintNudged || hintSeen()) return; hintNudged = true;
    try { if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return; } catch (e) {}
    setTimeout(function () {
      if (KARTTA() && st.kartta.map && st.kartta.center) {
        var map = st.kartta.map, c0 = map.getCenter(), z0 = map.getZoom(), dx = Math.round(map.getContainer().clientWidth * 0.12);
        st.kartta.busy = true;
        map.panBy([dx, 0], { duration: 420 });
        setTimeout(function () { map.panBy([-dx, 0], { duration: 420 }); }, 460);
        setTimeout(function () { map.jumpTo({ center: c0, zoom: z0 }); st.kartta.busy = false; }, 980);
        return;
      }
      var d = currentDesign(); if (!d || !d.tf) return;
      var x0 = d.tf.x, t0 = performance.now();
      (function step(now) { var k = Math.min(1, (now - t0) / 900); d.tf.x = x0 + 0.05 * Math.sin(k * Math.PI * 2) * (1 - k * 0.3); render(); if (k < 1) requestAnimationFrame(step); else { d.tf.x = x0; render(); } })(t0);
    }, 650);
  }
  function refreshGestureLayer() {
    var on = layers().length > 0;
    if (gesture) gesture.hidden = !on; if (tools) tools.hidden = !on;
    if (hintIcon) { var wasH = hintIcon.hidden; hintIcon.hidden = !on; if (wasH && on) hintNudge(); }
    if (on && isMobile() && stage.getAttribute('data-state') === 'mini') setStage('expand');
  }
  /* ───────── Kaiverruskuvat 1–3 (23.9.2026) ─────────
     Puukuoriin (sekä KUKSA/KARB) voi ladata enintään 3 kaiverrettavaa kuvaa. Jokainen on oma
     kerros omilla asetuksillaan (tyyli, tummuus, tausta, pyöreä). Muunninpaneeli muokkaa aina
     yhtä kuvaa kerrallaan = st.upload; valinta vaihtuu kuvalistasta tai esikatselussa napauttamalla.
     Tuotantoon kaikki kuvat menevät YHTEEN mustaan PNG:hen, hinta +5 € kerran. */
  var MAX_UPLOADS = LOMPAKKO ? 1 : 3;
  var upList = $('#lastu-k-up-images'), upWrap = $('[data-upload="upload"]');
  var upBtn = upWrap && upWrap.querySelector('.lastu-k__upload-btn'), upFace = upBtn && upBtn.querySelector('.lastu-k__upload-btn-face');
  var upHint = $('[data-up-hint]'), upMulti = $('[data-up-multi]'), convFor = $('[data-conv-for]');
  var upThumbCol = null;
  function hasUpload(u) { return !!u && st.uploads.indexOf(u) >= 0; }
  /* 9.10.2026 (käyttäjä): 1. ladattu kuva/logo oletuksena 80 % materiaalipinnan (ikkunan) leveydestä – mitattuna
     kuvion omasta rajauksesta, joten tyhjät/läpinäkyvät reunat eivät pienennä sitä. Korkeus ≤ 85 % pinnasta,
     kuvion keskipiste renkaan kohdalle (pidetään pinnan sisällä). Sovitetaan uudelleen kun maski vaihtuu
     (esim. Piirros saapuu), kunnes asiakas siirtää/skaalaa kuvaa itse (autoFit = false). Camo/lompakko ennallaan. */
  function fitUpload(u) {
    var c = u.maskCanvas, m = currentModel(), box = m && m.img && winCache[m.img];
    if (!c || !box || LOMPAKKO || CAMO) return;
    var W = c.width, H = c.height, px = c.getContext('2d').getImageData(0, 0, W, H).data;
    var step = Math.max(1, Math.floor(Math.min(W, H) / 300)), x0 = W, y0 = H, x1 = -1, y1 = -1, x, y;
    for (y = 0; y < H; y += step) for (x = 0; x < W; x += step) if (px[(y * W + x) * 4 + 3]) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
    if (x1 < 0) return;
    var bw = x1 - x0 + step, bh = y1 - y0 + step;
    var s = Math.min(0.8 * W / bw, 0.85 * box.h * W / (box.w * bh)), w = box.w * s, h = w * H / W;
    var offX = ((x0 + bw / 2) / W - 0.5) * w, offY = ((y0 + bh / 2) / H - 0.5) * h, half = bh / H * h / box.h / 2;
    var tx = (RING.x - box.x) / box.w, ty = Math.min(0.97 - half, Math.max(0.03 + half, (RING.y - box.y) / box.h));
    u.tf = { x: tx - offX / box.w, y: ty - offY / box.h, s: s, r: 0 };
  }
  function uploadDefaultTf(i) {
    var tf = defaultTf(); if (!i) return tf;
    /* 2. ja 3. kuva pienempinä renkaan ALAPUOLELLE (yläpuolella on kameramoduuli), ettei ne peitä ensimmäistä. */
    tf.s = 0.4; tf.y = Math.min(0.86, tf.y + (i === 1 ? 0.3 : 0.5));
    return tf;
  }
  function selectUpload(u) {
    st.upload = u || null;
    if (u) active = u;
    if (convPanel) convPanel.hidden = !u;
    if (u) { syncConvUI(); if (upRbInput) upRbInput.checked = !!u.removeBg; }
    syncRoundUI('upload');
    setAiBusy(!!(u && u.aiPending)); setUpRbBusy(!!(u && u.cutPending));
    syncUploads();
    if (u) setTimeout(showHandles, 150);
  }
  function syncUploads() {
    var n = st.uploads.length, idx = st.uploads.indexOf(st.upload);
    renderUploadRows();
    if (upBtn) upBtn.style.display = n >= MAX_UPLOADS ? 'none' : '';
    if (upFace) upFace.textContent = n ? S.up_add_more : S.upload_btn;
    if (upHint) upHint.hidden = n > 0;
    if (upMulti) upMulti.hidden = n === 0 || MAX_UPLOADS < 2;
    if (convFor) { convFor.hidden = n < 2 || idx < 0; convFor.textContent = (S.up_conv_for || '').replace('{n}', idx + 1); }
    setStatus('upload', n === 1 ? st.uploads[0].name : n ? n + ' ' + S.up_count : null);
    refreshGestureLayer(); showError(null); render();
  }
  function renderUploadRows() {
    if (!upList) return;
    upList.innerHTML = '';
    var n = st.uploads.length;
    st.uploads.forEach(function (u, i) {
      var on = st.upload === u;
      var row = document.createElement('div'); row.className = 'lastu-k__image' + (on && n > 1 ? ' is-active' : '') + (u.round ? ' is-round' : '');
      var th = document.createElement('canvas'); th.className = 'lastu-k__image-thumb'; th.width = 88; th.height = 88; u.thumbCanvas = th;
      var body = document.createElement('div'); body.className = 'lastu-k__image-body';
      var nm = document.createElement('span'); nm.className = 'lastu-k__image-name'; nm.textContent = (i + 1) + '. ' + u.name;
      body.appendChild(nm);
      if (n > 1) {
        var tag = document.createElement('span');
        if (on) { tag.className = 'lastu-k__image-tag'; tag.textContent = S.up_editing; }
        else { tag.className = 'lastu-k__image-edit'; tag.textContent = S.up_edit; }
        body.appendChild(tag);
      }
      var bX = document.createElement('button'); bX.type = 'button'; bX.className = 'lastu-k__image-x'; bX.textContent = '×'; bX.setAttribute('aria-label', S.remove + ' ' + (i + 1));
      bX.addEventListener('click', function () {
        st.uploads.splice(st.uploads.indexOf(u), 1); if (active === u) active = null;
        selectUpload(st.upload === u ? (st.uploads[st.uploads.length - 1] || null) : st.upload);
      });
      row.addEventListener('click', function (e) { if (e.target.closest('button')) return; if (st.upload !== u) selectUpload(u); else { active = u; showHandles(); } });
      row.appendChild(th); row.appendChild(body); row.appendChild(bX); upList.appendChild(row);
    });
    if (upThumbCol) drawUploadThumbs(upThumbCol);
  }
  /* Pikkukuva = kaiverrus materiaalin värillä materiaalipohjan päällä (CSS-tausta) → näkyy mitä tulee puuhun. */
  function drawUploadThumbs(col) {
    upThumbCol = col;
    st.uploads.forEach(function (u) {
      var c = u.thumbCanvas; if (!c || !u.maskCanvas) return;
      var x = c.getContext('2d'), src = u.maskCanvasTinted(col), pad = 8, sc = Math.min((c.width - pad * 2) / src.width, (c.height - pad * 2) / src.height);
      x.clearRect(0, 0, c.width, c.height);
      x.drawImage(src, (c.width - src.width * sc) / 2, (c.height - src.height * sc) / 2, src.width * sc, src.height * sc);
    });
  }
  var fileLoaders = {};
  $$('input[data-file]').forEach(function (inp) {
    var kind = inp.getAttribute('data-file'), wrap = inp.closest('[data-upload]');
    if (!wrap) return; /* KUWA-kuvakenttä hoidetaan omassa moduulissaan */
    var nameEl = wrap.querySelector('[data-upload-name]'), xBtn = wrap.querySelector('[data-upload-remove]');
    /* Sama lataaja käyttäjän valinnalle ja muistista palautukselle (restore = tallennetut asetukset). */
    fileLoaders[kind] = function (file, restore) {
      showError(null); nameEl.textContent = '…';
      return readFile(file).then(function (img) {
        var id = toImageData(img, 1000), bgm = backgroundMask(id, kind === 'print' ? 58 : 42);
        if (!bgm.hasAlpha) cleanMask(bgm.bg, id.width, id.height);
        var r = restore || {};
        if (kind === 'upload') {
          /* Kaiverruskuvat 1–3: jokainen lisätty kuva on oma kerros ja siirtyy heti muokattavaksi.
             Nimi ja poisto näkyvät kuvalistassa (#lastu-k-up-images), ei latausnapin vieressä. */
          nameEl.textContent = '';
          if (st.uploads.length >= MAX_UPLOADS) return;
          /* Oletustyyli = Piirros: ääriviiva näkyy heti, piirros vaihtuu tilalle kun se valmistuu. */
          var nu = { img: img, file: img.__file || file, name: (img.__file || file).name, imageData: id, bg: bgm.bg, hasAlpha: bgm.hasAlpha, tf: r.tf || uploadDefaultTf(st.uploads.length), autoFit: !r.tf && !st.uploads.length, mode: r.mode || 'ai', aiBy: r.aiBy || {}, detail: r.detail == null ? 50 : r.detail, dark: r.dark == null ? 50 : r.dark, invert: false, round: !!r.round, roundPos: r.roundPos, removeBg: !!r.removeBg, cut: r.cut || null };
          convert(nu); st.uploads.push(nu); selectUpload(nu);
          /* Piirros käynnistyy 1,2 s viiveellä: jos asiakas poistaa kuvan heti, sitä ei lähetetä. */
          if (nu.mode === 'ai' && !hasAi(nu)) { nu.aiQueued = true; stageBusy(); setTimeout(function () { nu.aiQueued = false; if (hasUpload(nu) && nu.mode === 'ai' && !hasAi(nu)) aiSketch(nu, 'edge'); else stageBusy(); }, 1200); }
        } else {
          nameEl.textContent = (img.__file || file).name; xBtn.hidden = false;
          st.print = { img: img, file: img.__file || file, name: (img.__file || file).name, imageData: id, bg: bgm.bg, hasAlpha: bgm.hasAlpha, tf: r.tf || defaultTf(), removeBg: !!r.removeBg, round: !!r.round, roundPos: r.roundPos, cutCanvas: r.cutCanvas || null };
          buildPrintCanvas(st.print); setStatus('print', file.name);
          if (st.print.removeBg && st.print.cutCanvas) st.print.canvas = st.print.round ? roundClip(st.print.cutCanvas, st.print.roundPos) : st.print.cutCanvas;
          var rb = $('input[data-removebg]'); if (rb) { rb.checked = st.print.removeBg; }
          syncRoundUI('print');
        }
        refreshGestureLayer(); render(); setTimeout(showHandles, 150);
      }).catch(function (err) {
        nameEl.textContent = '';
        showError(err && err.message === 'heic'
          ? (lang === 'en' ? 'The HEIC image couldn’t be converted – please export it as JPG or PNG.' : 'HEIC-kuvan muunnos ei onnistunut – tallenna kuva JPG- tai PNG-muodossa.')
          : (lang === 'en' ? 'The image could not be read.' : 'Kuvaa ei voitu lukea.'));
      });
    };
    inp.addEventListener('change', function () {
      if (kind === 'upload') {
        /* Useampi tiedosto kerralla → lisätään järjestyksessä, kunnes 3 kuvaa on täynnä. */
        var files = [].slice.call(inp.files || []).slice(0, MAX_UPLOADS - st.uploads.length); inp.value = '';
        files.reduce(function (ch, f) { return ch.then(function () { return fileLoaders.upload(f); }); }, Promise.resolve());
        return;
      }
      var file = inp.files && inp.files[0]; if (!file) return;
      fileLoaders[kind](file);
    });
    xBtn.addEventListener('click', function () {
      inp.value = ''; nameEl.textContent = ''; xBtn.hidden = true;
      if (kind === 'upload') { st.uploads = []; selectUpload(null); }
      else { st.print = null; setStatus('print', null); }
      refreshGestureLayer(); render();
    });
  });
  function buildPrintCanvas(p) {
    var id = p.imageData, w = id.width, h = id.height, c = document.createElement('canvas'); c.width = w; c.height = h;
    var out = new ImageData(new Uint8ClampedArray(id.data), w, h);
    if (p.removeBg) { for (var i = 0; i < w * h; i++) if (p.bg[i]) out.data[i * 4 + 3] = 0; }
    c.getContext('2d').putImageData(out, 0, 0); p.canvas = p.round ? roundClip(c, p.roundPos) : c;
  }
  /* Taustanpoisto: Cloudflare Worker → Cloudflare Images (28.9.2026, ent. Photoroom). Alkuperäinen
     tiedosto lähetetään kerran; tulos välimuistiin, jotta valinnan voi perua ja
     palauttaa ilman uutta kutsua. Jos palvelu ei vastaa, käytetään paikallista
     tulvatäyttöä varana. */
  var BG_URL = D.consts.bgRemoveUrl || 'https://lastu-taustanpoisto.sakke.workers.dev/';
  var removeBgInput = $('input[data-removebg]'), removeBgRow = removeBgInput && removeBgInput.closest('.lastu-k__toggle');
  function setBgBusy(on) {
    if (!removeBgRow) return; removeBgRow.classList.toggle('is-busy', on);
    var lab = removeBgRow.querySelector('.lastu-k__toggle-label'); if (lab) lab.textContent = on ? (S.removebg_busy || S.removebg) : S.removebg;
  }
  function applyCutout(p, img) {
    var c = document.createElement('canvas'); c.width = img.naturalWidth; c.height = img.naturalHeight;
    c.getContext('2d').drawImage(img, 0, 0); p.cutCanvas = c; p.canvas = p.round ? roundClip(c, p.roundPos) : c;
  }
  /* Lähetettävä kuva pienennetään selaimessa (max 2000 px): puhelinkuvat ovat
     usein 5–12 MB, ja Photoroomille riittää 2000 px. Nopeampi ja ei osu rajaan. */
  function uploadBlob(p) {
    return new Promise(function (res) {
      var img = p.img, w = img.naturalWidth || img.width, h = img.naturalHeight || img.height, sc = Math.min(1, 2000 / Math.max(w, h));
      var c = document.createElement('canvas'); c.width = Math.round(w * sc); c.height = Math.round(h * sc);
      c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
      var png = p.hasAlpha;
      c.toBlob(function (b) { res(b || p.file); }, png ? 'image/png' : 'image/jpeg', 0.92);
    });
  }
  function removeBackground(p) {
    if (p.cutCanvas) { p.canvas = p.round ? roundClip(p.cutCanvas, p.roundPos) : p.cutCanvas; render(); return; }
    if (p.pending) return;
    p.pending = true; setBgBusy(true); showError(null);
    prCall('segment', p)
      .then(function (blob) { return new Promise(function (res, rej) { var im = new Image(); im.onload = function () { res(im); }; im.onerror = rej; im.src = URL.createObjectURL(blob); }); })
      .then(function (img) { if (st.print === p && p.removeBg) { applyCutout(p, img); render(); } })
      .catch(function (e) {
        log('taustanpoisto epäonnistui', e);
        if (st.print === p) { p.removeBg = false; if (removeBgInput) removeBgInput.checked = false; buildPrintCanvas(p); render(); }
        showError(S.removebg_error || 'Taustan poisto ei onnistunut. Yritä hetken kuluttua uudelleen.', removeBgRow);
      })
      .then(function () { p.pending = false; setBgBusy(false); });
  }
  /* Kaiverruskuvan taustanpoisto: Photoroom leikkaa kuvan → u.cut = { img, imageData, bg };
     piirros pysyy samana, vain maski vaihtuu. Pois päältä → alkuperäinen lähde heti. */
  /* Pyöreä kuva + rajauksen kohta (kaiverrus ja painatus). Layer = st.upload / st.print. */
  function roundLayer(kind) { return kind === 'upload' ? st.upload : st.print; }
  function rebuildRound(kind) {
    var L = roundLayer(kind); if (!L) return;
    if (kind === 'upload') convert(L);
    else if (L.removeBg && L.cutCanvas) L.canvas = L.round ? roundClip(L.cutCanvas, L.roundPos) : L.cutCanvas;
    else buildPrintCanvas(L);
    render();
  }
  function syncRoundUI(kind) {
    var L = roundLayer(kind), cb = $('input[data-round="' + kind + '"]'), pn = $('[data-round-panel="' + kind + '"]'), sl = $('input[data-round-pos="' + kind + '"]');
    if (cb) cb.checked = !!(L && L.round);
    if (pn) pn.hidden = !(L && L.round);
    if (sl && L) sl.value = Math.round((L.roundPos == null ? 0.5 : L.roundPos) * 100);
  }
  ['upload', 'print'].forEach(function (kind) {
    var cb = $('input[data-round="' + kind + '"]'), sl = $('input[data-round-pos="' + kind + '"]');
    if (cb) cb.addEventListener('change', function () { var L = roundLayer(kind); if (!L) return; L.round = cb.checked; if (L.roundPos == null) L.roundPos = 0.5; syncRoundUI(kind); rebuildRound(kind); setTimeout(showHandles, 50); });
    if (sl) sl.addEventListener('input', function () { var L = roundLayer(kind); if (!L) return; L.roundPos = +sl.value / 100; rebuildRound(kind); });
  });
  var upRbInput = $('input[data-upload-removebg]'), upRbRow = upRbInput && upRbInput.closest('.lastu-k__toggle');
  function setUpRbBusy(on) {
    stageBusy();
    if (!upRbRow) return; upRbRow.classList.toggle('is-busy', on);
    var lab = upRbRow.querySelector('.lastu-k__toggle-label'); if (lab) lab.textContent = on ? (S.removebg_busy || S.removebg) : S.removebg;
  }
  /* ── Taustanpoisto- ja piirroskutsut yhden portin kautta (19.9.2026; 28.9. Cloudflare + Gemini) ──
     Sama kuva (nimi+koko+muokkausaika) + sama toiminto = tulos välimuistista:
     sivun sisäinen Map + IndexedDB 'cache' (30 pv, kaikki tuotteet). Kuukausikiintiö
     kului 80 % kahdessa päivässä → jokainen toisto maksaa. 429 = Workerin kiintiö täynnä. */
  var prMem = {};
  /* 28.9.2026: piirros siirtyi Photoroomista Geminiin → uusi avainversio, jotta vanhat Photoroom-piirrokset
     eivät palaa välimuistista. Taustanpoiston avain ennallaan (tulos on sama leikkaus). */
  function prKey(file, kind) { return (kind === 'piirros' ? 'piirros-g1' : kind) + ':' + (file ? (file.name || '') + ':' + file.size + ':' + (file.lastModified || 0) : Math.random()); }
  function prCall(kind, layer) {
    var key = prKey(layer.file, kind);
    if (prMem[key]) return prMem[key];
    var p = idbOp('readonly', function (os) { return os.get(key); }, 'cache').then(function (hit) {
      if (hit && hit.blob && Date.now() - hit.ts < 30 * 864e5) { log('photoroom välimuistista', key); return hit.blob; }
      return uploadBlob(layer).then(function (blob) {
        var fd = new FormData(); fd.append('image', blob, layer.hasAlpha ? 'kuva.png' : 'kuva.jpg'); if (kind === 'piirros') fd.append('style', aiStyle());
        return fetch(BG_URL.replace(/\/+$/, '') + (kind === 'piirros' ? '/piirros' : '/'), { method: 'POST', body: fd });
      }).then(function (r) {
        if (!r.ok) return r.text().then(function (t) { var e = new Error(kind + ' ' + r.status + ' ' + t.slice(0, 120)); e.quota = r.status === 429; throw e; });
        return r.blob();
      }).then(function (blob) { idbOp('readwrite', function (os) { return os.put({ ts: Date.now(), blob: blob }, key); }, 'cache'); return blob; });
    });
    prMem[key] = p; p.catch(function () { delete prMem[key]; });
    return p;
  }
  function uploadCutout(u) {
    if (u.cutPending) return; u.cutPending = true; setUpRbBusy(true); showError(null);
    prCall('segment', u)
      .then(function (blob) { return new Promise(function (res, rej) { var im = new Image(); im.onload = function () { res(im); }; im.onerror = rej; im.src = URL.createObjectURL(blob); }); })
      .then(function (img) {
        var id = toImageData(img, 1000), bgm = backgroundMask(id, 42);
        u.cut = { img: img, imageData: id, bg: bgm.bg };
        if (hasUpload(u) && u.removeBg) { convert(u); render(); if (u.mode === 'ai' && !hasAi(u)) aiSketch(u, 'edge'); }
      })
      .catch(function (e) {
        log('kaiverruksen taustanpoisto epäonnistui', e);
        if (hasUpload(u)) { u.removeBg = false; if (st.upload === u && upRbInput) upRbInput.checked = false; convert(u); render(); }
        showError(S.removebg_error || 'Taustan poisto ei onnistunut. Yritä hetken kuluttua uudelleen.', upRbRow);
      })
      .then(function () { u.cutPending = false; setUpRbBusy(!!(st.upload && st.upload.cutPending)); renderUploadRows(); });
  }
  if (upRbInput) upRbInput.addEventListener('change', function () {
    var u = st.upload; if (!u) return; u.removeBg = upRbInput.checked;
    if (u.removeBg && !u.cut) { uploadCutout(u); return; }
    convert(u); render();
  });
  if (removeBgInput) removeBgInput.addEventListener('change', function () {
    if (!st.print) return; st.print.removeBg = removeBgInput.checked;
    if (st.print.removeBg) removeBackground(st.print);
    else { st.print.removeBg = false; buildPrintCanvas(st.print); render(); }
  });
  /* 29.9.2026 Mobiilin esikatselu: kaiverrustyylit pillereinä oikeassa laidassa → asiakas voi
     vaihtaa tyyliä katsoen suoraan kuvaa. Klikkaus = saman tyylinapin klikkaus muunninpaneelissa. */
  var stageModes = $('#lastu-k-stage-modes');
  if (stageModes) {
    $$('[data-stage-mode]', stageModes).forEach(function (b) {
      var m = b.getAttribute('data-stage-mode'); b.textContent = S['conv_' + m] || m;
      b.addEventListener('click', function (e) { e.stopPropagation(); var src = convPanel && $('[data-mode="' + m + '"]', convPanel); if (src) src.click(); syncStageModes(); });
    });
  }
  function syncStageModes() {
    if (!stageModes) return;
    var u = st.upload, show = !!(convPanel && st.persona === 'upload' && u && hasUpload(u) && u.maskCanvas);   /* 29.9.2026: myös tietokoneella */
    stageModes.hidden = !show; if (!show) return;
    $$('[data-stage-mode]', stageModes).forEach(function (b) { var m = b.getAttribute('data-stage-mode'); b.classList.toggle('is-active', m === u.mode); b.classList.toggle('is-busy', m === 'ai' && !!u.aiPending); });
  }
  function syncConvUI() {
    syncStageModes();
    if (!convPanel || !st.upload) return;
    $$('[data-mode]', convPanel).forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-mode') === st.upload.mode); });
    $('[data-conv-detail]', convPanel).value = st.upload.detail; $('[data-conv-dark]', convPanel).value = st.upload.dark;
    /* 29.9.2026: Piirros = automaattinen lopputulos, ei säätimiä; muissa tyyleissä säätimet "Hienosäädä"-linkin takana. */
    var tune = $('[data-conv-tune]', convPanel); if (tune) tune.hidden = st.upload.mode === 'ai';
  }
  /* Piirros (AI): valokuva lähetetään Workerin /piirros-reitille (28.9.2026 alkaen Gemini),
     tulos (mustat viivat valkoisella) tallennetaan u.ai:hin ja kynnystetään kuten Viivapiirros.
     Odotuksen ajan näytetään edellinen tyyli; virheessä palataan siihen. */
  var aiBtn = convPanel && $('[data-mode="ai"]', convPanel);
  var aiProgress = convPanel && $('[data-ai-progress]', convPanel);
  function setAiBusy(on) { if (aiBtn) aiBtn.classList.toggle('is-busy', on); if (aiProgress) aiProgress.hidden = !on; stageBusy(); }
  /* 26.9.2026: odotusilmoitus esikatselussa, kun jokin kaiverruskuva odottaa AI-piirrosta
     (myös 1,2 s jonotusviive) tai taustanpoistoa → asiakas tietää että karkea luonnos paranee kohta. */
  var sbEl = $('#lastu-k-stage-busy'), sbKind = '';
  function stageBusy() {
    if (!sbEl) return;
    var ups = (st.uploads || []).filter(hasUpload);
    var ai = ups.some(function (u) { return u.aiPending || u.aiQueued; }), bg = ups.some(function (u) { return u.cutPending; });
    var kind = ai ? 'ai' : bg ? 'bg' : '';
    if (kind === sbKind) return; sbKind = kind;
    if (!kind) { sbEl.classList.add('is-done'); setTimeout(function () { if (!sbKind) { sbEl.hidden = true; sbEl.classList.remove('is-done'); } }, 350); return; }
    $('[data-sb-title]', sbEl).textContent = kind === 'ai' ? (S.stage_ai_title || '') : (S.stage_bg_title || '');
    $('[data-sb-sub]', sbEl).textContent = kind === 'ai' ? (S.stage_ai_sub || '') : (S.stage_bg_sub || '');
    sbEl.classList.remove('is-done'); sbEl.setAttribute('data-kind', kind);
    sbEl.hidden = false; var bar = $('.lastu-k__sb-bar i', sbEl); if (bar) { bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = ''; }
  }
  /* Piirroksen tyyli materiaalin mukaan: vaalea kaiverrusväri tummalla puulla → 'neg' (scratchboard:
     valokuvan vaaleat alueet kaiverretaan, pupillit jäävät tummiksi); tumma kaiverrus (Lumikoivu, KARB) → 'pos' viivapiirros. */
  /* 18.9.2026: scratchboard-tyyli ('neg', kaiverrusvärin luminanssi > 0.7) kokeiltiin tummille puille,
     mutta se vääristi kasvoja liikaa → aina viivapiirros. Worker tukee edelleen style=neg. */
  function aiStyle() { return 'pos'; }
  function hasAi(u) { return !!(u && u.aiBy && u.aiBy[aiStyle()]); }
  function aiSketch(u, prevMode) {
    if (u.aiPending) return; var style = aiStyle(); u.aiPending = true; u.aiQueued = false; if (st.upload === u) setAiBusy(true); stageBusy(); showError(null);
    prCall('piirros', u)
      .then(function (blob) { return new Promise(function (res, rej) { var im = new Image(); im.onload = function () { res(im); }; im.onerror = rej; im.src = URL.createObjectURL(blob); }); })
      .then(function (img) { u.aiBy = u.aiBy || {}; u.aiBy[style] = toImageData(img, 1000); if (hasUpload(u) && u.mode === 'ai') { convert(u); render(); } })
      .catch(function (e) {
        log('ai-piirros epäonnistui', e);
        /* 28.9.2026: Gemini epäonnistui → aina Viivapiirros (threshold). Piirros-painikkeen uusi klikkaus yrittää uudelleen;
           onnistunut piirros säilyy u.aiBy:ssä + välimuistissa, eikä sitä tehdä uudestaan tyylejä vaihdellessa. */
        if (hasUpload(u) && u.mode === 'ai') { u.mode = 'threshold'; if (st.upload === u) syncConvUI(); convert(u); render(); }
        showError(S.conv_ai_error || 'Piirrosta ei saatu tehtyä juuri nyt – näytetään viivapiirros. Voit kokeilla Piirros-tyyliä uudelleen hetken kuluttua.', convPanel);
      })
      .then(function () { u.aiPending = false; setAiBusy(!!(st.upload && st.upload.aiPending)); stageBusy(); });
  }
  if (convPanel) {
    $$('[data-mode]', convPanel).forEach(function (b) {
      b.addEventListener('click', function () {
        if (!st.upload) return; var m = b.getAttribute('data-mode'), prev = st.upload.mode; st.upload.mode = m; syncConvUI();
        if (m === 'ai' && !hasAi(st.upload)) { aiSketch(st.upload, prev); return; }
        reconvert();
      });
    });
    var reconvTimer = null;
    function reconvert() { clearTimeout(reconvTimer); reconvTimer = setTimeout(function () { if (st.upload) { convert(st.upload); render(); } }, 60); }
    var tuneBtn = $('[data-conv-tune-toggle]', convPanel), tuneBody = $('[data-conv-tune-body]', convPanel);
    if (tuneBtn && tuneBody) tuneBtn.addEventListener('click', function () {
      var open = tuneBody.hidden; tuneBody.hidden = !open; tuneBtn.setAttribute('aria-expanded', String(open));
    });
    $('[data-conv-detail]', convPanel).addEventListener('input', function (e) { if (st.upload) { st.upload.detail = +e.target.value; reconvert(); } });
    $('[data-conv-dark]', convPanel).addEventListener('input', function (e) { if (st.upload) { st.upload.dark = +e.target.value; reconvert(); } });
    var inv = $('[data-conv-invert]', convPanel); if (inv) inv.addEventListener('change', function (e) { if (st.upload) { st.upload.invert = e.target.checked; reconvert(); } });
    if (DEBUG) {
      var dl = document.createElement('button'); dl.type = 'button'; dl.className = 'lastu-k__chip'; dl.textContent = S.download_png;
      dl.addEventListener('click', function () { var png = productionPng(); if (!png) return; var a = document.createElement('a'); a.href = png; a.download = 'lastu-kaiverrus.png'; a.click(); });
      convPanel.appendChild(dl);
    }
  }

  /* ───────── 5. Eleet + kahvat ─────────
     Yksi sormi / hiiri: siirto. Kulmakahva: skaalaus. Kiertokahva: kierto.
     Kaksi sormea: nipistys = skaalaus + kierto. Rullalla skaalaus.
     Kahvat piirretään erilliselle overlay-canvasille (ei tule snapshotiin)
     ja katoavat 3 s käyttämättömyyden tai tyhjän kohdan napautuksen jälkeen. */
  var stage = $('#lastu-k-stage');
  /* Sormisäätöohje pois, kun esikatseluun kosketaan (ei nappeja). Kaappausvaiheessa → ehtii ennen karttaa/eleitä. */
  if (stage) ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { stage.addEventListener(ev, function (e) { if (e.target && e.target.closest && e.target.closest('button')) return; hintDone(); }, { capture: true, passive: true }); });
  var overlay = $('#lastu-k-overlay'), octx = overlay ? overlay.getContext('2d') : null;
  var selected = false, selTimer = null, lastBox = null;
  function boxNow() { if (LOMPAKKO) return lompakkoGeom().box; var m = currentModel(), u = m && m.img; return (u && winCache[u]) || lastBox || { x: 400, y: 50, w: 400, h: 860 }; }
  function designRect(d, box) {
    var src = d.maskCanvas || d.canvas; if (!src) return null;
    var w = box.w * d.tf.s, h = w * src.height / src.width;
    return { cx: box.x + box.w * d.tf.x, cy: box.y + box.h * d.tf.y, w: w, h: h, r: d.tf.r };
  }
  function rot(px, py, r) { var c = Math.cos(r), s_ = Math.sin(r); return { x: px * c - py * s_, y: px * s_ + py * c }; }
  function rectPoints(R) {
    var hw = R.w / 2, hh = R.h / 2, pts = [[-hw, -hh], [hw, -hh], [hw, hh], [-hw, hh]].map(function (p) { var q = rot(p[0], p[1], R.r); return { x: R.cx + q.x, y: R.cy + q.y }; });
    var rh = rot(0, -hh - 70, R.r); pts.rotate = { x: R.cx + rh.x, y: R.cy + rh.y };
    return pts;
  }
  function showHandles() {
    syncTextRowActive();
    selected = true; clearTimeout(selTimer); selTimer = setTimeout(function () { selected = false; drawOverlay(); }, 3000); drawOverlay();
  }
  function hideHandles() { selected = false; clearTimeout(selTimer); drawOverlay(); }
  function drawOverlay(box) {
    if (!octx) return; if (box) lastBox = box;
    octx.clearRect(0, 0, W, H);
    if (KARTTA()) { drawKarttaTop(boxNow()); return; }
    var d = currentDesign(); if (!d || !selected) return;
    var R = designRect(d, boxNow()); if (!R) return;
    var P = rectPoints(R);
    octx.save(); octx.lineWidth = 3; octx.strokeStyle = 'rgba(0,26,26,.9)'; octx.setLineDash([12, 8]);
    octx.beginPath(); P.forEach(function (p, i) { i ? octx.lineTo(p.x, p.y) : octx.moveTo(p.x, p.y); }); octx.closePath(); octx.stroke();
    octx.setLineDash([]); var top = { x: (P[0].x + P[1].x) / 2, y: (P[0].y + P[1].y) / 2 };
    octx.beginPath(); octx.moveTo(top.x, top.y); octx.lineTo(P.rotate.x, P.rotate.y); octx.stroke();
    function knob(p, txt) {
      octx.beginPath(); octx.arc(p.x, p.y, 22, 0, Math.PI * 2); octx.fillStyle = '#fff'; octx.fill(); octx.lineWidth = 3; octx.strokeStyle = '#001A1A'; octx.stroke();
      if (txt) { octx.fillStyle = '#001A1A'; octx.font = '600 24px ' + (S.font_mono || 'monospace'); octx.textAlign = 'center'; octx.textBaseline = 'middle'; octx.fillText(txt, p.x, p.y + 1); }
    }
    P.forEach(function (p) { knob(p); }); knob(P.rotate, '↻');
    octx.restore();
  }
  (function initGestures() {
    if (!gesture) return;
    var pts = {}, start = null, mode = null;
    function toCanvas(e) { var rc = canvas.getBoundingClientRect(); return { x: (e.clientX - rc.left) * W / rc.width, y: (e.clientY - rc.top) * H / rc.height }; }
    function dist(a, b) { return Math.hypot(a.x - b.x, a.y - b.y); }
    function hit(p, d) {
      var R = designRect(d, boxNow()); if (!R) return null;
      var P = rectPoints(R), tol = 46;
      if (selected) {
        if (dist(p, P.rotate) < tol) return 'rotate';
        for (var i = 0; i < 4; i++) if (dist(p, P[i]) < tol) return 'scale';
      }
      var q = rot(p.x - R.cx, p.y - R.cy, -R.r);
      if (Math.abs(q.x) <= R.w / 2 + 20 && Math.abs(q.y) <= R.h / 2 + 20) return 'move';
      return null;
    }
    gesture.addEventListener('pointerdown', function (e) {
      var d = currentDesign(); if (!d) return;
      var p = toCanvas(e);
      pts[e.pointerId] = p; var keys = Object.keys(pts);
      if (keys.length === 1) {
        /* Osuma päällimmäisestä kerroksesta alkaen; osuma vaihtaa aktiivisen kerroksen. */
        var L = layers(); mode = null;
        for (var li = L.length - 1; li >= 0; li--) { var hm = hit(p, L[li]); if (hm) { if (L[li] !== d && hm !== 'move') hm = 'move'; active = L[li]; d = L[li]; mode = hm; if (hasUpload(d) && st.upload !== d) selectUpload(d); break; } }
        if (!mode) { hideHandles(); return; }
        try { gesture.setPointerCapture(e.pointerId); } catch (x) {}
        var R = designRect(d, boxNow()); d.autoFit = false;
        start = { tf: Object.assign({}, d.tf), p: p, c: { x: R.cx, y: R.cy }, ang: Math.atan2(p.y - R.cy, p.x - R.cx), dist: dist(p, { x: R.cx, y: R.cy }) };
        showHandles();
      } else if (keys.length === 2) {
        try { gesture.setPointerCapture(e.pointerId); } catch (x) {}
        var a = pts[keys[0]], b = pts[keys[1]];
        mode = 'pinch'; d.autoFit = false; start = { tf: Object.assign({}, d.tf), dist: dist(a, b), ang: Math.atan2(b.y - a.y, b.x - a.x), cx: (a.x + b.x) / 2, cy: (a.y + b.y) / 2 };
        showHandles();
      }
      gesture.classList.add('is-dragging'); e.preventDefault();
    });
    gesture.addEventListener('pointermove', function (e) {
      if (!pts[e.pointerId] || !start || !mode) return;
      var d = currentDesign(); if (!d) return;
      var p = toCanvas(e); pts[e.pointerId] = p; var box = boxNow(), keys = Object.keys(pts);
      if (mode === 'pinch' && keys.length >= 2) {
        var a = pts[keys[0]], b = pts[keys[1]], dd = dist(a, b), ang = Math.atan2(b.y - a.y, b.x - a.x);
        d.tf.s = clampS(start.tf.s * dd / start.dist); d.tf.r = start.tf.r + (ang - start.ang);
        d.tf.x = start.tf.x + ((a.x + b.x) / 2 - start.cx) / box.w; d.tf.y = start.tf.y + ((a.y + b.y) / 2 - start.cy) / box.h;
      } else if (mode === 'move') {
        d.tf.x = start.tf.x + (p.x - start.p.x) / box.w; d.tf.y = start.tf.y + (p.y - start.p.y) / box.h;
      } else if (mode === 'scale') {
        d.tf.s = clampS(start.tf.s * dist(p, start.c) / Math.max(1, start.dist));
      } else if (mode === 'rotate') {
        d.tf.r = start.tf.r + (Math.atan2(p.y - start.c.y, p.x - start.c.x) - start.ang);
      }
      d.tf.x = Math.min(1.3, Math.max(-0.3, d.tf.x)); d.tf.y = Math.min(1.3, Math.max(-0.3, d.tf.y));
      showHandles(); render(); e.preventDefault();
    });
    function clampS(v) { return Math.min(3, Math.max(0.08, v)); }
    function up(e) {
      delete pts[e.pointerId];
      var keys = Object.keys(pts);
      if (!keys.length) { start = null; mode = null; gesture.classList.remove('is-dragging'); }
      else { var d = currentDesign(); if (d) { mode = 'move'; start = { tf: Object.assign({}, d.tf), p: pts[keys[0]] }; } }
    }
    gesture.addEventListener('pointerup', up); gesture.addEventListener('pointercancel', up);
    /* iOS/Android: estetään sivun vieritys ja selaimen zoom kosketuksen aikana.
       Pointer-tapahtumat hoitavat itse liikkeen; tämä vain pitää sivun paikallaan. */
    ['touchstart', 'touchmove'].forEach(function (ev) {
      gesture.addEventListener(ev, function (e) { if (currentDesign()) e.preventDefault(); }, { passive: false });
    });
    gesture.addEventListener('wheel', function (e) { var d = currentDesign(); if (!d) return; d.autoFit = false; d.tf.s = clampS(d.tf.s * (e.deltaY < 0 ? 1.06 : 0.94)); showHandles(); render(); e.preventDefault(); }, { passive: false });
    if (tools) tools.addEventListener('click', function (e) {
      var b = e.target.closest('[data-tool]'), d = currentDesign(); if (!b || !d) return;
      var t = b.getAttribute('data-tool'); d.autoFit = false;
      if (t === 'zoom-in') d.tf.s = clampS(d.tf.s * 1.12); if (t === 'zoom-out') d.tf.s = clampS(d.tf.s / 1.12);
      if (t === 'rotate') d.tf.r += Math.PI / 12; if (t === 'reset') d.tf = d.isText ? defaultTextTf(st.text.items.indexOf(d)) : hasUpload(d) ? uploadDefaultTf(st.uploads.indexOf(d)) : defaultTf();
      if (t === 'reset' && hasUpload(d) && !st.uploads.indexOf(d)) { d.autoFit = true; fitUpload(d); }
      showHandles(); render();
    });
  })();

  /* ───────── 6. Mobiili mini/expand, desktop galleriaan ───────── */
  var mq = window.matchMedia('(max-width:767px), ((max-width:1023px) and (orientation:portrait))');
  function isMobile() { return mq.matches; }
  var stageHome = stage.parentNode, stageAnchor = stage.nextSibling, photosBtn = null;
  /* Lähennä/Loitonna (mobiili, expand-tila): skaalaa canvasit niin että puhelimen
     takaikkuna täyttää kortin. Muunnos CSS-muuttujina, lasketaan uudelleen piirron yhteydessä. */
  /* ── Mobiili: näppäimistö auki → esikatselu piiloon ja sivun kohta lukkoon ──
     iOS/Android vierittää fokusoidun kentän näkyviin ja palauttaa vierityksen eri kohtaan, jolloin
     tuotevalinnat "hyppäävät". Piilotetaan esikatselu kirjoittamisen ajaksi ja palautetaan sama
     kenttä samaan kohtaan ruudulla, kun näppäimistö sulkeutuu. */
  (function keyboardGuard() {
    var typingEl = null, keepTop = 0, restoreTimer = null, anchorTimer = null, selfScroll = false;
    function isTextField(el) {
      if (!el || !el.closest || !el.closest('#lastu-k')) return false;
      var t = el.tagName;
      return t === 'TEXTAREA' || (t === 'INPUT' && /^(text|search|email|tel|number|url)$/i.test(el.type || 'text'));
    }
    function restoreScroll(el, top, tries) {
      if (!el.isConnected) return;
      var now = el.getBoundingClientRect().top, d = now - top;
      if (Math.abs(d) > 2) { selfScroll = true; window.scrollBy(0, d); setTimeout(function () { selfScroll = false; }, 60); }
      if (tries > 0) setTimeout(function () { restoreScroll(el, top, tries - 1); }, 150);
    }
    function anchor() { if (typingEl) keepTop = typingEl.getBoundingClientRect().top; }
    document.addEventListener('focusin', function (e) {
      if (!isMobile() || !isTextField(e.target)) return;
      typingEl = e.target; anchor();   /* ankkuri = kentän kohta ENNEN kuin selain vierittää sen näppäimistön yläpuolelle */
      clearTimeout(restoreTimer); clearTimeout(anchorTimer);
      document.documentElement.classList.add('lastu-k-typing');
      /* Kenttä ruudun yläosaan, jotta sen alle avautuva ehdotuslista mahtuu näppäimistön yläpuolelle. */
      var el = typingEl;
      function lift() {
        if (typingEl !== el) return;
        var want = 84, d = el.getBoundingClientRect().top - want;
        if (Math.abs(d) > 8) { selfScroll = true; window.scrollBy(0, d); setTimeout(function () { selfScroll = false; }, 60); }
      }
      anchorTimer = setTimeout(function () { lift(); setTimeout(lift, 260); setTimeout(lift, 600); }, 320);
    });
    document.addEventListener('focusout', function (e) {
      if (!typingEl || e.target !== typingEl) return;
      var el = typingEl, top = keepTop; typingEl = null;
      clearTimeout(restoreTimer); clearTimeout(anchorTimer);
      restoreTimer = setTimeout(function () {
        document.documentElement.classList.remove('lastu-k-typing');
        if (KARTTA()) { karttaLastGeom = ''; }
        restoreScroll(el, top, 10);   /* kartan koon muutos ja näppäimistön sulkeutuminen kestävät ~1 s */
        render();
      }, 60);
    });
    /* 2.10.2026: Android Chrome – näppäimistön voi sulkea (alanuoli/takaisin) ilman että kenttä menettää
       fokuksen → focusout ei laukea ja esikatselu jäi piiloon. Tunnistetaan sulkeutuminen visualViewportin
       korkeudesta ja irrotetaan fokus, jolloin yllä oleva focusout-palautus ajetaan normaalisti. */
    var vv = window.visualViewport;
    if (vv) {
      var fullH = vv.height, kbOpen = false;
      document.addEventListener('focusin', function () { kbOpen = false; });
      vv.addEventListener('resize', function () {
        var h = vv.height;
        if (!typingEl) { fullH = h; kbOpen = false; return; }      /* ei kirjoiteta → nykyinen = täysi korkeus (myös kierto) */
        if (h < fullH - 120) { kbOpen = true; return; }             /* näppäimistö auki */
        if (kbOpen && h > fullH - 80) { kbOpen = false; try { typingEl.blur(); } catch (e) {} }
      });
    }
  })();
  var stageZoom = $('#lastu-k-stage-zoom');
  function applyZoom() {
    if (!stage.classList.contains('is-zoomed')) return;
    var card = stage.querySelector('.lastu-k__stage-card'), cw = card.clientWidth; if (!cw) return;
    var ch = cw * H / W, k = cw / W;   /* canvas-px → näyttö-px ennen skaalausta */
    /* Kortti kasvaa 1,5-kertaiseksi (max 78 vh) ja KOKO puhelin kameroineen sovitetaan siihen. */
    var Hc = Math.min(Math.round(ch * 1.5), Math.round(window.innerHeight * 0.78));
    var model = currentModel(), url = model && model.img;
    var ph = (url && phoneCache[url]) || (url && winCache[url] ? { x: winCache[url].x - 70, y: winCache[url].y - 190, w: winCache[url].w + 140, h: winCache[url].h + 240 } : { x: 330, y: 20, w: 540, h: 920 });
    var sc = Math.min((Hc - 16) / (ph.h * k), (cw - 16) / (ph.w * k));
    var bx = (ph.x + ph.w / 2) * k, by = (ph.y + ph.h / 2) * k;
    /* Kortti ei saa olla skaalattua canvasia korkeampi, eikä canvas saa jättää tyhjää reunaa. */
    Hc = Math.min(Hc, Math.floor(sc * ch)); stage.style.setProperty('--k-zoom-h', Hc + 'px');
    var tx = Math.min(0, Math.max(cw - sc * cw, cw / 2 - sc * bx)), ty = Math.min(0, Math.max(Hc - sc * ch, Hc / 2 - sc * by));
    stage.style.setProperty('--k-zoom', sc.toFixed(4));
    stage.style.setProperty('--k-zoom-tx', tx.toFixed(1) + 'px');
    stage.style.setProperty('--k-zoom-ty', ty.toFixed(1) + 'px');
  }
  function setZoom(on) {
    stage.classList.toggle('is-zoomed', on);
    if (KARTTA()) { karttaLastGeom = ''; setTimeout(function () { karttaLastGeom = ''; render(); }, 60); }
    if (stageZoom) stageZoom.textContent = on ? S.zoom_out : S.zoom_in;
    if (on) applyZoom(); else ['--k-zoom', '--k-zoom-tx', '--k-zoom-ty', '--k-zoom-h'].forEach(function (v) { stage.style.removeProperty(v); });
    render();
  }
  if (stageZoom) stageZoom.addEventListener('click', function (e) { e.stopPropagation(); setZoom(!stage.classList.contains('is-zoomed')); });
  window.addEventListener('resize', function () { applyZoom(); });
  function setStage(state) {
    var prev = stage.getAttribute('data-state');
    stage.setAttribute('data-state', state);
    if (stageToggle) stageToggle.textContent = state === 'mini' ? S.preview_show : S.preview_hide;
    if (stageZoom) { stageZoom.hidden = state !== 'expand' || !isMobile(); if (!stageZoom.textContent) stageZoom.textContent = S.zoom_in; }
    if (KARTTA() && state !== 'expand' && stage.classList.contains('is-zoomed')) setZoom(false);
    if (state !== 'expand' && stage.classList.contains('is-zoomed')) setZoom(false);
    syncDock();
    if (KARTTA()) { karttaLastGeom = ''; render(); setTimeout(function () { karttaLastGeom = ''; render(); }, 420); }   /* kartta-elementti uuteen geometriaan (myös animaation jälkeen) */
    if (prev && prev !== state && isMobile() && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      stage.classList.remove('is-anim'); void stage.offsetWidth; stage.classList.add('is-anim');
      setTimeout(function () { stage.classList.remove('is-anim'); }, 380);
    }
    if (prev && prev !== state) dropLeaves();
  }
  /* ───────── Syyslehdet (26.9.2026) ─────────
     Mobiilissa esikatselukortin alta leijailee viisi pikselikoivunlehteä, kun kortti
     vaihtaa kokoa (mini ↔ iso) tai tulee näkyviin. Vain 1.9.–30.11. (toistuu vuosittain),
     kun minikortti ilmestyy ensimmäisen kerran (merkin valinta), korkeintaan kerran 3,2 s:ssa, ei prefers-reduced-motionilla. Lehdet ovat tasolla 27:
     kortin (28) alla, headerin (20) ja dockin (25) päällä; pointer-events:none. */
  var leafLast = 0;
  var LEAF_ROWS = ['...#...', '..###..', '.#####.', '#######', '#######', '.#####.', '..###..', '...#...', '...#...'];
  var LEAF_COLS = [['#e8c547', '#d4ad2f'], ['#e8c547', '#d4ad2f'], ['#e38a3a', '#c8712a'], ['#e38a3a', '#c8712a'], ['#c9463a', '#a93428']];
  function leafSvg(c) {
    var d = '', v = '';
    LEAF_ROWS.forEach(function (row, y) {
      for (var x = 0; x < row.length; x++) {
        if (row.charAt(x) !== '#') continue;
        if (x === 3 && y > 1) v += 'M' + x + ' ' + y + 'h1v1h-1z'; else d += 'M' + x + ' ' + y + 'h1v1h-1z';
      }
    });
    return '<svg viewBox="0 0 7 9" width="20" height="26" shape-rendering="crispEdges" aria-hidden="true">' +
      '<path fill="' + c[0] + '" d="' + d + '"/><path fill="' + c[1] + '" d="' + v + '"/></svg>';
  }
  function leafSeason() { var m = new Date().getMonth(); return m >= 8 && m <= 10; }   /* syys–marras */
  function dropLeaves() {
    if (!isMobile() || !leafSeason() || !Element.prototype.animate) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (Date.now() - leafLast < 3200) return;   /* ≈ yhden pudotuksen kesto */
    setTimeout(function () {                              /* kortin koonmuutosanimaatio (380 ms) valmiiksi */
      /* Vain kun kortti oikeasti näkyy: tallennettu suunnitelma palauttaa merkin jo latauksessa,
         jolloin kortti voi olla piilossa (lastu-k-stage-hidden) – lehdet putoavat vasta kun se tulee näkyviin. */
      var cs = getComputedStyle(stage), r = stage.getBoundingClientRect();
      if (document.documentElement.classList.contains('lastu-k-stage-hidden') || cs.visibility === 'hidden' || cs.display === 'none' || +cs.opacity === 0) return;
      if (!r.width || r.bottom < 0 || r.top > window.innerHeight) return;
      if (Date.now() - leafLast < 3200) return;
      leafLast = Date.now();
      var box = document.createElement('div');
      box.className = 'lastu-k-leaves';
      box.setAttribute('aria-hidden', 'true');
      box.style.cssText = 'position:fixed;left:0;top:0;width:0;height:0;z-index:27;pointer-events:none;';
      document.body.appendChild(box);
      var done = 0;
      LEAF_COLS.slice().sort(function () { return Math.random() - .5; }).forEach(function (c, i) {
        var el = document.createElement('div'), inner = document.createElement('div');
        inner.innerHTML = leafSvg(c);
        el.appendChild(inner);
        var x0 = r.left + r.width * (0.15 + 0.7 * (i / 4)) + (Math.random() * 16 - 8), y0 = r.bottom - 10;
        el.style.cssText = 'position:absolute;left:' + x0.toFixed(0) + 'px;top:' + y0.toFixed(0) + 'px;opacity:0;';
        box.appendChild(el);
        var fall = 150 + Math.random() * 70, sway = 14 + Math.random() * 12, dir = Math.random() < .5 ? -1 : 1;
        var dur = 2500 + Math.random() * 600, delay = i * 110 + Math.random() * 140;
        el.animate([
          { transform: 'translate(0,0)', opacity: 0 },
          { transform: 'translate(' + (dir * sway * .6) + 'px,' + (fall * .22) + 'px)', opacity: 1, offset: .12 },
          { transform: 'translate(' + (-dir * sway * .5) + 'px,' + (fall * .5) + 'px)', opacity: 1, offset: .45 },
          { transform: 'translate(' + (dir * sway) + 'px,' + (fall * .78) + 'px)', opacity: .9, offset: .75 },
          { transform: 'translate(' + (-dir * sway * .3) + 'px,' + fall + 'px)', opacity: 0 }
        ], { duration: dur, delay: delay, easing: 'ease-in-out', fill: 'both' }).onfinish = function () {
          if (++done === LEAF_COLS.length && box.parentNode) box.parentNode.removeChild(box);
        };
        inner.animate([{ transform: 'rotate(0deg)' }, { transform: 'rotate(' + (dir * 360) + 'deg)' }],
          { duration: dur, delay: delay, easing: 'steps(4, end)', fill: 'both' });
      });
    }, 400);
  }
  /* Mobiilidock pois näkyvistä koko suunnittelun ajaksi (mini + expand),
     palaa kun esikatselu on piilossa (paneeli ei näkyvissä) tai desktopilla. */
  function syncDock() {
    var h = document.documentElement;
    h.classList.toggle('lastu-k-preview-open', isMobile() && h.classList.contains('lastu-k-started') && !h.classList.contains('lastu-k-stage-hidden'));
  }
  function placeStage() {
    var html = document.documentElement;
    if (isMobile()) {
      html.classList.add('lastu-k-mobile'); html.classList.remove('lastu-k-desktop', 'lastu-k-show-photos');
      /* Bodyn lapseksi: teeman fade-up-animaatio jättää product-infoon transformin,
         jolloin position:fixed laskettaisiin sen suhteen eikä näkymän. */
      if (stage.parentNode !== document.body) document.body.appendChild(stage);
      if (!stage.hasAttribute('data-state') || stage.getAttribute('data-state') === 'expand' && !stage.__userExpanded) stage.setAttribute('data-state', 'mini');
      if (photosBtn) photosBtn.hidden = true;
      setStage(stage.getAttribute('data-state') || 'mini');
    } else {
      html.classList.add('lastu-k-desktop'); html.classList.remove('lastu-k-mobile');
      var gal = document.querySelector('.product__gallery-container');
      if (gal) {
        if (stage.parentNode !== gal) gal.insertBefore(stage, gal.firstChild);
        if (!photosBtn) {
          photosBtn = document.createElement('button'); photosBtn.type = 'button'; photosBtn.className = 'lastu-k__stage-photos-out';
          photosBtn.addEventListener('click', function () {
            var on = html.classList.toggle('lastu-k-show-photos');
            photosBtn.textContent = on ? S.preview_back : S.preview_photos;
          });
          gal.insertBefore(photosBtn, stage.nextSibling);
        }
        photosBtn.hidden = !html.classList.contains('lastu-k-started'); photosBtn.textContent = html.classList.contains('lastu-k-show-photos') ? S.preview_back : S.preview_photos;
      }
      setStage('expand');
    }
  }
  /* Pienennä zoomattuna → ensin takaisin normaalikokoon, vasta seuraava painallus minikorttiin. */
  if (stageToggle) stageToggle.addEventListener('click', function (e) {
    e.stopPropagation();
    if (stage.getAttribute('data-state') === 'expand' && stage.classList.contains('is-zoomed')) { setZoom(false); return; }
    var to = stage.getAttribute('data-state') === 'mini' ? 'expand' : 'mini'; stage.__userExpanded = to === 'expand'; setStage(to);
  });
  stage.addEventListener('click', function (e) {
    if (!(isMobile() && stage.getAttribute('data-state') === 'mini') || e.target.closest('button')) return;
    /* 10.10.2026 VÄISTÖ: jos pienoisesikatselun alla on konfiguraattorin painike/valinta, napautus ei avaa esikatselua
       vaan esikatselu häivähtää 2,5 s läpinäkyväksi → seuraava napautus osuu painikkeeseen (ei vahinkovalintoja).
       Esikatselu aukeaa aina ⤢-kahvasta (#lastu-k-stage-toggle) tai napauttamalla kohtaa jonka alla ei ole painiketta. */
    var under = null;
    try {
      /* elementsFromPoint = kaikki pisteen elementit päällekkäin → ensimmäinen esikatselun ulkopuolinen */
      var els = document.elementsFromPoint(e.clientX, e.clientY), el = null;
      for (var ei = 0; ei < els.length; ei++) if (!stage.contains(els[ei])) { el = els[ei]; break; }
      under = el && el.closest && el.closest('a, button, label, select, input, textarea, .lux-sum');
      if (under && !root.contains(under)) under = null;
    } catch (x) {}
    if (under) { stage.classList.add('is-dodge'); clearTimeout(stage.__dodgeT); stage.__dodgeT = setTimeout(function () { stage.classList.remove('is-dodge'); }, 2500); return; }
    stage.__userExpanded = true; setStage('expand');
  });
  placeStage();
  if (mq.addEventListener) mq.addEventListener('change', placeStage); else mq.addListener(placeStage);
  /* Mobiilissa piilota mini-esikatselu kun paneeli ei ole näkyvissä (ei roiku sivun muissa osissa) */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (en) {
      var vis = en.some(function (x) { return x.isIntersecting; });
      var wasHidden = document.documentElement.classList.contains('lastu-k-stage-hidden');
      document.documentElement.classList.toggle('lastu-k-stage-hidden', !vis); syncDock();
      if (vis && wasHidden) dropLeaves();   /* esikatselu tulee näkyviin */
    }, { rootMargin: '200px 0px 200px 0px' });
    io.observe($('.lastu-k__panel'));
  }

  /* ───────── 7. Koriin lisäys ───────── */
  function validate() {
    if (st.brand < 0 && !LOMPAKKO) return { msg: S.err_brand, el: $('#lastu-k-step-brand') };
    if (!currentModel()) return { msg: S.err_model, el: $('#lastu-k-step-model') };
    if (!currentMaterial()) return { msg: S.err_material, el: $('#lastu-k-step-material') };
    if (st.persona === 'engraving' && st.engraving < 0) return { msg: S.err_engraving, el: $('#lastu-k-engravings') };
    if (st.persona === 'upload' && !st.uploads.some(function (u) { return u.maskCanvas; })) return { msg: S.err_upload, el: $('[data-upload="upload"]') };
    if (st.persona === 'print' && !(st.print && st.print.canvas)) return { msg: S.err_upload, el: $('[data-upload="print"]') };
    if (KUWA && !st.images.some(function (im) { return im.canvas; })) return { msg: S.err_images, el: $('#lastu-k-step-images') };
    if (st.text.on && !st.text.items.some(function (t) { return cleanText(t.value).trim(); })) return { msg: S.err_text, el: $('[data-row="text"]') };
    if (SANAT && !wordList().length) return { msg: S.err_sanat, el: $('#lastu-k-step-sanat') };
    if (KARTTA() && !(st.kartta.center && st.kartta.ready)) return { msg: S.err_kartta, el: $('#lastu-k-step-kartta') };
    if (st.leka && !st.lekaCount) return { msg: S.err_leka, el: $('.lastu-k__leka') };
    return null;
  }
  function textTouchesRing() {
    var model = currentModel(), url = model && model.img, box = url && winCache[url] ? winCache[url] : { x: 400, y: 50, w: 400, h: 860 };
    var rcx = (RING.x - box.x) / box.w, rcy = (RING.y - box.y) / box.h, rx = 135 / box.w, ry = 135 / box.h;
    return liveTexts().some(function (t) {
      if (!t.tf) return false;
      var hw = t.tf.s / 2, hh = (t.tf.s * box.w * t.maskCanvas.height / t.maskCanvas.width) / 2 / box.h;
      return Math.abs(t.tf.x - rcx) < hw + rx && Math.abs(t.tf.y - rcy) < hh + ry;
    });
  }
  function upsellEligible() {
    if (LOMPAKKO || st.magsafe || st.persona === 'velcro' || KUWA || VELCRO) return false;
    if (CAMO || SANAT || KARTTA()) return true;
    if (st.persona === 'upload' || st.persona === 'print') return false;
    return !textTouchesRing();
  }
  /* 9.10.2026 UX: korin "Muokkaa tuotettasi" → tuotesivu samoilla valinnoilla (malli, materiaali, MagSafe, KRIP/KARB, LEKA)
     + muokkaa=<ryhmä> → koko design palautetaan ja "Päivitä ostoskori" korvaa vanhan version (§9). */
  function editUrl() {
    try {
      var m = currentModel(), mat = currentMaterial(), q = [];
      if (m && !LOMPAKKO) q.push('malli=' + encodeURIComponent(mSlug(m.name)));
      if (mat) q.push('materiaali=' + encodeURIComponent(mSlug(mat.name)));
      if (st.magsafe) q.push('magsafe=1');
      Object.keys(st.addons || {}).forEach(function (i) { var a = D.addons[+i]; if (!st.addons[i] || !a) return; if (a.type === 'krip') q.push('krip=1'); else if (a.type === 'karb') q.push('karb=1'); });
      if (st.leka && st.lekaCount) q.push('leka=' + st.lekaCount);
      q.push('muokkaa=' + encodeURIComponent(upsellId));   /* 9.10.2026: oikea muokkaus (§9) */
      return location.pathname + '?' + q.join('&');
    } catch (e) { return location.pathname; }
  }
  function buildItems() {
    var K = D.consts.keys, b = currentBrand(), m = currentModel(), mat = currentMaterial();
    var main = { id: +root.getAttribute('data-variant-id'), quantity: 1, properties: {} };
    var P = main.properties;
    P['_customily-customization-url'] = editUrl();
    if (!LOMPAKKO) { P[K.brand] = b.name; P[b.propKey] = m.orderName; }
    P[K.material] = mat.orderName;
    /* Korin näyttönimet (käännetyt, lyhyet) – tilausnimet pysyvät tuotannolle ennallaan. */
    P['_lastu_materiaali'] = mat.name;
    var lines = [];
    function addon(variantId, optionName) {
      if (!variantId) { log('lisäosalta puuttuu variantti', optionName); return; }
      var props = {}; props['_customily-option-name'] = optionName; props['_customily-upsell-id'] = upsellId; props['_customily-upsell-multiplier'] = '1';
      lines.push({ id: +variantId, quantity: 1, properties: props });
    }
    addon(mat.variantId, K.material); if (!LOMPAKKO) addon(m.variantId, b.propKey);   /* tilaukseen: materiaali ennen mallia */
    if (st.persona === 'engraving') { P[K.engravingRow] = 'on'; P[K.engravingPick] = D.engravings[st.engraving].orderName; P['_lastu_kaiverrus'] = D.engravings[st.engraving].name; addon(D.consts.engravingCollection, K.engravingRow); }
    if (st.persona === 'upload') {
      /* 1–3 kaiverruskuvaa: kaikki samassa tuotanto-PNG:ssä, yksi +5 € rivi. Kuvakohtaiset tiedot pilkulla eroteltuina. */
      var ups = st.uploads.filter(function (u) { return u.maskCanvas; });
      P[K.upload] = 'on';
      if (ups.length > 1) P['Kuvia:'] = String(ups.length);
      P['_lastu_kuva_tila'] = ups.map(function (u) { return u.mode === 'ai' && hasAi(u) ? 'piirros' : u.resolvedMode; }).join(', ');
      if (ups.some(function (u) { return u.removeBg && u.cut; })) P['Poista kuvan tausta (kaiverrus)'] = 'on';
      if (ups.some(function (u) { return u.round; })) P['Pyöreä kuva (kaiverrus)'] = 'on';
      addon(D.consts.engraving5, K.upload);
    }
    if (st.persona === 'print') { P[K.print] = 'on'; if (st.print.removeBg) P[K.removeBg] = 'on'; if (st.print.round) P['Pyöreä kuva (painatus)'] = 'on'; addon(D.consts.print7, K.print); }
    if (KUWA) P[K.images] = String(st.images.filter(function (im) { return im.canvas; }).length);
    if (KARTTA()) { if (KARTTA_ADDON && st.persona === 'kartta') { P[K.kartta] = 'on'; addon(D.consts.kartta7, K.kartta); }   /* 26.9.2026: property päätuotteelle → kori näyttää karttarivin hinnan */ var kc = st.kartta.center; P['Sijainti:'] = st.kartta.place || st.kartta.q; P['Koordinaatit:'] = kc ? kc[1].toFixed(5) + ', ' + kc[0].toFixed(5) : ''; P['Zoom:'] = st.kartta.zoom.toFixed(2); P['Karttatyyli:'] = ({ city: 'Kaupunki', nature: 'Luonto', terrain: 'Maasto' })[st.kartta.style]; var ktx = karttaText(); if (ktx) { P['Alalaidan teksti:'] = ktx; P['Tekstin fontti:'] = ({ poster: 'Bebas Neue', head: 'DM Serif Display', body: 'Hanken Grotesk', mono: 'DM Mono' })[st.kartta.font]; P['Tekstin koko:'] = ({ s: 'Pieni', m: 'Oletus', l: 'Suuri' })[st.kartta.size]; } if (st.kartta.pin) P['Nasta keskipisteeseen'] = 'on'; P['_lastu_kartta'] = JSON.stringify({ center: kc, zoom: st.kartta.zoom, style: st.kartta.style, pin: st.kartta.pin }); }
    if (SANAT) { P['Sanat:'] = wordList().join(' · '); P['Sanojen fontti:'] = ({ brush: 'Satisfy', script: 'Caveat', poster: 'Bebas Neue', head: 'DM Serif Display', body: 'Hanken Grotesk', mono: 'DM Mono' })[st.words.font]; P['_lastu_sanat'] = JSON.stringify({ seed: st.words.seed, density: st.words.density, font: st.words.font }); }
    if (st.text.on) {
      /* 29.9.2026: 1–8 tekstiä → "Kaiverrettava teksti:", "Kaiverrettava teksti 2:"… (kaikki samassa tuotanto-PNG:ssä). */
      var tvals = st.text.items.map(function (t) { return cleanText(t.value).trim(); }).filter(Boolean);
      tvals.forEach(function (v, vi) { P[vi ? 'Kaiverrettava teksti ' + (vi + 1) + ':' : K.textValue] = v; });
      if (tvals.length > 1) P['Tekstejä:'] = String(tvals.length);
      P[K.text] = 'on'; P[K.textFont] = ({ brush: 'Satisfy', head: 'DM Serif Display', hand: 'Gochi Hand', body: 'Hanken Grotesk', mono: 'DM Mono' })[st.text.font];
      addon(D.consts.text3, K.text);
    }
    if (st.persona === 'velcro' && !VELCRO) { P[K.velcro] = 'on'; addon(D.consts.velcro, K.velcro); }
    if (st.magsafe) {
      P[K.magsafe] = 'on'; addon(D.consts.magsafe, K.magsafe);
      Object.keys(st.addons).forEach(function (i) { var a = D.addons[i]; P[a.propKey] = 'on'; addon(a.variantId, a.propKey); });
    }
    if (st.leka && st.lekaCount) { P[K.leka] = 'on'; P[K.lekaCount] = D.consts.lekaValues[st.lekaCount - 1]; addon(D.consts.leka[st.lekaCount - 1], K.leka); }
    P['_customily-upsell-main-id'] = upsellId;
    try { P['_lastu_design'] = JSON.stringify(memBase()); } catch (e) {}   /* §9 muokkauksen varakopio (ei kuvia) */
    P['_lastu_konfiguraattori'] = LOMPAKKO ? 'lompakko-v1' : 'v1.0';
    /* KORIN LISÄMYYNTI (20.9.2026): MagSafe + KRIP 10 € tarjotaan korissa vain jos rengas ei
       peitä asiakkaan omaa designia: ei MagSafea/Velcroa; camo aina; muuten tyhjä kuori tai
       kaiverrus valikoimasta; tekstikaiverrus vain jos teksti on renkaan ulkopuolella. */
    if (upsellEligible()) P['_lastu_upsell_ok'] = 'magsafe-krip';
    return [main].concat(lines);
  }
  /* 3.10.2026: esikatselun POHJA ilman MagSafea ja lisäosia (_lastu-pohja) → korissa lisäosan
     poisto (×) piirtää uuden esikatselun: pohja + jäljelle jäävät kerrokset mallin mittakaavassa (_lastu_acc).
     Piirretään hetkeksi ilman lisäosia, otetaan kuva ja palautetaan. Epäonnistuminen → null (ei estä ostoa). */
  function baseSnapshot() {
    if (LOMPAKKO || !(st.magsafe || Object.keys(st.addons).length)) return Promise.resolve(null);
    var sm = st.magsafe, sa = st.addons, done = false;
    var restore = function () { if (done) return; done = true; st.magsafe = sm; st.addons = sa; render(); };
    st.magsafe = false; st.addons = {};
    var work = Promise.resolve(draw()).then(function () {
      var c = document.createElement('canvas'); c.width = W; c.height = H;
      var x = c.getContext('2d'); x.fillStyle = '#F4F1EB'; x.fillRect(0, 0, W, H);
      if (KARTTA()) karttaComposite(c); else x.drawImage(canvas, 0, 0, W, H);
      var u = c.toDataURL('image/jpeg', 0.8); restore(); return u;
    }).catch(function () { restore(); return null; });
    return Promise.race([work, new Promise(function (r) { setTimeout(function () { restore(); r(null); }, 2500); })]);
  }
  function snapshot() {
    try {
      var c = document.createElement('canvas'); c.width = W; c.height = H;
      var x = c.getContext('2d'); x.fillStyle = '#F4F1EB'; x.fillRect(0, 0, W, H);
      if (KARTTA()) karttaComposite(c); else x.drawImage(canvas, 0, 0, W, H);
      kripSnapshot(x);
      return c.toDataURL('image/jpeg', 0.8);   /* 3.10.: 0.86 → 0.8 (~25 % pienempi lähetys) */
    } catch (e) { return null; }
  }
  /* Pohjakuva selaimeen upsell-id:llä (6 uusinta). Kori: lastu-concept.js initLastuAddonRemove. */
  function saveBase(uid, dataUrl) {
    if (!uid || !dataUrl) return;
    var LS = 'lastuBase';
    for (var tries = 0; tries < 3; tries++) {
      try {
        var cur = JSON.parse(localStorage.getItem(LS) || '{}'); cur[uid] = { t: Date.now(), d: dataUrl };
        var keys = Object.keys(cur).sort(function (a, b) { return cur[b].t - cur[a].t; });
        keys.slice(6 - tries * 2).forEach(function (k) { if (k !== uid) delete cur[k]; });
        localStorage.setItem(LS, JSON.stringify(cur)); return;
      } catch (e) {}
    }
  }
  function rememberPreview(key, dataUrl) {
    if (!key || !dataUrl) return;
    window.__lastuPreviewByKey = window.__lastuPreviewByKey || {}; window.__lastuPreviewByKey[key] = dataUrl;
    try { var LS = 'lastuCartPreviews', cur = JSON.parse(localStorage.getItem(LS) || '{}'); cur[key] = dataUrl; localStorage.setItem(LS, JSON.stringify(cur)); } catch (e) {}
  }
  function setBusy(on) {
    var b = submitButton(); if (!b) return;
    if (on) { b.setAttribute('aria-busy', 'true'); b.setAttribute('aria-disabled', 'true'); }
    else { b.removeAttribute('aria-busy'); b.removeAttribute('aria-disabled'); }
  }
  /* ───────── Ostonappi: Kiitos! + lehtipölähdys (26.9.2026) ─────────
     Kun lisäys lähtee (validointi ok), napin teksti vaihtuu "Kiitos!"/"Thank you!" ja
     syyskaudella (leafSeason) napista pölähtää 6 pikselilehteä. Epäonnistuessa teksti
     palautuu heti; onnistuessa kun kiitos on näkynyt ≥ 1,6 s. */
  var thanksAt = 0;
  /* 9.10.2026: jos koriin-animaatio (assets/lastu-atc-bag.js, teema-asetus) on päällä, se korvaa Kiitos-tilan ja lehdet.
     Kori aukeaa vasta animaation jälkeen (bag pidättää cart-drawer.show:n). */
  function bag() { return window.lastuAtcBag; }
  function thanksStart() {
    var b = submitButton(); if (!b) return;
    if (bag() && bag().start(b)) { thanksAt = -1; return; }
    if (!S.thanks) return;
    var lab = b.querySelector('.lastu-k-thanks');
    if (!lab) { lab = document.createElement('span'); lab.className = 'lastu-k-thanks'; lab.setAttribute('aria-hidden', 'true'); b.appendChild(lab); }
    /* 26.9.2026: kiitoksen alle pieni tilarivi, jotta asiakas tietää lisäyksen olevan käynnissä. */
    lab.innerHTML = ''; var t1 = document.createElement('strong'), t2 = document.createElement('small');
    t1.textContent = S.thanks; t2.textContent = lang === 'en' ? 'Adding to cart…' : 'Lisätään ostoskoriin…';
    lab.appendChild(t1); lab.appendChild(t2); b.classList.add('is-lastu-thanks'); thanksAt = Date.now();
    burstLeaves(b);
  }
  function thanksEnd(ok) {
    var b = submitButton(); if (!b) return;
    if (thanksAt === -1 && bag()) { thanksAt = 0; if (ok) bag().done(); else bag().fail(); return; }
    var wait = ok ? Math.max(0, 1600 - (Date.now() - thanksAt)) : 0;
    setTimeout(function () { b.classList.remove('is-lastu-thanks'); }, wait);
  }
  function burstLeaves(b) {
    if (!leafSeason() || !Element.prototype.animate) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var r = b.getBoundingClientRect(); if (!r.width) return;
    var box = document.createElement('div'); box.className = 'lastu-k-leaves'; box.setAttribute('aria-hidden', 'true');
    box.style.cssText = 'position:fixed;left:0;top:0;width:0;height:0;z-index:40;pointer-events:none;';
    document.body.appendChild(box);
    var cols = LEAF_COLS.concat([LEAF_COLS[0]]), done = 0;
    cols.forEach(function (c, i) {
      var el = document.createElement('div'), inner = document.createElement('div');
      inner.innerHTML = leafSvg(c); el.appendChild(inner);
      var x0 = r.left + r.width / 2 - 10 + (Math.random() * 40 - 20), y0 = r.top + r.height / 2 - 13;
      el.style.cssText = 'position:absolute;left:' + x0.toFixed(0) + 'px;top:' + y0.toFixed(0) + 'px;opacity:0;';
      box.appendChild(el);
      var ang = (-160 + i * (140 / (cols.length - 1)) + Math.random() * 14 - 7) * Math.PI / 180;   /* viuhka ylöspäin */
      var dist = 50 + Math.random() * 45, px = Math.cos(ang) * dist, py = Math.sin(ang) * dist;
      var fall = 110 + Math.random() * 60, sway = 10 + Math.random() * 10, dir = px < 0 ? -1 : 1;
      var dur = 1900 + Math.random() * 500, delay = Math.random() * 90;
      el.animate([
        { transform: 'translate(0,0) scale(.4)', opacity: 0 },
        { transform: 'translate(' + px.toFixed(0) + 'px,' + py.toFixed(0) + 'px) scale(1)', opacity: 1, offset: .18 },
        { transform: 'translate(' + (px + dir * sway).toFixed(0) + 'px,' + (py + fall * .45).toFixed(0) + 'px)', opacity: 1, offset: .55 },
        { transform: 'translate(' + (px - dir * sway * .6).toFixed(0) + 'px,' + (py + fall).toFixed(0) + 'px)', opacity: 0 }
      ], { duration: dur, delay: delay, easing: 'cubic-bezier(.2,.7,.4,1)', fill: 'both' }).onfinish = function () {
        if (++done === cols.length && box.parentNode) box.parentNode.removeChild(box);
      };
      inner.animate([{ transform: 'rotate(0deg)' }, { transform: 'rotate(' + (dir * 450) + 'deg)' }],
        { duration: dur, delay: delay, easing: 'steps(5, end)', fill: 'both' });
    });
  }
  function onSubmit(e) {
    if (!form || e.target !== form) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var v = validate(); if (v) { track('koriin_puuttuu', { arvo: (v.el && v.el.id || '').replace('lastu-k-step-', '') || 'muu' }); showError(v.msg, v.el); return; }
    track('koriin_klikkaus');
    showError(null); setBusy(true);
    if (!e.__lastuThanks) { e.__lastuThanks = true; thanksStart(); }
    /* KARTTA(): esikatselu otetaan ENNEN tuotantorenderöintiä (pixelRatio-vaihto tyhjentää kartan hetkeksi). */
    if (KARTTA() && !e.__karttaReady) { e.__preview = snapshot(); karttaProductionPng().then(function (png) { e.__karttaReady = true; e.__karttaPng = png; onSubmit(e); }); return; }
    if (!e.__baseReady) { e.__preview = e.__preview || snapshot(); var acc0 = accXf(); e.__acc = acc0.s + ',' + acc0.dy; baseSnapshot().then(function (u) { e.__baseReady = true; e.__base = u; onSubmit(e); }); return; }
    var items = buildItems(), preview = e.__preview || snapshot();
    log('items', items);
    var routes = (window.theme && theme.routes) || {}, root_ = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var addUrl = routes.cart_add_url || (root_ + 'cart/add.js');
    /* FormData: Shopify tallentaa File-arvoiset propertyt CDN:lle ja kirjoittaa
       propertyyn URL:n → esikatselu + tuotantotiedosto tilaukseen ilman omaa palvelinta. */
    var fd = new FormData();
    /* JÄRJESTYS TILAUKSESSA (18.9.2026): Shopifyn kori näyttää rivit käänteisessä
       lisäysjärjestyksessä (uusin ylimpänä) ja tilaus perii korin järjestyksen. Siksi
       rivit lähetetään KÄÄNTEISESSÄ järjestyksessä: LEKA, lisäosat, MagSafe, personointi,
       materiaali, malli ja viimeisenä päätuote → tilauksessa päätuote ensin, sen alla
       materiaali, malli, personointi, MagSafe, lisäosat, LEKA. Tiedostot liitetään
       päätuotteen indeksiin. */
    items = items.slice().reverse(); var MI = items.length - 1;
    items.forEach(function (it, i) {
      fd.append('items[' + i + '][id]', it.id); fd.append('items[' + i + '][quantity]', it.quantity);
      Object.keys(it.properties).forEach(function (k) { fd.append('items[' + i + '][properties][' + k + ']', it.properties[k]); });
    });
    var pv = dataUrlToBlob(preview); if (pv) fd.append('items[' + MI + '][properties][_customily-preview]', new File([pv], 'lastu-esikatselu.jpg', { type: 'image/jpeg' }));
    /* 3.10.2026: pohjakuvaa (_lastu-pohja) EI lähetetä (191 kB hidasti lisäystä ~1,5 s) → tallennetaan selaimeen (lastuBase), kori käyttää sitä lisäosan poistossa. */
    if (e.__base) fd.append('items[' + MI + '][properties][_lastu_acc]', e.__acc || '1,0');
    /* Kaiverrus: yksi tiedosto (_customily-production-url) jossa kuvat + teksti yhdessä.
       Väripainatus (KUWA/print): painotiedosto + tekstikaiverrus erikseen (eri koneet). */
    var mainProd, txt = null;
    if (KARTTA()) mainProd = e.__karttaPng;
    else if (printProcess()) { mainProd = printPng(); txt = textPng(); if (!mainProd) { mainProd = txt; txt = null; } }
    else mainProd = productionPng();
    var prod = dataUrlToBlob(mainProd); if (prod) fd.append('items[' + MI + '][properties][_customily-production-url]', new File([prod], 'lastu-tuotanto.png', { type: 'image/png' }));
    var tb = dataUrlToBlob(txt); if (tb) fd.append('items[' + MI + '][properties][_lastu-tekstikaiverrus-url]', new File([tb], 'lastu-tekstikaiverrus.png', { type: 'image/png' }));
    /* Asiakkaan alkuperäiset kaiverruskuvat liitteiksi tuotannolle (_Alkuperäinen kuva 1…3). */
    if (st.persona === 'upload') st.uploads.forEach(function (u, i) { if (u.maskCanvas && u.file) fd.append('items[' + MI + '][properties][_Alkuperäinen kuva ' + (i + 1) + ']', u.file, u.file.name || ('kuva-' + (i + 1))); });
    /* KUWA: myös alkuperäiset kuvat talteen (_lastu-kuva-1…5) tuotannon varalle. */
    if (KUWA) st.images.forEach(function (im, i) { if (im.canvas && im.file) fd.append('items[' + MI + '][properties][_lastu-kuva-' + (i + 1) + ']', im.file, im.file.name || ('kuva-' + (i + 1))); });
    fetch(addUrl, { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || res.j.status) { thanksEnd(false); showError(res.j.description || res.j.message || S.err_net); return; }
        var added = res.j.items || [], mainId = +root.getAttribute('data-variant-id'), mainLine = null;
        for (var i = 0; i < added.length; i++) if (+added[i].variant_id === mainId || +added[i].id === mainId) { mainLine = added[i]; rememberPreview(added[i].key, preview); break; }
        saveBase(upsellId, e.__base);
        /* 3.10.2026 VARMUUS: jokainen lähetetty rivi oltava vastauksessa → puuttuvat lisätään heti uudelleen (ilman tiedostoja). */
        var got = added.map(function (it) { return +it.variant_id; }), missing = [];
        items.forEach(function (it) { var ix = got.indexOf(+it.id); if (ix >= 0) got.splice(ix, 1); else missing.push(it); });
        var fix = missing.length ? fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: missing.map(function (it) { return { id: it.id, quantity: it.quantity, properties: it.properties }; }) }) })
          .then(function () { log('puuttuvat rivit lisätty', missing); }).catch(function () {}) : Promise.resolve();
        res.added = added; res.mainLine = mainLine;
        return fix.then(function () { return res; });
      })
      .then(function (res) {
        if (!res) return;
        var gidAdded = upsellId;
        return editReplace(res).then(function () { editSave(gidAdded); return addedFlow(res, preview); });
      })
      .catch(function (err) { log('add error', err); thanksEnd(false); showError(S.err_net); })
      .then(function () { setBusy(false); });
  }
  function addedFlow(res, preview) {
        upsellId = '_lastu-id-' + (window.crypto && crypto.randomUUID ? crypto.randomUUID() : Date.now().toString(36));
        if (hiddenUpsell) hiddenUpsell.value = upsellId;
        /* 3.10.2026 NOPEUS: kori aukeaa heti; esikatselulinkki (/cart/change.js ~0,5 s) taustalla ja sen jälkeen hiljainen päivitys. */
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
        try { var cd = document.querySelector('cart-drawer'); if (cd && typeof cd.show === 'function' && !cd.hasAttribute('open')) cd.show(submitButton()); } catch (e2) {}
        document.dispatchEvent(new CustomEvent('lastu-k:added', { detail: { items: res.added } }));
        /* 9.10.2026: headerin <cart-count> kuuntelee teeman pubsubia – tämän teki ennen Customily-silta (poistettu). */
        fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
          if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'lastu-konfiguraattori', cart: cart });
        }).catch(function () {});
        memClearDraft(); thanksEnd(true);
        if (res.mainLine && window.__lastuPreviewLink) window.__lastuPreviewLink(res.mainLine).then(function (nk) {
          if (!nk) return; rememberPreview(nk, preview);
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false, source: 'lastu-preview-link' } }));
        });
  }
  document.addEventListener('submit', onSubmit, true);

  /* ───────── Käynnistys ───────── */
  onMaterialChange(); updatePrice(); render();
  window.__lastuK = { state: st, render: render, productionPng: productionPng, buildItems: buildItems, data: D };
  /* 9.10.2026: apufunktiot vaiheiden tiivistykselle (assets/lastu-vaiheet.js) */
  Object.assign(window.__lastuK, { validate: validate, showError: showError, submitButton: submitButton, money: money, total: function () { return basePrice + extras(); }, currentModel: currentModel, currentMaterial: currentMaterial, isMobile: isMobile, S: S });
  document.dispatchEvent(new CustomEvent('lastu-k:ready'));

  /* ───────── 9.10.2026 UX: vaihekohtainen mittaus (kohta 11) ─────────
     Shopify.analytics.publish('lastu_konfiguraattori', {vaihe,…}) → mukautettu pikseli välittää GA4:ään
     (koodi: Shopify Claude/ux-0910/lastu-konfiguraattori-pikseli.js). Sama data myös dataLayeriin. Kerran per vaihe per sivu. */
  var trkDone = {};
  function track(vaihe, extra) {
    try {
      var key = vaihe + (extra && extra.arvo ? ':' + extra.arvo : ''); if (trkDone[key]) return; trkDone[key] = 1;
      var m = currentModel(), d = { vaihe: vaihe, tuote: location.pathname.split('/').pop(), malli: m ? m.name : '', mobiili: isMobile() };
      if (extra) Object.keys(extra).forEach(function (k) { d[k] = extra[k]; });
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish('lastu_konfiguraattori', d);
      (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'lastu_konfiguraattori' }, d));
    } catch (e) {}
  }
  track('aloitus');
  root.addEventListener('change', function (e) {
    var t = e.target; if (!t || !t.getAttribute) return;
    var v = t.hasAttribute('data-brand-index') ? ['merkki'] : t.matches('select[data-brand-index]') ? ['malli'] : t.hasAttribute('data-material-index') ? ['materiaali']
      : t.hasAttribute('data-persona') ? ['personointi', t.getAttribute('data-persona')] : t.hasAttribute('data-engraving-index') ? ['kaiverrus']
      : t.hasAttribute('data-magsafe') ? ['magsafe'] : t.hasAttribute('data-addon-index') ? ['lisaosa', (D.addons[+t.getAttribute('data-addon-index')] || {}).type || '']
      : t.hasAttribute('data-leka') ? ['leka'] : t.hasAttribute('data-kartta-style') ? ['kartta'] : null;
    if (v && t.checked !== false) track(v[0], v[1] ? { arvo: v[1] } : null);
    /* virhe pois kun puuttuva asia on korjattu */
    setTimeout(function () {
      if (errorEl && !errorEl.hidden && errorEl.parentNode !== errorHome) { var r = null; try { r = validate(); } catch (e2) {} if (!r || !errorEl.parentNode.contains(r.el)) showError(null); }
      atcNeedState();
    }, 0);
  }, true);
  /* 10.10.2026 (käyttäjä): kaiverruksen valinta kokoelmasta tai MagSafe-lisäosan (KRIP/KARB…) valinta avaa mobiilin esikatselun isoksi
     – sama käytös kuin oman kuvan lisäyksessä (refreshGestureLayer). Vain asiakkaan oma napautus (isTrusted), ei esivalinnat/palautus. */
  root.addEventListener('change', function (e) {
    var t = e.target; if (!e.isTrusted || !t || !t.hasAttribute || t.checked === false) return;
    if (!t.hasAttribute('data-engraving-index') && !t.hasAttribute('data-addon-index')) return;
    if (!isMobile() || stage.getAttribute('data-state') !== 'mini') return;
    setTimeout(function () { if (stage.getAttribute('data-state') === 'mini') { stage.__userExpanded = true; setStage('expand'); } }, 80);
  });
  document.addEventListener('lastu-k:added', function () { track('koriin_lisatty', { summa: (basePrice + extras()) / 100 }); });
  atcNeedState(); setTimeout(atcNeedState, 1500);
  /* 10.10.2026: Valmis-rivin "Siirry koriin ↓" – pehmeä vieritys koriin-napille niin, että yläpuolella näkyvät yhä
     MagSafe/LEKA (autetaan, mutta lisämyynti ei katoa näkyvistä) ja alapuolella toimitus-/takuuinfo.
     Perillä nappi välähtää kerran (.lastu-k-atc-here). */
  root.addEventListener('click', function (e) {
    var go = e.target.closest && e.target.closest('[data-req-go]'); if (!go) return;
    e.preventDefault();
    var b = submitButton(); if (!b) return;
    /* 10.10.2026 b (käyttäjä): kohde = napin alla olevan luottamusruudukon (toimitus, palautus, takuu) alareuna näytön alareunaan
       → nappi + sen alapuolinen info näkyvät; matalalla näytöllä nappi pidetään vähintään 120 px yläreunasta. */
    var r = b.getBoundingClientRect(), grid = document.querySelector('.lastu-atc__grid'), py = window.pageYOffset, y;
    if (grid && grid.getClientRects().length) {
      y = py + grid.getBoundingClientRect().bottom - window.innerHeight + 16;
      if (r.top - (y - py) < 120) y = py + r.top - 120;
    } else y = py + r.bottom - window.innerHeight + 80;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    clearTimeout(go.__t);
    go.__t = setTimeout(function () { b.classList.remove('lastu-k-atc-here'); void b.offsetWidth; b.classList.add('lastu-k-atc-here'); setTimeout(function () { b.classList.remove('lastu-k-atc-here'); }, 1400); }, 650);
    try { track('siirry_koriin'); } catch (x) {}
  });
  /* 10.10.2026: hinnan vieressä oleva "Suunnittele ↓" (main-product.liquid, data-lastu-jump) → pehmeä vieritys konfiguraattoriin.
     Kohde AINA sama (käyttäjän kuvakaappaukset 10.10.): konfiguraattorin musta yläkaista ~206 px yläreunasta (max 32 % näytöstä),
     jolloin yllä näkyvät "Lue miten Lastun kuoret suojaavat" -linkit. Ei nostoa valintojen määrän mukaan (käyttäjä: ei alemmas). */
  document.addEventListener('click', function (e) {
    var j = e.target.closest && e.target.closest('[data-lastu-jump]'); if (!j) return;
    e.preventDefault();
    var py = window.pageYOffset, vh = window.innerHeight, kTop = py + root.getBoundingClientRect().top;
    var y = kTop - Math.min(206, Math.round(vh * 0.32));
    /* "Lue miten…"-linkit (.lastu-seo-intro__links) näkyviin ~28 px yläreunasta, jos välissä on lisäsisältöä (esim. kirjautuneen
       kanta-asiakaslaatikko) – kuitenkin niin, että konfiguraattorin kaista jää näytön yläpuoliskolle. */
    var lk = document.querySelector('.lastu-seo-intro__links');
    if (lk && lk.getClientRects().length) y = Math.max(Math.min(y, py + lk.getBoundingClientRect().top - 28), kTop - Math.round(vh * 0.55));
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
    try { track('suunnittele_linkki'); } catch (x) {}
  });
  /* 10.10.2026: kirjoitus (tekstikaiverrus, sanat, kartan paikka) päivittää napin + Valmis-rivin heti, ei vasta seuraavasta valinnasta */
  root.addEventListener('input', function () { clearTimeout(atcNeedState.__t); atcNeedState.__t = setTimeout(atcNeedState, 150); }, true);
  log('valmis', D);

  /* ───────── 8. Muisti: localStorage (merkki+malli, kaikki tuotteet) + IndexedDB (tuotekohtainen luonnos kuvineen), 30 pv ─────────
     - Merkki ja malli täytetään automaattisesti kaikilla tuotteilla.
     - Tuotekohtainen luonnos: < 12 h → "Jatka siitä mihin jäit" -painike; ≥ 12 h → palautetaan heti + "Aloita alusta".
     - Luonnos poistetaan kun tuote on lisätty koriin. Kuvat, Photoroom-tulokset ja piirros tallennetaan, ettei kutsuja toisteta. */
  var MEM_MS = 30 * 864e5, MEM_AUTO_MS = 0,   /* 2.10.2026: luonnos palautetaan aina heti (ennen < 12 h → Jatka-painike) */ MEM_G = 'lastu-k-global', MEM_PID = String(root.getAttribute('data-product-id') || '');
  var memRestoring = false, memTimer = null;
  /* 30.9.2026 korjaus: tallentamaton luonnos (Jatka-laatikko näkyvissä) ei saa ylikirjoittua sillä, että
     sivun avautuessa malli täytetään automaattisesti → tallennetaan vasta kun asiakas tekee oikean valinnan. */
  var memPending = null, memDefaultMat = st.material;
  function memValue(t) { return !!(t && String(t.value || '').trim()); }
  /* Onko luonnoksessa jotain muuta kuin merkki + malli + oletusmateriaali? */
  function memHasContent(d) {
    if (!d) return false;
    return !!(d.persona || d.magsafe || d.leka || d.matChanged ||
      (d.text && d.text.on && ((d.text.items || []).some(memValue) || memValue(d.text))) ||
      (d.uploads && d.uploads.length) || d.upload || d.print || (d.images && d.images.length) ||
      (d.kartta && d.kartta.center) || (d.words && d.words.list && d.words.list.length));
  }
  function memStateHasContent() {
    return !!((st.persona && !(VELCRO && st.persona === 'velcro')) || st.magsafe || st.leka || st.material !== memDefaultMat ||
      (st.text.on && st.text.items.some(memValue)) || st.uploads.length || (st.images && st.images.length) ||
      (KARTTA_MODE && st.kartta.center) || (SANAT && wordList().length));
  }
  function lsGet(k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function idb() {
    return new Promise(function (res, rej) {
      try {
        var r = indexedDB.open('lastu-k', 2);
        r.onupgradeneeded = function () { var db = r.result; if (!db.objectStoreNames.contains('drafts')) db.createObjectStore('drafts'); if (!db.objectStoreNames.contains('cache')) db.createObjectStore('cache'); };
        r.onsuccess = function () { res(r.result); }; r.onerror = function () { rej(r.error); }; r.onblocked = function () { rej(new Error('blocked')); };
      } catch (e) { rej(e); }
    });
  }
  function idbOp(mode, fn, store) {
    return idb().then(function (db) {
      return new Promise(function (res, rej) {
        var t = db.transaction(store || 'drafts', mode), req = fn(t.objectStore(store || 'drafts'));
        req.onsuccess = function () { res(req.result); }; req.onerror = function () { rej(req.error); };
      });
    }).catch(function (e) { log('idb', e); return null; });
  }
  function canvasBlob(c) { return new Promise(function (res) { if (!c) return res(null); try { c.toBlob(function (b) { res(b); }, 'image/png'); } catch (e) { res(null); } }); }
  function imgBlob(img) { if (!img) return Promise.resolve(null); var c = document.createElement('canvas'); c.width = img.naturalWidth || img.width; c.height = img.naturalHeight || img.height; c.getContext('2d').drawImage(img, 0, 0); return canvasBlob(c); }
  function idBlob(id) { if (!id) return Promise.resolve(null); var c = document.createElement('canvas'); c.width = id.width; c.height = id.height; c.getContext('2d').putImageData(id, 0, 0); return canvasBlob(c); }
  function blobImg(b) { return new Promise(function (res) { if (!b) return res(null); var im = new Image(); im.onload = function () { res(im); }; im.onerror = function () { res(null); }; im.src = URL.createObjectURL(b); }); }
  function blobCanvas(b) { return blobImg(b).then(function (im) { if (!im) return null; var c = document.createElement('canvas'); c.width = im.naturalWidth; c.height = im.naturalHeight; c.getContext('2d').drawImage(im, 0, 0); return c; }); }
  function tfCopy(tf) { return tf ? { x: tf.x, y: tf.y, s: tf.s, r: tf.r } : null; }

  /* Design ilman kuvatiedostoja (synkroninen) – myös korin muokkauksen varakopio (_lastu_design). */
  function memBase() {
    var b = currentBrand(), m = currentModel(), mat = currentMaterial();
    return {
      ts: Date.now(), mode: MODE, brand: b ? b.name : null, model: m ? m.name : null, material: mat ? mat.name : null, matChanged: st.material !== memDefaultMat,
      persona: st.persona, engraving: st.engraving >= 0 && D.engravings[st.engraving] ? D.engravings[st.engraving].name : null,
      magsafe: st.magsafe, addons: Object.keys(st.addons).map(function (i) { return D.addons[i].name; }), leka: st.leka, lekaCount: st.lekaCount,
      text: { on: st.text.on, font: st.text.font, align: st.text.align, items: st.text.items.map(function (t) { return { value: t.value, tf: tfCopy(t.tf) }; }) },
      words: SANAT ? { list: wordList(), font: st.words.font, seed: st.words.seed, density: st.words.density } : null,
      kartta: KARTTA() ? { q: st.kartta.q, place: st.kartta.place, center: st.kartta.center, zoom: st.kartta.zoom, style: st.kartta.style, text: st.kartta.text, mode: st.kartta.mode, font: st.kartta.font, size: st.kartta.size, pin: st.kartta.pin } : null,
      upload: null, print: null, images: []
    };
  }
  function memSerialize() {
    var d = memBase();
    var jobs = [];
    d.uploads = [];
    st.uploads.forEach(function (u) {
      if (!u.file) return;
      var e = { file: u.file, name: u.name, tf: tfCopy(u.tf), mode: u.mode, detail: u.detail, dark: u.dark, round: !!u.round, roundPos: u.roundPos, removeBg: !!u.removeBg, ai: null, cut: null };
      d.uploads.push(e);
      jobs.push(idBlob(u.aiBy && u.aiBy.pos).then(function (bl) { e.ai = bl; }));
      jobs.push(imgBlob(u.cut && u.cut.img).then(function (bl) { e.cut = bl; }));
    });
    var p = st.print;
    if (p && p.file) {
      d.print = { file: p.file, name: p.name, tf: tfCopy(p.tf), round: !!p.round, roundPos: p.roundPos, removeBg: !!p.removeBg, cut: null };
      jobs.push(canvasBlob(p.cutCanvas).then(function (bl) { d.print.cut = bl; }));
    }
    st.images.forEach(function (im) {
      if (!im.file) return;
      var e = { file: im.file, name: im.name, tf: tfCopy(im.tf), round: !!im.round, roundPos: im.roundPos, removeBg: !!im.removeBg, cut: null };
      d.images.push(e); jobs.push(canvasBlob(im.cutCanvas).then(function (bl) { e.cut = bl; }));
    });
    return Promise.all(jobs).then(function () { return d; });
  }
  function memSaveNow() {
    if (memRestoring || (st.brand < 0 && !LOMPAKKO) || !MEM_PID) return;
    var b = currentBrand(), m = currentModel();
    if (b && m) lsSet(MEM_G, { ts: Date.now(), brand: b.name, model: m.name });
    /* 2.10.2026: luonnosmuisti (IndexedDB, kuvat PNG:ksi joka muutoksella) POIS – hidasti mobiili-Safaria.
       Vain merkki + malli muistetaan. Palautus: lastu-live-2909/assets/lastu-konfiguraattori.js §8. */
  }
  /* 2.10.2026: enintään 2 s viive – jatkuvat piirrot (animaatiot, tekstin kirjoitus) siirsivät 0,7 s ajastinta loputtomiin → teksti ei tallentunut */
  var memFirst = 0;
  function scheduleSave() {
    if (!memFirst) memFirst = Date.now();
    clearTimeout(memTimer);
    memTimer = setTimeout(function () { memFirst = 0; memSaveNow(); }, Math.max(0, Math.min(700, 2000 - (Date.now() - memFirst))));
  }
  function memFlush() { if (memTimer) { clearTimeout(memTimer); memTimer = null; memFirst = 0; memSaveNow(); } }
  window.addEventListener('pagehide', memFlush);
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') memFlush(); });
  function memClearDraft() { return idbOp('readwrite', function (os) { return os.delete(MEM_PID); }); }

  function fire(el, type) { el.dispatchEvent(new Event(type, { bubbles: true })); }
  function memApplyBrandModel(brandName, modelName) {
    var bi = -1, mi = -1;
    D.brands.forEach(function (b, i) { if (b.name === brandName) bi = i; });
    if (bi < 0) return false;
    var r = $('input[data-brand-index="' + bi + '"]'); if (!r) return false;
    if (!r.checked) { r.checked = true; fire(r, 'change'); }
    if (modelName) {
      D.brands[bi].models.forEach(function (m, i) { if (m.name === modelName && m.available !== false) mi = i; });
      var sel = modelSelects[bi];
      if (sel && mi >= 0) {
        /* hasAttribute: placeholderilla ei ole data-indexiä → +null === 0 osui merkin 1. malliin (iPhone 18 Pro ei palautunut) */
        for (var i = 0; i < sel.options.length; i++) if (sel.options[i].hasAttribute('data-index') && +sel.options[i].getAttribute('data-index') === mi && !sel.options[i].disabled) { sel.selectedIndex = i; fire(sel, 'change'); break; }
      }
    }
    return true;
  }
  function memRestore(d) {
    memRestoring = true;
    var jobs = [];
    try {
      memApplyBrandModel(d.brand, d.model);
      if (d.material) { var mi = -1; D.materials.forEach(function (m, i) { if (m.name === d.material && m.available !== false) mi = i; }); var mr = mi >= 0 && $('input[data-material-index="' + mi + '"]'); if (mr && !mr.disabled) { mr.checked = true; fire(mr, 'change'); } }
      if (d.persona) { var pi = personaInputs.filter(function (i) { return i.getAttribute('data-persona') === d.persona; })[0]; if (pi && !pi.disabled) { pi.checked = true; fire(pi, 'change'); } }
      if (d.persona === 'engraving' && d.engraving) { var ei = -1; D.engravings.forEach(function (e, i) { if (e.name === d.engraving) ei = i; }); var er = ei >= 0 && $('input[data-engraving-index="' + ei + '"]'); if (er && !er.hasAttribute('data-soldout')) { er.checked = true; fire(er, 'change'); } }
      if (d.magsafe && magsafeInput && !magsafeInput.disabled) { magsafeInput.checked = true; fire(magsafeInput, 'change'); }
      (d.addons || []).forEach(function (name) { addonInputs.forEach(function (a) { var i = +a.getAttribute('data-addon-index'); if (D.addons[i].name === name && !a.hasAttribute('data-soldout')) { a.checked = true; fire(a, 'change'); } }); });
      if (d.leka && lekaInput && !lekaInput.disabled) { lekaInput.checked = true; fire(lekaInput, 'change'); lekaRadios.forEach(function (r) { if (+r.getAttribute('data-leka-count') === d.lekaCount) { r.checked = true; fire(r, 'change'); } }); }
      if (KARTTA() && d.kartta) { karttaRestore(d.kartta); }
      if (SANAT && d.words) { st.words.list = (d.words.list || []).slice(0, 15); st.words.font = d.words.font || 'poster'; st.words.seed = d.words.seed || 1; st.words.density = d.words.density == null ? 50 : d.words.density; renderWordInputs(); syncWordsUI(); wordsChanged(); }
      if (d.text && d.text.on && textInput) {
        var savedT = d.text.items && d.text.items.length ? d.text.items : [{ value: d.text.value || '', tf: d.text.tf || null }];   /* vanhat luonnokset: yksi teksti */
        st.text.items = savedT.slice(0, MAX_TEXTS).map(function (e) { return { value: e.value || '', tf: e.tf || null, keepS: !!e.tf, maskCanvas: null, isText: true }; });
        st.text.font = d.text.font === 'body' ? 'hand' : (d.text.font || ((MODE === 'puu' || MODE === 'kuksa') ? 'brush' : 'hand')); st.text.align = d.text.align || 'center';
        renderTextRows();
        textFontInputs.forEach(function (r) { r.checked = r.getAttribute('data-text-font') === st.text.font; });
        $$('[data-text-align]').forEach(function (o) { o.classList.toggle('is-active', o.getAttribute('data-text-align') === st.text.align); });
        textInput.checked = true; fire(textInput, 'change');
      }
      /* Vanhat luonnokset (ennen 23.9.2026) tallensivat yhden kuvan kenttään d.upload. */
      var savedUps = (d.uploads && d.uploads.length ? d.uploads : d.upload ? [d.upload] : []).filter(function (e) { return e && e.file; }).slice(0, MAX_UPLOADS);
      if (savedUps.length && fileLoaders.upload) {
        jobs.push(savedUps.reduce(function (chain, e) {
          return chain.then(function () {
            return Promise.all([blobImg(e.ai), blobImg(e.cut)]).then(function (r) {
              var opts = { tf: e.tf, mode: e.mode, detail: e.detail, dark: e.dark, round: e.round, roundPos: e.roundPos, removeBg: e.removeBg, aiBy: {}, cut: null };
              if (r[0]) opts.aiBy.pos = toImageData(r[0], 1000);
              if (r[1]) { var cid = toImageData(r[1], 1000); opts.cut = { img: r[1], imageData: cid, bg: backgroundMask(cid, 42).bg }; } else opts.removeBg = false;
              return fileLoaders.upload(new File([e.file], e.name || 'kuva.jpg', { type: e.file.type || 'image/jpeg' }), opts);
            });
          });
        }, Promise.resolve()));
      }
      if (d.print && d.print.file && fileLoaders.print) {
        jobs.push(blobCanvas(d.print.cut).then(function (cc) {
          return fileLoaders.print(new File([d.print.file], d.print.name || 'kuva.jpg', { type: d.print.file.type || 'image/jpeg' }), { tf: d.print.tf, round: d.print.round, roundPos: d.print.roundPos, removeBg: d.print.removeBg && !!cc, cutCanvas: cc });
        }));
      }
      if (KUWA && d.images && d.images.length) {
        jobs.push(Promise.all(d.images.map(function (e) { return blobCanvas(e.cut); })).then(function (cuts) {
          var files = d.images.map(function (e) { return new File([e.file], e.name || 'kuva.jpg', { type: e.file.type || 'image/jpeg' }); });
          var rs = d.images.map(function (e, i) { return { tf: e.tf, round: e.round, roundPos: e.roundPos, removeBg: e.removeBg, cutCanvas: cuts[i] }; });
          return addKuwaFiles(files, rs);
        }));
      }
    } catch (e) { log('restore', e); }
    return Promise.all(jobs).catch(function (e) { log('restore', e); }).then(function () { memRestoring = false; if (VELCRO) st.persona = 'velcro'; updatePrice(); render(); scheduleSave(); });
  }
  function memSummary(d) {
    var parts = [];
    if (d.model) parts.push(d.model); if (d.material) parts.push(d.material);
    if (d.persona === 'upload') parts.push(d.uploads && d.uploads.length > 1 ? S.sum_upload + ' ×' + d.uploads.length : S.sum_upload); if (d.persona === 'print') parts.push(S.sum_print);
    if (d.persona === 'engraving') parts.push(d.engraving ? S.sum_engraving + ': ' + d.engraving : S.sum_engraving);
    if (d.persona === 'velcro') parts.push(S.sum_velcro);
    if (d.words && d.words.list && d.words.list.length) parts.push(d.words.list.slice(0, 4).join(' · '));
    if (d.kartta && d.kartta.place) parts.push(d.kartta.place.split(',')[0]);
    if (d.images && d.images.length) parts.push(d.images.length + ' ' + S.kuwa_count);
    var tv = d.text && d.text.on ? ((d.text.items || []).filter(memValue)[0] || (memValue(d.text) ? d.text : null)) : null;
    if (tv) parts.push('”' + String(tv.value).split('\n')[0].slice(0, 20) + '”');
    if (d.magsafe) parts.push(S.sum_magsafe); (d.addons || []).forEach(function (a) { parts.push(a); });
    if (d.leka) parts.push(S.sum_leka);
    return parts.join(' · ');
  }
  function memAgo(ts) {
    var days = Math.floor((Date.now() - ts) / 864e5);
    return (S.resume_ago || '{when}').replace('{when}', days <= 0 ? S.ago_today : days === 1 ? S.ago_yesterday : (S.ago_days || '{n}').replace('{n}', days));
  }
  var resumeEl = $('#lastu-k-resume');
  function memShowResume(d, restored) {
    if (!resumeEl) return;
    $('[data-resume-title]', resumeEl).textContent = restored ? S.resume_restored : S.resume_title;
    $('[data-resume-summary]', resumeEl).textContent = memSummary(d);
    $('[data-resume-ago]', resumeEl).textContent = memAgo(d.ts);
    var go = $('[data-resume-go]', resumeEl), rs = $('[data-resume-reset]', resumeEl);
    go.textContent = S.resume_btn; rs.textContent = S.resume_reset;
    resumeEl.classList.toggle('is-restored', !!restored); resumeEl.hidden = false;
    go.disabled = false;
    go.onclick = function () { go.disabled = true; memPending = null; memRestore(d).then(function () { resumeEl.hidden = true; }); };
    /* Aloita alusta = kaikki pois: tämän tuotteen luonnos + muistettu merkki/malli, ja sivu ladataan puhtaana. */
    rs.onclick = function () {
      rs.disabled = go.disabled = true; memPending = null; clearTimeout(memTimer);
      try { localStorage.removeItem(MEM_G); sessionStorage.setItem('lastu-k-skip', '1'); } catch (e) {}
      memClearDraft().then(function () { location.reload(); });
    };
  }
  /* ───────── Mallikohtainen suora linkki (3.10.2026): ?malli=galaxy-s26 ─────────
     Mallikokoelmien tuotekortit ja mainokset avaavat konfiguraattorin valmiiksi oikealla mallilla.
     Kanoninen osoite pysyy tuotesivuna (Shopify ei ota parametria mukaan) → ei kaksoissisältöä.
     Slug = mallin nimi pienellä, + → plus, muut merkit viivoiksi. Yhdistetyt nimet hyväksyvät myös osat:
     "iPhone 16e / 17e" → iphone-16e-17e, iphone-16e, iphone-17e; "Pixel 10 & 10 Pro" → pixel-10-10-pro, pixel-10, pixel-10-pro. */
  function mSlug(t) { return String(t || '').toLowerCase().replace(/\+/g, ' plus ').replace(/[äå]/g, 'a').replace(/ö/g, 'o').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function memUrlModel() {
    var q = ''; try { var up = new URLSearchParams(location.search); q = mSlug(up.get('malli') || up.get('model')); } catch (e) {}
    if (!q || LOMPAKKO) return null;
    var hit = null;
    D.brands.forEach(function (b) {
      (b.models || []).forEach(function (m) {
        if (hit || m.available === false) return;
        var keys = [mSlug(m.name)], parts = m.name.split(/\s+[\/&]\s+/), pfx = parts[0].split(' ')[0];
        if (parts.length > 1) parts.forEach(function (p) { keys.push(mSlug(/^\d/.test(p) ? pfx + ' ' + p : p)); });
        if (keys.indexOf(q) >= 0) hit = { b: b.name, m: m.name };
      });
    });
    return hit;
  }
  /* ───────── Agentti-/mainoslinkki (6.10.2026): valinnat URL:ssa ─────────
     Tekoälyagentit (UCP) eivät voi välittää konfiguraattorin valintoja koriin → ne tuovat ostajan tähän osoitteeseen valmiiksi
     täytettynä, ja ostaja lisää oman kuvan/tekstin ja maksaa. Parametrit (kaikki valinnaisia, vain saatavilla olevat otetaan):
       malli | model      = mallin slug (ks. yllä), esim. iphone-17-pro
       materiaali | material = materiaalin slug, esim. koivu → hiilikoivu, terwa, ruska, kaamos, horsma, terwakelo, lumikoivu
       magsafe=1          = MagSafe päälle
       krip=1 | karb=1    = KRIP / KARB lisäosa (kytkee MagSafen päälle)
       leka=1|2|3         = LEKA-näytönsuojien määrä
     Ei koskaan ohita pakollisia valintoja eikä lisää koriin mitään: ostaja painaa itse "Lisää koriin". */
  function memUrlFlag(v) { return v === '1' || v === 'true' || v === 'yes' || v === 'kylla'; }
  function memApplyUrlOptions() {
    var sp; try { sp = new URLSearchParams(location.search); } catch (e) { return false; }
    var did = false, mq = mSlug(sp.get('materiaali') || sp.get('material'));
    if (mq) {
      var mi = -1;
      D.materials.forEach(function (m, i) { if (mi < 0 && m.available !== false && (mSlug(m.name) === mq || mSlug(m.orderName).indexOf(mq) === 0)) mi = i; });
      var mr = mi >= 0 && $('input[data-material-index="' + mi + '"]');
      if (mr && !mr.disabled) { mr.checked = true; fire(mr, 'change'); did = true; }
    }
    var wantKrip = memUrlFlag(sp.get('krip')), wantKarb = memUrlFlag(sp.get('karb'));
    if ((memUrlFlag(sp.get('magsafe')) || wantKrip || wantKarb) && magsafeInput && !magsafeInput.disabled) {
      magsafeInput.checked = true; fire(magsafeInput, 'change'); did = true;
      [['krip', wantKrip], ['karb', wantKarb]].forEach(function (t) {
        if (!t[1]) return;
        var hit = null;
        addonInputs.forEach(function (a) { if (!hit && !a.disabled && !a.hasAttribute('data-soldout') && D.addons[+a.getAttribute('data-addon-index')].type === t[0]) hit = a; });
        if (hit) { hit.checked = true; fire(hit, 'change'); }
      });
    }
    var ln = +sp.get('leka');
    if (ln >= 1 && ln <= 3 && lekaInput && !lekaInput.disabled) {
      lekaInput.checked = true; fire(lekaInput, 'change');
      lekaRadios.forEach(function (r) { if (+r.getAttribute('data-leka-count') === ln) { r.checked = true; fire(r, 'change'); } });
      did = true;
    }
    return did;
  }
  function memInit() {
    var um = memUrlModel();
    if (um) {
      memRestoring = true; memApplyBrandModel(um.b, um.m);
      if (currentModel()) { try { memApplyUrlOptions(); } catch (e) {} }
      memRestoring = false;
      if (currentModel()) { lsSet(MEM_G, { ts: Date.now(), brand: um.b, model: um.m }); try { sessionStorage.removeItem('lastu-k-skip'); } catch (e) {} return; }
    } else if (!LOMPAKKO) {
      memRestoring = true; try { memApplyUrlOptions(); } catch (e) {} memRestoring = false;   /* materiaali/MagSafe/LEKA ilman mallia */
    }
    if (!MEM_PID) return;
    var skip = false; try { skip = sessionStorage.getItem('lastu-k-skip') === '1'; sessionStorage.removeItem('lastu-k-skip'); } catch (e) {}
    var g = lsGet(MEM_G); if (g && Date.now() - g.ts > MEM_MS) { g = null; try { localStorage.removeItem(MEM_G); } catch (e) {} }
    /* 2.10.2026: vanhat luonnokset (kuvineen) pois laitteelta kerran; 'cache'-store (taustanpoistot) jää. */
    try { if (window.indexedDB && !localStorage.getItem('lastu-k-drafts-cleared')) { localStorage.setItem('lastu-k-drafts-cleared', '1'); idbOp('readwrite', function (os) { return os.clear(); }); } } catch (e) {}
    if (skip) return;
    /* Vain merkki + malli automaattisesti (ei luonnosta, kuvia tai lisäosia). */
    /* Ehto "malli puuttuu" eikä "merkki puuttuu": merkki voi olla esivalittu, jolloin malli jäi täyttämättä. */
    if (g && g.brand && !currentModel()) { memRestoring = true; memApplyBrandModel(g.brand, g.model); memRestoring = false; }
  }
  /* ───────── 9. Korin "Muokkaa tuotettasi" = oikea muokkaus (9.10.2026) ─────────
     - Koriin lisätessä koko design (memSerialize, kuvat/piirros/taustanpoisto mukana) IndexedDB:hen ('cache', avain
       edit:<ryhmä>) + kevyt JSON ilman kuvia päärivin propertyyn _lastu_design (varalla, esim. tyhjennetty selain).
     - Muokkauslinkki ?muokkaa=<ryhmä> (tai vanhoilla riveillä lastu-concept.js:n lipun rivi-avain) → design palautetaan,
       yläreunaan ilmoitus + "Lisää uutena", nappi "Päivitä ostoskori".
     - Lisäys onnistuu → vanha ryhmä (päärivi + lisäosarivit, _customily-upsell-(main-)id) pois YHDELLÄ /cart/update.js-
       kutsulla ennen drawerin päivitystä; vanha kappalemäärä siirtyy uudelle päärivelle. Lisäys epäonnistuu → vanha jää. */
  var edit = null, EDIT_MS = 30 * 864e5;
  var ET = lang === 'en'
    ? { title: 'Editing the product in your cart', sub: 'Your changes replace the version in your cart.', cancel: 'Add as new instead', atc: 'Update cart' }
    : { title: 'Muokkaat ostoskorissa olevaa tuotetta', sub: 'Muutokset korvaavat korissa olevan version.', cancel: 'Lisää uutena', atc: 'Päivitä ostoskori' };
  function editSave(gid) {
    if (!gid || !window.indexedDB) return;
    memSerialize().then(function (d) { return idbOp('readwrite', function (os) { return os.put({ ts: Date.now(), d: d }, 'edit:' + gid); }, 'cache'); })
      .then(function () {
        idb().then(function (db) {   /* yli 30 pv vanhat muokkauskopiot pois */
          var rq = db.transaction('cache', 'readwrite').objectStore('cache').openCursor();
          rq.onsuccess = function () { var c = rq.result; if (!c) return; if (String(c.key).indexOf('edit:') === 0 && Date.now() - ((c.value && c.value.ts) || 0) > EDIT_MS) c.delete(); c.continue(); };
        }).catch(function () {});
      }).catch(function () {});
  }
  function editReplace(res) {
    var e = edit; if (!e) return Promise.resolve();
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var upd = {}, n = 0;
      (cart.items || []).forEach(function (it) {
        var p = it.properties || {};
        if (it.key === e.key || (e.gid && (p['_customily-upsell-main-id'] === e.gid || p['_customily-upsell-id'] === e.gid))) { upd[it.key] = 0; n++; }
      });
      if (e.qty > 1 && res.mainLine) { upd[res.mainLine.key] = e.qty; res.mainLine.quantity = e.qty; }   /* esikatselulinkki (lastu-concept.js) käyttää line.quantity:ä */
      if (!n && !(e.qty > 1)) return;
      return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: upd }) });
    }).then(function () { editEnd(); }).catch(function (err) { log('muokkaus: vanhan poisto', err); editEnd(); });
  }
  /* Muokkauslinkin parametrit pois osoitteesta (uudelleenlataus ei palauta vanhoja valintoja). */
  function editStrip() {
    try {
      var u = new URL(location.href); if (!u.searchParams.has('muokkaa')) return;
      ['muokkaa', 'malli', 'model', 'materiaali', 'material', 'magsafe', 'krip', 'karb', 'leka'].forEach(function (k) { u.searchParams.delete(k); });
      history.replaceState(history.state, '', u.pathname + u.search + u.hash);
    } catch (e) {}
  }
  function editEnd() {
    edit = null; editStrip();
    if (resumeEl && resumeEl.classList.contains('is-editing')) { resumeEl.hidden = true; resumeEl.classList.remove('is-editing'); var go = $('[data-resume-go]', resumeEl); if (go) go.hidden = false; }
    atcNeedState();
  }
  function editBanner() {
    if (!resumeEl) return;
    $('[data-resume-title]', resumeEl).textContent = ET.title;
    $('[data-resume-summary]', resumeEl).textContent = ET.sub;
    $('[data-resume-ago]', resumeEl).textContent = '';
    var go = $('[data-resume-go]', resumeEl), rs = $('[data-resume-reset]', resumeEl);
    if (go) go.hidden = true;
    if (rs) { rs.hidden = false; rs.disabled = false; rs.textContent = ET.cancel; rs.onclick = editEnd; }
    resumeEl.classList.add('is-editing'); resumeEl.hidden = false;
  }
  function editInit() {
    var gid = '', flag = null;
    try { gid = new URLSearchParams(location.search).get('muokkaa') || ''; } catch (e) {}
    try { flag = JSON.parse(sessionStorage.getItem('lastuEditingLine') || 'null'); } catch (e) {}
    if (flag && Date.now() - (flag.ts || 0) > 30 * 60 * 1000) flag = null;
    if (!gid && !(flag && flag.key)) return;
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var mine = (cart.items || []).filter(function (it) { return String(it.product_id) === MEM_PID; });
      var line = gid ? mine.filter(function (it) { return (it.properties || {})['_customily-upsell-main-id'] === gid; })[0] : null;
      if (!line && flag && flag.key) line = mine.filter(function (it) { return it.key === flag.key; })[0];
      if (!line) { editStrip(); return; }
      try { sessionStorage.removeItem('lastuEditingLine'); } catch (e) {}   /* korvaus hoidetaan täällä, ei lastu-concept.js:n siivouksessa */
      var props = line.properties || {}, g = props['_customily-upsell-main-id'] || '';
      edit = { gid: g, key: line.key, qty: line.quantity || 1 };
      editBanner(); atcNeedState();
      return (g ? idbOp('readonly', function (os) { return os.get('edit:' + g); }, 'cache') : Promise.resolve(null)).then(function (rec) {
        var d = rec && rec.d;
        if (!d) { try { d = JSON.parse(props['_lastu_design'] || 'null'); } catch (e) { d = null; } }
        if (d) return memRestore(d);
      }).then(function () {
        atcNeedState();
        /* suoraan muokkaukseen: ilmoitus näkyviin headerin alle */
        if (resumeEl && !resumeEl.hidden) {
          /* mobiilissa kelluva esikatselu laajenee yläreunaan (~300 px) → ilmoitus sen alapuolelle */
          var off = isMobile() ? Math.round(Math.min(window.innerHeight * 0.42, 340)) : 96;
          window.scrollTo({ top: Math.max(0, resumeEl.getBoundingClientRect().top + window.pageYOffset - off), behavior: 'auto' });
        }
      });
    }).catch(function (e) { log('muokkaus', e); });
  }

  if (LOMPAKKO) { document.documentElement.classList.add('lastu-k-started'); placeStage(); syncDock(); render(); }
  if (VELCRO) st.persona = 'velcro';   /* piirtää Velcro-pinnan aina; rivit pysyvät piilossa (data-row-off) */
  memInit();
  editInit();
  setTimeout(function () { kAnimReady = true; }, 400);   /* käynnistyksen omat näytä/piilota-kutsut ilman animaatiota */
})();
